<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <!-- <v-toolbar-title class="white--text">{{toolbarTitle}}</v-toolbar-title> -->
		    <v-toolbar-title class="white--text" :class="{'two-line-title':Form.transactionTypeList && Form.transactionTypeList.length>1}">
		    	{{toolbarTitle}}
		    	<div class="toolbar-subtitle" @click="fn_openTransactionTypeList" v-if="Form.transactionTypeList && Form.transactionTypeList.length>1">
		    		<div class="subtitle-text dark-opacity-color" style="float:left">{{Form.transactionData.mergeTransactionNumber}} |&nbsp;</div>
		    		<div class="subtitle-text dark-opacity-color">{{Form.transactionTypeFormName ? Form.transactionTypeFormName : 'Select Transaction Form'}}</div>
		    		<v-icon class="subtitle-icon">arrow_drop_down</v-icon>
		    	</div>
		    </v-toolbar-title>

		    <!-- <v-spacer></v-spacer> -->

		    <!-- <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<div class="hasToolbar" v-if="loading">
			<v-progress-linear height="4" nomargin indeterminate color="primary"></v-progress-linear>	
		</div>

		<v-form class="form-element hasToolbar hasBigFooter grey-back" v-else>

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<div class="form_wrapper" v-if="!loading">

				<v-layout row wrap>
            	  <v-list full-width nopadding>
					  	<v-list-tile>
				          	<v-list-tile-content @click="fn_openDialogNumberSeries">
				              <v-list-tile-title class="merged_tnumber">{{Form.transactionData.mergeTransactionNumber}}</v-list-tile-title>
				            </v-list-tile-content>

				            <span>{{Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span>	

				            <v-list-tile-action class="action-small">
	            				<v-btn flat icon color="primary" @click="fn_openDatePicker('transactionDate', Form.transactionData.transactionDate)" class="no-left-margin">
	            					<v-icon>date_range</v-icon>	
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
            	</v-layout>

				<v-alert @click="fn_checkPendingItemsCount(1)" :value="true" color="info" transition="slide-y-transition" v-if="Form.pendingCount && settings.transactionTypeId != 20004">
					<div style="display: flex; justify-content: space-between;">
						<span v-if="Form.transactionData.transactionListId == 20002">
							{{Form.pendingCount + (Form.pendingCount > 1 ? " Purchase Orders are pending." : " Purchase Order is pending.")}}
						</span>

						<span v-if="Form.transactionData.transactionListId == 20003">
							{{Form.pendingCount + " " + fn_getPendingAlertMsg()}}
						</span>

						<span class="primary-color">Add</span>
					</div>
				</v-alert>

				<v-layout margin-top-ten row wrap white-background padding-top-ten id="supplierfield">

					<!-- <v-flex xs12 sm12 md12 form-item @click="fn_checkTransactionType" id="transactionTypeField">
		               <v-text-field 
		               		v-if="Form.transactionTypeList && Form.transactionTypeList.length>1" 
			               	readonly
			               	v-model="Form.transactionTypeFormName" 
			               	label="Transaction Form"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	v-validate="'required'" 
		               		data-vv-name="transactionType" 
		               		data-vv-as="transaction type" 
		               		:error-messages="errors.collect('transactionType')"
		               		required>
		               </v-text-field>
		            </v-flex> -->

		            <v-layout row wrap>
		            	<!-- <v-btn icon flat color="primary" @click="fn_getBottomMenu" v-if="settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004" style="float: right;margin-left: 16px;"><v-icon>more_vert</v-icon></v-btn> -->
		            	<!-- <v-btn icon flat color="primary" @click="fn_getBottomMenu" v-if="settings.transactionTypeId != 20001 && !Form.isPendingItems" style="position: absolute;right:0"><v-icon>more_vert</v-icon></v-btn> -->
						<v-btn icon flat color="primary" @click="fn_checkPendingItemsCount(2)" v-if="settings.transactionTypeId != 20001 && !Form.isPendingItems && toolbarTitle != 'Debit Note'" style="position: absolute;right:0">
							<v-icon>more_vert</v-icon>
						</v-btn>

		            	<!-- <v-flex xs12 sm12 md12 pl-3 :class="{'pr-3':settings.transactionTypeId != 20003 && settings.transactionTypeId != 20004}"> -->
		            	<v-flex xs12 sm12 md12 pl-3 :style="{'padding-right':settings.transactionTypeId == 20001 || Form.isPendingItems ? '16px' : '62px'}" @click="fn_openSuppliers">
		        		
			               <v-text-field  
				               	readonly
				               	:hide-details="Form.partyName ? true : false"
				               	v-model="Form.partyName" 
				               	:label="fn_partyLabel()"
				               	:onUpdate="fn_updateSupplier" 
				               	placeholder=" " 
				               	append-icon="arrow_drop_down"
				               	ref="ref_fieldSupplier"
				               	v-validate="'required'" 
			               		data-vv-name="supplier" 
			               		:error-messages="errors.collect('supplier')"
			               		required>
			               </v-text-field>
			            </v-flex>
			            
		            </v-layout>
		        	

		            <!-- <v-flex xs2 sm2 md2 @click="fn_getBottomMenu">
		               <v-btn icon flat color="primary"><v-icon>more_horiz</v-icon></v-btn>
		            </v-flex> -->

		            <v-flex right-align xs12 sm12 md12 pl-3 pr-3 pb-2 pt-1 font12 v-if="Form.partyName && Form.partyDetails">
		               <!-- <span light-opacity-color>Balance:</span> -->
					   <span light-opacity-color>{{ fn_balanceLabel(Form.partyDetails) }}</span>
					   <span :class="[Form.partyDetails.balance < 0 ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(Form.partyDetails.balance)}}</span>
		            </v-flex>

		            <!-- <v-flex xs12 sm12 md12 form-item>
		            	RCM Applicable
			           	<v-radio-group v-model="Form.isRcmApplicable" row>
					      <v-radio label="No" :value="0"></v-radio>
					      <v-radio label="Yes" :value="1"></v-radio>
					    </v-radio-group>
			        </v-flex> -->

		            <v-flex xs12 sm12 md12 form-item @click="fn_openStates" v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && Form.partyDetails">
		            <!-- <v-flex xs12 sm12 md12 form-item @click="fn_openStates"> -->
		               <v-text-field  
			               	readonly
			               	v-model="Form.placeOfSupplyName" 
			               	label="State/Place of Supply"
			               	:onUpdate="fn_updateState" 
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	ref="ref_fieldState">
		               </v-text-field>
		            </v-flex>

					<v-flex xs12 sm12 md12 form-item v-if="$root.TransactionSettings.enableBroker && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004) && toolbarTitle != 'Debit Note'" @click="fn_openAccountLedgers('android', 'AccountLedgers', 'ref_fieldBroker')">
		               <v-text-field  
			               	readonly
			               	v-model="Form.brokerName" 
			               	label="Broker"
							:onUpdate="fn_updateBroker" 
			               	ref="ref_fieldBroker"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
		               		required>
		               </v-text-field>
		            </v-flex>

					<v-flex xs12 sm12 md12 form-item @click="fn_openGodowns('android', 'Godowns', 'ref_fieldGodown')" v-if="$root.TransactionSettings.enableGodown && toolbarTitle != 'Debit Note'">
		               <v-text-field  
			               	readonly
			               	v-model="Form.godownName" 
			               	label="Select Godown"
							:onUpdate="fn_updateGodown" 
			               	ref="ref_fieldGodown"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
		               		required>
		               </v-text-field>
		            </v-flex>

		            <!-- <v-flex xs12 sm12 md12 form-item v-if="!Form.items.length && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004)">
			           	<v-radio-group v-model="Form.itemType" row>
					      <v-radio label="Goods" :value="0"></v-radio>
					      <v-radio label="Service" :value="1"></v-radio>
					    </v-radio-group>
			        </v-flex> -->
		        </v-layout>

		        <!-- <v-layout pt-3 row wrap white-background margin-top-ten v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && settings.transactionTypeId == 20003">
            	  	<v-flex xs12 sm12 md12 form-item>
		            	<v-checkbox :disabled="Form.taxMode==0" class="nomargin" v-model="Form.isRcmApplicable" label="RCM Applicable"></v-checkbox>
		            </v-flex>
            	</v-layout> -->

		        <v-layout row wrap white-background v-if="formType() == 'invoice' || formType() == 'return'">

		        	<div white-background full-width class="small-textbox-container">
						<v-layout row wrap class="layout-wrap">
						  <v-flex xs6 sm6 md6 pl-3 class="small-textbox-label">             
						     <div>Bill Number</div>
						  </v-flex>
						  <v-flex xs6 sm6 md6 pr-3 class="small-textbox">
						    <!-- <v-text-field 
						    	type="text"
						    	v-model="Form.transactionData.refNumber" 
						    	label="" 
						    	v-validate="'numeric'" 
			               		data-vv-name="billNumber"
			               		:error-messages="errors.collect('billNumber')">
						    </v-text-field> -->
						    <v-text-field 
						    	v-model="Form.transactionData.refNumber" 
						    	label="" >
						    </v-text-field>
						  </v-flex>
						</v-layout>
					</div>

		        	<v-list full-width nopadding>

					    <v-list-tile>
				          	<v-list-tile-content>
				          		<v-list-tile-title>Bill Date</v-list-tile-title>
				            </v-list-tile-content>
				            <span v-if="Form.transactionData.refDate">{{Form.transactionData.refDate | moment("DD-MMM-YYYY")}}</span>
				            <v-list-tile-action class="action-small">
				            	<v-btn flat icon color="primary" @click="fn_openDatePicker('refDate', Form.transactionData.refDate)" class="no-left-margin">
	            					<v-icon>date_range</v-icon>	
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>

		        </v-layout>

		        <v-layout margin-top-ten row wrap white-background full-width>

		        	<v-subheader full-width font16 medium-theme-color font-normal border-bottom-thin>
		        		Tax 
		        		<!-- <v-spacer></v-spacer> -->
		        		<!-- <v-checkbox v-if="$root.CurrentBusiness.GSTRegistrationStatus!=3 && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004)" right-align-checkbox hide-details :disabled="Form.taxMode==0" class="nomargin tile-checkbox-align-right" v-model="Form.isRcmApplicable" label="RCM Applicable"></v-checkbox> -->
		        		<!-- <v-checkbox right-align-checkbox hide-details :disabled="Form.taxMode==0" class="nomargin tile-checkbox-align-right" v-model="Form.isRcmApplicable" label="RCM Applicable"></v-checkbox> -->
		        	</v-subheader>
		        	<v-divider></v-divider>
		          	<v-flex xs12 sm12 md12 form-item>
		               	<v-radio-group class="pb-3" v-model="Form.taxMode" :hide-details="true" row @change="fn_calculateTax(true)">
					      <v-radio label="None" :value="0" ></v-radio>
					      <v-radio label="Exclusive" :value="1"></v-radio>
					      <v-radio label="Inclusive" :value="2"></v-radio>
					    </v-radio-group>
		            </v-flex>

		            <template v-if="Form.taxMode && $root.CurrentBusiness.GSTRegistrationStatus==1 && settings.transactionTypeId == 20003">
			            <v-flex xs6 sm6 md6 pl-3 pr-3>
			            	<v-checkbox label="RCM Applicable" v-model="Form.isRcmApplicable" @change="fn_calculateTax(false)"></v-checkbox>
			            </v-flex>
		            </template>
		            <!-- <v-flex xs12 sm12 md12 form-item v-if="$root.CurrentBusiness.GSTRegistrationStatus==1 && settings.transactionTypeId == 20003">
		            <v-flex xs12 sm12 md12 form-item>
		            	<v-checkbox :disabled="Form.taxMode==0" class="nomargin" v-model="Form.isRcmApplicable" label="RCM Applicable"></v-checkbox>
		            </v-flex> -->
		        </v-layout>

	        	<v-list margin-top-ten nopadding auto-height-tile>

					<div v-for="(groupItems, category) in filteredItems">

						<div v-for="(group, groupIndex) in groupItems" :key="groupIndex">

							<!-- <v-list full-width nopadding> -->
						  	<v-list-tile v-if="category=='self' || group.items && group.items.length" :class="{'norightpadding':category!='self'}">
					          	<v-list-tile-content>
					              <v-list-tile-title medium-theme-color>
					              	{{group.header}}&nbsp;
					              	<span v-if="group.baseTransactionNumber != Form.transactionData.mergeTransactionNumber">
										{{group.baseTransactionNumber}}	
									</span>
					              </v-list-tile-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
		            				<!-- <v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_addItem(true)" v-if="category=='self'">Add</v-btn> -->
									<v-btn small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="fn_addItem(true)" v-if="category=='self'">
		            					<v-icon class="mr-1" font16 color="primary">add</v-icon> Item
		            				</v-btn>

		            				<v-menu v-else>

								      <v-btn slot="activator" icon>
								      	<v-icon>more_vert</v-icon>
								      </v-btn>

								      <v-list nopadding>
								      	
								        <v-list-tile @click="fn_getPendingItems([group.baseTransactionId], 'invoices')" v-if="category=='invoice' && Form.isNew">
								          <v-list-tile-title>Edit</v-list-tile-title>
								        </v-list-tile>

								        <v-divider v-if="category=='invoice'"></v-divider>

								        <v-list-tile @click="fn_removeGroup(category, group.baseTransactionNumber)">
								          <v-list-tile-title>Remove</v-list-tile-title>
								        </v-list-tile>
								      </v-list>

								    </v-menu>
					            </v-list-tile-action>
						    </v-list-tile>
							<!-- </v-list> -->

							<!-- <v-subheader v-if="category=='self' || group.items && group.items.length" :class="{'norightpadding':category!='self'}">
								{{group.header}}&nbsp;
								<span v-if="group.baseTransactionNumber != Form.transactionData.mergeTransactionNumber">
									{{group.baseTransactionNumber}}	
								</span>
								<v-spacer></v-spacer>

								<v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_addItem(true)" v-if="category=='self'">Add</v-btn>

								<v-menu v-else>

							      <v-btn slot="activator" icon>
							      	<v-icon>more_vert</v-icon>
							      </v-btn>

							      <v-list nopadding>
							      	
							        <v-list-tile @click="fn_getPendingItems([group.baseTransactionId], 'invoices')" v-if="category=='invoice' && Form.isNew">
							          <v-list-tile-title>Edit</v-list-tile-title>
							        </v-list-tile>

							        <v-divider v-if="category=='invoice'"></v-divider>

							        <v-list-tile @click="fn_removeGroup(category, group.baseTransactionNumber)">
							          <v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
							      </v-list>

							    </v-menu>

							</v-subheader> -->

							<v-alert type="info" icon="info_outline" :value="true" v-if="$root.TransactionSettings.enableBatch && group.header == 'Purchase Order'">
								Consider adding batches into items
							</v-alert>

							<v-divider v-if="group.items && group.items.length && category=='self'"></v-divider>

							<!-- <div style="padding:12px 16px" v-if="!Form.items.length && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004)">
								<v-radio-group v-model="Form.itemType" row>
								      <v-radio class="mb-0" label="Goods" :value="0"></v-radio>
								      <v-radio class="mb-0" label="Service" :value="1"></v-radio>
								</v-radio-group>
							</div> -->


							<div v-for="(item, index) in group.items" :key="index">

								<v-list-tile class="right-subtitle-tile custom-action-tile">
								    <v-list-tile-content @click="fn_editItem(item, category, groupIndex, group.baseTransactionNumber)">
								      <v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
								      <!-- <v-list-tile-sub-title class="mb-1"><span class="right_subtitle">&#8377; {{$root.numberToLocale(item.netAmount)}}</span> </v-list-tile-sub-title> -->

								      <v-list-tile-sub-title class="mb-1" v-for="(variant, vIndex) in item.productVariants" :key="vIndex" v-if="variant.qty">
								      	<!-- {{variant.qty}} {{variant.unitName}} X {{$root.numberToLocale(item.rate)}} -->
										  <span v-if="variant.selectedUnit">{{variant.qty}} {{variant.selectedUnit.itemName}} X {{item.rate}}</span>
										  <span v-else>{{variant.qty}} {{variant.unitName}} X {{item.rate}}</span>
								      	<!-- <span v-if="variant.packQuantity">({{variant.packQuantity}})</span> X {{item.rate}} -->
								      </v-list-tile-sub-title>

								      <v-list-tile-sub-title class="mb-1" v-if="$root.TransactionSettings.mrpWiseStock">MRP: {{$root.numberToLocale(item.mrp)}}</v-list-tile-sub-title>

								      <v-list-tile-sub-title class="mb-1" v-for="(addOns, addOnsIndex) in item.addOnsItems" :key="addOnsIndex" v-if="addOns.value && !addOns.isGst">
								      	{{addOns.name}}
								      	<span v-if="addOns.percentage"> @{{addOns.percentage}}%</span>: {{addOns.nature ? '-' : ''}}{{$root.numberToLocale(addOns.value)}}
								      </v-list-tile-sub-title>

								      <v-list-tile-sub-title class="mb-1" v-if="Form.taxMode && item.taxValue!=null">
								      	GST @{{item.taxValue}}%: {{$root.numberToLocale(item.taxAmount)}} {{Form.isRcmApplicable ? ' (RCM)' : ''}}
								      </v-list-tile-sub-title>

								      <v-list-tile-sub-title class="mb-1" v-if="Form.taxMode && item.cessAmount">
								      	CESS<span v-if="item.cessValue!=null"> @{{item.cessValue}}%</span>: {{$root.numberToLocale(item.cessAmount)}} {{Form.isRcmApplicable ? ' (RCM)' : ''}}
								      </v-list-tile-sub-title>

									  <v-list-tile-sub-title class="mb-1" v-if="Form.taxMode && item.cessValueOnQuantity">
								      	CESS (Per Qty: {{$root.numberToLocale(item.cessValueOnQuantity)}} X {{item.productVariants[0].qty}}):<span v-if="item.cessValueOnQuantity!=null"> {{$root.numberToLocale(item.cessValueOnQuantity * item.productVariants[0].qty)}}</span>
								      </v-list-tile-sub-title>

								      <v-list-tile-sub-title class="mb-1" v-if="item.description">
								      	{{item.description}}
								      </v-list-tile-sub-title>

								    </v-list-tile-content>

								    <v-list-tile-action>

								    	<div>&#8377; {{$root.numberToLocale(item.netAmount)}}</div>
								    	<!-- <div v-if="Form.isRcmApplicable">
								    		&#8377; {{$root.numberToLocale(item.netAmount - item.taxAmount - item.cessAmount)}}
								    	</div>
								    	<div v-else>&#8377; {{$root.numberToLocale(item.netAmount)}}</div> -->

								    	<v-btn class="remove_btn" :class="{'mb-1':item.batches && item.batches.length}" icon @click="fn_removeItem(item.groupId, category, groupIndex, group.baseTransactionNumber)">
									      	<v-icon class="redcolor">remove_circle_outline</v-icon>
									    </v-btn>
							               <!-- <v-menu>

										      <v-btn slot="activator" icon>
										      	<v-icon>more_vert</v-icon>
										      </v-btn>

										      <v-list nopadding>
										        <v-list-tile @click="fn_removeItem(item.groupId, category, groupIndex, group.baseTransactionNumber)">
										          <v-list-tile-title>Remove</v-list-tile-title>
										        </v-list-tile>
										      </v-list>

										    </v-menu> -->
							        </v-list-tile-action>
								</v-list-tile>

								<div class="grey-back full-width batch_display_container" :class="{'pb-1':group.items.length - 1 != index}" v-if="item.batches && item.batches.length">

									<v-expansion-panel nomargin>

										<v-expansion-panel-content>

											<div slot="header" light-opacity-color font16 class="pt-0 pb-0">{{ item.selectedBatchType == 2 ? 'Series#' : 'Batches#' }}</div>
											<v-card flat v-for="(batch, batchIndex) in item.batches" :key="batchIndex">
												<!-- <v-card-text class="pb-2">
													<v-layout row wrap>
														<v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="field.id != 'opening' && fn_fieldVisibilty(field, item.selectedBatchType)">
															<div light-opacity-color>{{ field.title }}</div>
															<div v-if="field.type == 'date'">{{ batch[field.id] | moment('DD-MMM-YYYY') }}</div>
															<div v-else>{{ batch[field.id] }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.productVariants[0].qty)">
															<div light-opacity-color>Quantity</div>
															<div>{{ batch.productQty }}</div>
														</v-flex>
													</v-layout>
												</v-card-text> -->
												<v-card-text class="pb-2 pt-2">
													<v-layout class="batch_layout" row wrap>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
															<div light-opacity-color>Batch No.</div>
															<div>{{ batch.batchNumber }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
															<div light-opacity-color>Size</div>
															<div>{{ batch.batchSize }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
															<div light-opacity-color>MRP</div>
															<div>{{ batch.batchMRP }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
															<div light-opacity-color>Mfg. Date</div>
															<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
															<div light-opacity-color>Exp. Date</div>
															<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
														</v-flex>
														<!-- <v-flex xs4 sm4 md4 mb-2>
															<div light-opacity-color>Opening</div>
															<div>{{ batch.opening ? batch.opening : 0  }}</div>
														</v-flex> -->
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
															<div light-opacity-color>Purchase Rate</div>
															<div>{{ batch.purchaseRate }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
															<div light-opacity-color>Serial Number</div>
															<div>{{ batch.field1 }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
															<div light-opacity-color>IMEI Number</div>
															<div>{{ batch.field2 }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
															<div light-opacity-color>Part Number</div>
															<div>{{ batch.field3 }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
															<div light-opacity-color>Model Number</div>
															<div>{{ batch.field4 }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.productVariants[0].qty)">
															<div light-opacity-color>Quantity</div>
															<div>{{ batch.productQty }}</div>
														</v-flex>

														<v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && fn_checkDate(batch)">
															<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ fn_getDate(batch) }}
														</v-flex>
													</v-layout>
												</v-card-text>
												<v-divider v-if="item.batches.length - 1 != batchIndex"></v-divider>
											</v-card>
										</v-expansion-panel-content>

									</v-expansion-panel>

								</div>

								<v-divider v-if="group.items.length-1 != index && (!item.batches || !item.batches.length)"></v-divider>
							</div>

						</div>

					</div>
				</v-list>

				<v-divider v-if="Form.items.length"></v-divider>

				<v-list class="oneline-tile-dense" nopadding>
					<!-- <v-list-tile v-if="Form.itemsSummary.itemsQuanity.length">
					  <v-list-tile-content>
					    <v-list-tile-title>Total Qty</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>
					  	<span v-for="(item, index) in Form.itemsSummary.itemsQuanity" v-if="item.qty" :key="index">
					  		{{totalQty}} Units
	               		</span>
					  </v-list-tile-action>
					</v-list-tile> -->

					<!-- <div v-if="Form.itemsSummary.itemsQuanity.length">
						<v-subheader>
							<v-layout row wrap>
							  <v-flex xs3 sm3 md3>
								Total Qty  
							  </v-flex>

							  <v-flex xs9 sm9 md9 right-align overflowed-text>
								<span v-for="(item, index) in Form.itemsSummary.itemsQuanity" v-if="item.qty" :key="index">
			               			{{item.unitName}}<span v-if="item.packQuantity != 0 && item.packQuantity != null">({{item.packQuantity}})</span>: 
			               			{{item.qty}}{{Form.itemsSummary.itemsQuanity.length-1 != index ? ',&nbsp;' : ''}}
			               		</span>
							  </v-flex>
							</v-layout>
							
						</v-subheader>

						<v-divider></v-divider>
					</div> -->

					<!-- <v-divider v-if="Form.itemsSummary.itemsQuanity.length"></v-divider> -->

					<v-list-tile v-if="Form.items.length && fn_getTotalQty()">
					  <v-list-tile-content>
					    <v-list-tile-title>Total Qty</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>{{fn_getTotalQty()}}</v-list-tile-action>
					</v-list-tile>

					<v-list-tile v-if="Form.items.length">
					  <v-list-tile-content>
					    <!-- <v-list-tile-title>Gross Amount</v-list-tile-title> -->
					    <v-list-tile-title>Items Total</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>{{$root.numberToLocale(Form.itemsSummary.grossAmount)}}</v-list-tile-action>
					</v-list-tile>

					<v-list-tile v-for="(item, index) in Form.itemsSummary.addOnsItems" :key="index" v-if="item.value" @click="fn_addDiscountToAll(item)">
					  <v-list-tile-content>
					    <!-- <v-list-tile-title>{{item.nature ? 'Items Discount' : item.name}}</v-list-tile-title> -->
						<v-list-tile-title>{{item.name}} <span v-if="item.nature && item.percentage && fn_isAddonCommon(item.addOnsId)">@{{item.percentage}}%</span></v-list-tile-title> 
						<!-- <v-list-tile-title>{{item.name}} <span v-if="item.nature">{{fn_getDiscountPercentage(item)}}</span></v-list-tile-title> -->
					  </v-list-tile-content>
					  <v-list-tile-action>{{item.nature ? '-' : ''}}{{$root.numberToLocale(item.value)}}</v-list-tile-action>
					</v-list-tile>

					<div v-if="Form.taxMode && Form.items.length">
						<!-- When dealing within state -->
						<div v-if="Form.gstType=='IntraState'">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>CGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>
 	
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>SGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- When dealing with other state -->
						<div v-if="Form.gstType=='InterState'">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>IGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- When dealing from union territory to other state -->
						<div v-if="Form.gstType=='UnionTerritory'">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>CGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>

							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>UTGST{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.taxValue/2))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- When Cess is applicable -->
						<div v-if="Form.itemsSummary.cessValue">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>CESS{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.cessValue))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<div v-if="Form.itemsSummary.cessValueOnQuantity">
							<v-list-tile>
							  <v-list-tile-content>
							    <v-list-tile-title>CESS on Qty</v-list-tile-title>
							  </v-list-tile-content>
							  <v-list-tile-action>{{$root.numberToLocale(roundUpto2Decimals(Form.itemsSummary.cessValueOnQuantity))}}</v-list-tile-action>
							</v-list-tile>
						</div>

						<!-- <v-divider></v-divider>

						<v-list-tile>
						  <v-list-tile-content>
						    <v-list-tile-title>Net Amount</v-list-tile-title>
						  </v-list-tile-content>
						  <v-list-tile-action>&#8377; {{$root.numberToLocale(netAmount)}}</v-list-tile-action>
						</v-list-tile> -->
					</div>


					<!-- <v-list-tile v-if="!Form.items.length && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004)">
					  <v-list-tile-content>
					    <v-list-tile-title>Net Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action style="width:40%">
					 	<v-text-field right-align name="name" prefix="₹" type="number" v-model.number="Form.netInvoiceValue"></v-text-field>
					  </v-list-tile-action>
					</v-list-tile> -->

				</v-list>

				<!-- <v-divider v-if="Form.items.length"></v-divider> -->
				<v-list nopadding :class="{'margin-top-ten':!Form.items.length && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004)}">

				  	<!-- <v-list-tile v-if="Form.items.length">
					  	<v-list-tile-content>
					    	<v-list-tile-title>Net Amount</v-list-tile-title>
					  	</v-list-tile-content>
					  	<v-list-tile-action>&#8377; {{$root.numberToLocale(netAmount)}}</v-list-tile-action>
					</v-list-tile> -->

					<template v-if="!Form.items.length && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004) && toolbarTitle != 'Debit Note'">
						<!-- <div style="padding:12px 16px">
							<v-radio-group v-model="Form.itemType" row>
							      <v-radio class="mb-0" label="Goods" :value="0"></v-radio>
							      <v-radio class="mb-0" label="Service" :value="1"></v-radio>
							</v-radio-group>
						</div> -->

						<v-list-tile big-height-tile>
						  	<v-list-tile-content>
						    	<v-list-tile-title>Net Amount</v-list-tile-title>
						  	</v-list-tile-content>
						  	<v-list-tile-action style="width:40%">
								<v-text-field right-align name="name" prefix="₹" type="number" @input="$root.fn_boundDecimalLengthUpto2(Form, 'netInvoiceValue')" v-model.number="Form.netInvoiceValue"></v-text-field>
						 		<!-- <v-text-field right-align name="name" prefix="₹" type="number" v-model.number="Form.netInvoiceValue"></v-text-field> -->
						  	</v-list-tile-action>
						</v-list-tile>

						<v-list-tile v-if="roundedAmount">
							<v-list-tile-action style="margin-right:-16px">
								<v-checkbox v-model="Form.itemType" style="width: 32px;float:left"></v-checkbox>
							</v-list-tile-action>
						  	<v-list-tile-content>
						    	<v-list-tile-title>Service Bill</v-list-tile-title>
						  	</v-list-tile-content>
						</v-list-tile>
					</template>

				</v-list>

				<v-layout class="descrition-field" pt-3 pb-2 row wrap white-background v-if="!Form.items.length && roundedAmount && (settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004)">
					<!-- <v-flex mb-1 font12 light-theme-color xs12 sm12 md12 form-item>Description</v-flex> -->
					<v-flex xs12 sm12 md12 form-item>
						<v-textarea
							v-validate="'max:255'"
							data-vv-name="description" 
							:error-messages="errors.collect('description')"
							v-model="Form.description"
							label="Description"
							placeholder=" "
							rows="2"
							:counter="255">
						</v-textarea>
					</v-flex>
				</v-layout>

				<v-layout row wrap pa-3 white-background v-if="roundedAmount || Form.items.length">
				  <v-flex center-align xs4 sm4 md4 pr-1>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(3, true)"><v-icon font18 style="margin-right:5px">add</v-icon>Charges</v-btn>
				  </v-flex>
				  <v-flex center-align xs4 sm4 md4 pr-1 pl-1>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(1, true)"><v-icon font18 style="margin-right:5px">add</v-icon> Discount</v-btn>
				  </v-flex>
				  <v-flex center-align xs4 sm4 md4 pl-1 v-if="!Form.items.length">
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openAddOns(2, true)"><v-icon font18 style="margin-right:5px">add</v-icon> Tax</v-btn>
				  </v-flex>
				  <v-flex center-align xs4 sm4 md4></v-flex>
				  <v-flex center-align xs4 sm4 md4></v-flex>
				  <v-flex center-align xs4 sm4 md4 pl-1 mt-2>
				    	<v-btn full-width outline light-opacity-color nopadding capitalize nomargin style="border-radius:5px;" flat @click="fn_openTdsForm"><v-icon font18 style="margin-right:5px">add</v-icon> TDS</v-btn>
				  </v-flex>
				</v-layout>

				<!-- <div margin-top-ten white-background class="small-textbox-container">
					<v-list nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Other Charges</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click="fn_openAddOns(3, true)" class="no-left-margin">Add</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
					<v-divider v-if="Form.transactionAddOns.length"></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index" v-if="item.addOnsType==3">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div>

				<div margin-top-ten white-background class="small-textbox-container">
					<v-list nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Discounts</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click="fn_openAddOns(1, true)" class="no-left-margin">Add</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
					<v-divider v-if="Form.transactionAddOns.length"></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index" v-if="item.addOnsType==1">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div>

				<div margin-top-ten white-background class="small-textbox-container">
					<v-list nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Taxes{{Form.isRcmApplicable ? ' (RCM)' : ''}}</v-list-tile-title>
				            </v-list-tile-content>
				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" class="no-left-margin" @click="fn_openAddOns(2, true)">Add</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>
					<v-divider v-if="Form.transactionAddOns.length"></v-divider>
					<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in Form.transactionAddOns" :key="index" v-if="item.addOnsType==2">
					  <v-flex xs8 sm8 md8 class="small-textbox-label">
					  	<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
					    <div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
					  </v-flex>
					  <v-flex xs4 sm4 md4 pr-3 class="small-textbox">
					    <v-text-field 
					    	v-model.number="item.value" 
					    	@input="item.percentage = null"  
					    	type="number" label="" 
					    	:prefix="item.nature ? '(-)' : ''"
					    	v-validate="'min_value:0|decimal:2'" 
		               		:data-vv-name="'value'+index" 
		               		:data-vv-as="item.name"
		               		:error-messages="errors.collect('value'+index)">
					    </v-text-field>
					  </v-flex>
					</v-layout>
				</div> -->
				<div full-width>
					<div white-background class="small-textbox-container" v-if="otherChargeItems && otherChargeItems.length">

						<v-layout row wrap margin-top-ten class="layout-wrap" v-for="(item, index) in otherChargeItems" :key="index">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							<div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								v-model.number="item.value" 
								@input="item.percentage = null"  
								type="number" label="" 
								:prefix="item.nature ? '-' : ''"
								v-validate="'min_value:0|decimal:2'" 
								:data-vv-name="'value'+index" 
								:data-vv-as="item.name"
								:error-messages="errors.collect('value'+index)">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>

					<div white-background class="small-textbox-container" v-if="discountItems && discountItems.length">
						<v-layout row wrap class="layout-wrap" v-for="(item, index) in discountItems" :key="index">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							<div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								v-model.number="item.value" 
								@input="item.percentage = null"  
								type="number" label="" 
								:prefix="item.nature ? '-' : ''"
								v-validate="'min_value:0|decimal:2'" 
								:data-vv-name="'value'+index" 
								:data-vv-as="item.name"
								:error-messages="errors.collect('value'+index)">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>

					<div white-background class="small-textbox-container" v-if="taxItems && taxItems.length">
						<v-layout row wrap class="layout-wrap" v-for="(item, index) in taxItems" :key="index">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							<div @click="fn_editAddOns(item)">{{item.name}} {{item.percentage!==null && item.percentage!=='' ? '@'+item.percentage+'%' : ''}} {{Form.isRcmApplicable ? ' (RCM)' : ''}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								v-model.number="item.value" 
								@input="item.percentage = null"  
								type="number" label="" 
								:prefix="item.nature ? '-' : ''"
								v-validate="'min_value:0|decimal:2'" 
								:data-vv-name="'value'+index" 
								:data-vv-as="item.name"
								:error-messages="errors.collect('value'+index)">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>

					<div white-background class="small-textbox-container" v-if="Form.tdsDetails.amount">
						<v-layout row wrap class="layout-wrap">
						<v-flex xs8 sm8 md8 class="small-textbox-label">
							<v-btn icon @click="fn_removeTds"><v-icon>close</v-icon></v-btn>
							<div @click="fn_openTdsForm">{{Form.tdsDetails.tdsAccountName}}</div>
						</v-flex>
						<v-flex xs4 sm4 md4 pr-3 class="small-textbox">
							<v-text-field 
								@click="fn_openTdsForm"
								readonly
								:value="Form.tdsDetails.amount"
								type="number" 
								label="" 
								prefix="-">
							</v-text-field>
						</v-flex>
						</v-layout>
					</div>
				</div>
				

				<!-- <v-list full-width nopadding margin-top-ten v-if="roundedAmount">

					<v-list-tile>
				  		<v-list-tile-action v-if="Form.tdsDetails.amount">
			            	<v-btn icon @click="fn_removeTds"><v-icon>close</v-icon></v-btn>
			            </v-list-tile-action>
			          	<v-list-tile-content @click="fn_openTdsForm">
			              	<v-list-tile-title medium-theme-color>TDS</v-list-tile-title>
			            </v-list-tile-content>
			            <v-list-tile-action>
            				<v-icon>keyboard_arrow_right</v-icon>
			            </v-list-tile-action>
				    </v-list-tile>

				    <v-divider></v-divider>
				    
				  	<v-list-tile v-if="Form.tdsDetails.amount">
					  <v-list-tile-content>
					    <v-list-tile-title>{{Form.tdsDetails.tdsAccountName}}</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action>(-){{$root.numberToLocale(Form.tdsDetails.amount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list> -->


				<!-- <v-list nopadding margin-top-ten>
					<v-list-tile>
						<v-list-tile-action style="margin-right:-16px">
							<v-checkbox v-model="Form.isRounded" style="width: 32px;float:left"></v-checkbox>
						</v-list-tile-action>
					  <v-list-tile-content>
					    <v-list-tile-title>Round Off</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action :class="[Form.isRounded && netAmount ? 'text-underline' : 'light-opacity-color']" @click="fn_openDialogRoundOff">&#8377; {{roundOff}}</v-list-tile-action>
					</v-list-tile>
				</v-list>

				<v-list nopadding margin-top-ten>
					<v-list-tile>
					  <v-list-tile-content>
					    <v-list-tile-title>Total Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action style="align-items: flex-start;padding-top: 8px;}">&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list> -->

				<v-list nopadding v-if="roundedAmount || Form.items.length">
					<v-list-tile>
						<v-list-tile-action style="margin-right:-16px">
							<v-checkbox v-model="Form.isRounded" style="width: 32px;float:left"></v-checkbox>
						</v-list-tile-action>
					  	<v-list-tile-content>
					    	<v-list-tile-title>Round Off</v-list-tile-title>
					  	</v-list-tile-content>
					  	<!-- <v-list-tile-action :class="[Form.isRounded && netAmount ? 'text-underline' : 'light-opacity-color']" @click="fn_openDialogRoundOff" v-if="Form.isRounded">&#8377; {{roundOff}}</v-list-tile-action> -->
					  	<v-list-tile-action style="width:33.33%" @click="fn_openDialogRoundOff" v-if="Form.isRounded">
					  		<v-text-field 
					  			align-input-text-right
								:value="roundOff"
								readonly
								type="number" 
								label="" 
								prefix="₹">
							</v-text-field>
					  	</v-list-tile-action>
					</v-list-tile>
					<v-divider></v-divider>
					<v-list-tile font-medium>
					  <v-list-tile-content>
					    <v-list-tile-title>Total Amount</v-list-tile-title>
					  </v-list-tile-content>
					  <v-list-tile-action style="align-items: center;}">&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
					</v-list-tile>
				</v-list>

				<v-layout wrap margin-top-ten white-background :class="{'margin-bottom-five':Form.transactionData.notes}" v-if="roundedAmount || Form.items.length">
					<v-list full-width nopadding>
					  	<v-list-tile>

					  		<v-list-tile-action v-if="Form.transactionData.notes">
				            	<v-btn icon @click="Form.transactionData.notes = ''">
						  			<v-icon>close</v-icon>
						  		</v-btn>
				            </v-list-tile-action>

				          	<v-list-tile-content full-width @click="fn_addNote">
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
							  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
				            </v-list-tile-content>

					    </v-list-tile>
					</v-list>

					<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
						<v-divider></v-divider>
					  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</v-layout>

				<!-- <v-layout row wrap margin-top-ten white-background v-if="Form.customFields.length">

					<v-expansion-panel nomargin v-model="expandCustomFields">

					    <v-expansion-panel-content v-for="(item, index) in Form.customFields" :key="index" :id="'section_'+item.section.sectionId">

					    	<v-divider></v-divider>

					    	<v-subheader nopadding>

					    		<v-layout row wrap>
					    			<v-flex xs6 sm6 md6 center-align right-border>
					    		  		<v-btn flat small color="primary" nomargin @click="fn_bindDynamicFields(item.section.sectionId)">edit</v-btn>
					    			</v-flex>
					    			<v-flex xs6 sm6 md6 center-align>
					    		  		<v-btn flat small color="primary" nomargin @click="fn_removeFields(index, item.section.sectionId)">remove</v-btn>
					    			</v-flex>
					    		</v-layout>

							</v-subheader>

					      <div slot="header" font16>{{item.section.sectionName}}</div>

					      <v-divider></v-divider>

					      <v-card v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.value">
					        <v-card-text>
					        	<div><b>{{fieldItem.displayName}}</b></div>
					        	<div v-if="fieldItem.fieldType=='yes/no'">{{fieldItem.value ? 'Yes' : 'No'}}</div>

					        	<div v-else-if="fieldItem.fieldType=='dateTime'">
					        		<span v-if="fieldItem.value">{{fieldItem.value | moment("DD-MMM-YYYY")}}</span>
					        		<span v-else>-</span>
					        	</div>

					  			<div v-else v-html="fieldItem.value ? fieldItem.value : '-'" white-space-pre-line></div>
					        </v-card-text>
					      </v-card>

					    </v-expansion-panel-content>

					  </v-expansion-panel>

				</v-layout>	

				<v-list nopadding :class="{'margin-top-ten': !Form.customFields.length}">
					<div v-for="(item, index) in Form.dynamicMenuItems" :key="index" v-if="!item.hideOption">
						<v-list-tile>
						  	<v-list-tile-content>
						    	<v-list-tile-title>{{item.Text}}</v-list-tile-title>
						  	</v-list-tile-content>
						  	<v-list-tile-action>
						  		<v-btn color="primary" flat icon @click="fn_bindDynamicFields(item.sectionId)" class="no-left-margin">
						  			Add
						  		</v-btn>
						  	</v-list-tile-action>
						</v-list-tile>

						<v-divider v-if="Form.dynamicMenuItems.length-1 != index"></v-divider>
					</div>	

					<v-divider v-if="roundedAmount>=50000 && !Form.hideEwayOption"></v-divider>

					<v-list-tile v-if="roundedAmount>=50000 && !Form.hideEwayOption">
					  	<v-list-tile-content>
					    	<v-list-tile-title data-no-translate>E-Way Bill Details</v-list-tile-title>
					  	</v-list-tile-content>
					  	<v-list-tile-action>
					  		<v-btn color="primary" flat icon @click="fn_bindDynamicFields(ewayBillDetailSection.sectionId)" class="no-left-margin">
					  			Add
					  		</v-btn>
					  	</v-list-tile-action>
					</v-list-tile>
				</v-list> -->

				<v-layout full-width row wrap id="custom_field_panel" v-if="roundedAmount || Form.items.length">
					
					<div full-width v-for="(dItem, dIndex) in Form.dynamicMenuItems" :key="dIndex">
						<v-list nopadding white-background>
							<v-list-tile @click="fn_bindDynamicFields(dItem.sectionId)" v-if="!dItem.hideOption">
							  	<v-list-tile-content>
							    	<v-list-tile-title>{{dItem.Text}}</v-list-tile-title>
							  	</v-list-tile-content>
							  	<v-list-tile-action>
							  		<v-icon>keyboard_arrow_right</v-icon>
							  	</v-list-tile-action>
							</v-list-tile>
						</v-list>

						<div class="pb-3" white-background full-width v-for="(item, index) in Form.customFields" :key="index" v-if="dItem.sectionId == item.section.sectionId" :class="{'margin-top-bottom-five':dItem.sectionId == item.section.sectionId}" data-no-translate>
							<v-list nopadding :id="'section_'+item.section.sectionId">
								<v-list-tile>
									<v-list-tile-action>
								  		<v-btn icon @click="fn_removeFields(index, item.section.sectionId)">
								  			<v-icon>close</v-icon>
								  		</v-btn>
								  	</v-list-tile-action>

								  	<v-list-tile-content full-width @click="fn_bindDynamicFields(item.section.sectionId)">
								    	<v-list-tile-title>{{item.section.sectionName}}</v-list-tile-title>
										<v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
								  	</v-list-tile-content>
								</v-list-tile>
							</v-list>

							<v-divider></v-divider>

						      <v-card flat v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.value">
						        <v-card-text class="pb-0">
						        	<div font12 light-theme-color>{{fieldItem.displayName}}</div>
						        	<div font16 v-if="fieldItem.fieldType=='yes/no'">{{fieldItem.value ? 'Yes' : 'No'}}</div>

						        	<div font16 v-else-if="fieldItem.fieldType=='dateTime'">
						        		<span v-if="fieldItem.value">{{fieldItem.value | moment("DD-MMM-YYYY")}}</span>
						        		<span v-else>-</span>
						        	</div>

						  			<div font16 v-else v-html="fieldItem.value ? fieldItem.value : '-'" white-space-pre-line></div>
						        </v-card-text>
						      </v-card>
						</div>
					</div>

					<v-list full-width nopadding v-if="(roundedAmount>=50000 || $root.TransactionSettings.eWayBillConfigValue === 1) && !Form.hideEwayOption && $root.CurrentBusiness.GSTRegistrationStatus == 1">
						<v-list-tile @click="fn_bindDynamicFields(ewayBillDetailSection.sectionId)">
						  	<v-list-tile-content>
						    	<v-list-tile-title>E-Way Bill Details</v-list-tile-title>
						  	</v-list-tile-content>
						  	<v-list-tile-action>
						  		<v-icon>keyboard_arrow_right</v-icon>
						  	</v-list-tile-action>
						</v-list-tile>
					</v-list>

					<div class="pb-3" white-background full-width margin-top-bottom-five v-for="(item, index) in Form.customFields" :key="index" margin-top-ten v-if="ewayBillDetailSection.sectionId == item.section.sectionId" data-no-translate>
						<v-list nopadding :id="'section_'+item.section.sectionId">
							<v-list-tile>
								<v-list-tile-action>
							  		<v-btn icon @click="fn_removeFields(index, item.section.sectionId)">
							  			<v-icon>close</v-icon>
							  		</v-btn>
							  	</v-list-tile-action>

							  	<v-list-tile-content full-width @click="fn_bindDynamicFields(item.section.sectionId)">
							    	<v-list-tile-title>{{item.section.sectionName}}</v-list-tile-title>
									<v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
							  	</v-list-tile-content>
							</v-list-tile>
						</v-list>

						<v-divider></v-divider>

					      <v-card flat v-for="(fieldItem, itemIndex) in item.items" :key="itemIndex" v-if="fieldItem.value">
					        <v-card-text class="pb-0">
					        	<div font12 light-theme-color>{{fieldItem.displayName}}</div>
					        	<div font16 v-if="fieldItem.fieldType=='yes/no'">{{fieldItem.value ? 'Yes' : 'No'}}</div>

					        	<div font16 v-else-if="fieldItem.fieldType=='dateTime'">
					        		<span v-if="fieldItem.value">{{fieldItem.value | moment("DD-MMM-YYYY")}}</span>
					        		<span v-else>-</span>
					        	</div>

					  			<div font16 v-else v-html="fieldItem.value ? fieldItem.value : '-'" white-space-pre-line></div>
					        </v-card-text>
					      </v-card>
					</div>

				</v-layout>

				<v-layout wrap margin-top-ten white-background v-if="roundedAmount || Form.items.length">
					<v-list full-width nopadding>
						<v-list-tile>
				          	<v-list-tile-content>
								<v-list-tile-title medium-theme-color>Attachments {{ Form.attachments.length ? '('+Form.attachments.length+')' : '' }}</v-list-tile-title>
								<!-- <v-list-tile-title medium-theme-color>Attachments</v-list-tile-title> -->
				            </v-list-tile-content>

				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click="fn_getBottomMenuAttachment" :disabled="$root.CurrentBusiness.temporaryBusiness ? true : false" class="no-left-margin">
									<v-icon>attachment</v-icon>
								</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
						<v-divider v-if="Form.attachments.length"></v-divider>
						<template v-for="(item, index) in Form.attachments">
							<v-list-tile :key="index" :id="'doc_'+item.documentId" v-if="item.uploadStatus!=2">
					          	<v-list-tile-content>
					              <v-list-tile-title medium-theme-color>{{item.fileName}}</v-list-tile-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
		            				<v-btn flat icon :disabled="$root.CurrentBusiness.temporaryBusiness ? true : false" color="primary" @click="fn_removeAttachment(item)"><v-icon>close</v-icon></v-btn>
					            </v-list-tile-action>
						    </v-list-tile>
						    <v-divider v-if="Form.attachments.length-1 != index"></v-divider>
						</template>
					</v-list>
				</v-layout>	

				<!-- <v-layout row wrap margin-top-ten white-background v-if="Form.transactionData.paymentMode==1 && roundedAmount>0">

					<v-subheader full-width border-bottom-thin nomargin norightpadding>Payment Mode
						<v-spacer></v-spacer>
						<v-menu min-width="120">

					      <v-btn slot="activator" icon>
					      	<v-icon>more_vert</v-icon>
					      </v-btn>
					      <v-list nopadding>
					        <v-list-tile @click="fn_openDialog_PaymentOptions">
					          <v-list-tile-title>Change</v-list-tile-title>
					        </v-list-tile>
					      </v-list>

					    </v-menu>
					</v-subheader>


					<v-list nopadding full-width>

					  	<div v-if="!Form.splitPayment">
							<v-list-tile>
								<v-list-tile-content>
									<v-list-tile-title>{{fn_paymentAccountName(Form.paymentLedgerId)}}</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>&#8377; {{$root.numberToLocale(roundedAmount)}}</v-list-tile-action>
							</v-list-tile>	
						</div>

						<div v-for="(item, index) in Form.paymentOptions" :key="index" v-else>
							<v-list-tile>
						  		<v-list-tile-content>
						  		 	<v-list-tile-title>{{item.accountLedgerId == creditAccountLedgerId ? 'On Credit' : item.accountLedgerName}}</v-list-tile-title>
						  		</v-list-tile-content>
						  		<v-list-tile-action>&#8377; {{$root.numberToLocale(item.amount)}}</v-list-tile-action>
						  	</v-list-tile>	
						</div>
						
					  	
					</v-list>

				</v-layout>	 -->

				<!-- <v-layout wrap margin-top-ten white-background>
					<v-list full-width nopadding>
					  	<v-list-tile border-bottom-thin>
				          	<v-list-tile-content>
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
	            				<v-btn flat icon color="primary" @click.native="fn_addNote" class="no-left-margin">
	            					{{Form.transactionData.notes ? 'Edit' : 'Add'}}
	            				</v-btn>
				            </v-list-tile-action>
					    </v-list-tile>
					</v-list>

					<v-card flat class="note-card" v-if="Form.transactionData.notes">
					  <v-card-text v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</v-layout>     -->

				<v-list nopadding margin-top-ten v-if="Form.splitPayment && Form.paymentOptions && Form.paymentOptions.length">
					<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>Payment Mode</v-list-tile-title>
			            </v-list-tile-content>
				    </v-list-tile>
				    <v-divider></v-divider>
					<v-list-tile v-for="(item, index) in Form.paymentOptions" :key="index">
			          	<v-list-tile-content>
			              <v-list-tile-title medium-theme-color>
			              	<span v-if="item.accountLedgerId == creditAccountLedgerId">On Credit</span>
			              	<span v-else>{{item.accountLedgerName}}</span>
			              </v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>&#8377; {{item.amount}}</v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-layout wrap margin-top-ten padding-top-bottom-ten white-background v-if="(roundedAmount || Form.items.length) && settings.transactionTypeId == 20003 && $root.appVersion >= 117">
					<v-flex xs12 sm12 md12 form-item @click="fn_openDialogPaymentTerm">
						<v-text-field 
			               	readonly
			               	:value="!Form.selectedPaymentTerm ? 'Custom' : Form.selectedPaymentTerm != -1 ? Form.selectedPaymentTerm + ' Days' : 'No Due Date'"
			               	label="Term of Payment"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
		               		required>
		               	</v-text-field>	
					</v-flex>

					<v-flex xs12 sm12 md12 form-item v-if="!Form.selectedPaymentTerm">
						<v-text-field 
							v-model="Form.paymentTerm"
							type="number"
			               	label="Enter Term of Payment"
			               	placeholder=" " 
			               	v-validate="'required'" 
		               		data-vv-name="paymentTerm" 
		               		data-vv-as="payment term" 
		               		:error-messages="errors.collect('paymentTerm')"
		               		required>
		               	</v-text-field>	
					</v-flex>
				</v-layout>

			</div>

			<div white-background full-width nopadding style="position:fixed;bottom:0;">
				<v-layout row wrap>
					<v-flex xs6 sm6 md6 style="padding:6px 6px 6px 16px" @click="fn_openDialog_PaymentOptions" v-ripple v-if="(settings.transactionTypeId == 20003 || settings.transactionTypeId == 20004) && toolbarTitle != 'Debit Note'">
						<div font-medium style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">&#8377; {{$root.numberToLocale(roundedAmount)}}</div>
						<div style="font-size:11px">
							<span light-opacity-color style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">Payment:&nbsp;</span> <span style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{!Form.splitPayment ? fn_paymentAccountName(Form.paymentLedgerId) : 'Split Payment'}}</span> <v-icon font16 style="line-height:12px">arrow_drop_down</v-icon>
							<!-- {{!Form.splitPayment ? fn_paymentAccountName(Form.paymentLedgerId) : 'Split Payment'}} -->
							<!-- <v-icon font16 style="line-height:12px">arrow_drop_down</v-icon> -->
						</div>
					</v-flex>
					<v-flex xs6 sm6 md6 :class="{'xs12 sm12 md12 height48':(settings.transactionTypeId != 20003 && settings.transactionTypeId != 20004) || toolbarTitle == 'Debit Note'}">
						<v-btn color="primary" full-height nomargin block no-round-borders noshadow @click="fn_checkValidations">Save</v-btn>
					</v-flex>
				</v-layout>
			</div>

		</v-form>

	    <!-- <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	    <v-snackbar v-model="transactionNumberSnackbar" multi-line :timeout="0">
	    	Generate new transaction number?
	    	<v-btn flat icon @click="fn_bindTransactionNumber" color="primary">okay</v-btn>
	    	<v-btn flat icon @click="transactionNumberSnackbar=false">close</v-btn>
	    </v-snackbar>

		<!-- <v-snackbar v-model="snackbarTaxCategory" multi-line :timeout="0">
	    	Consider updating tax category of item(s)
	    	<v-btn flat icon @click="snackbarTaxCategory=false" color="primary">okay</v-btn>
	    </v-snackbar> -->

		<v-bottom-sheet v-model="snackbarTaxCategory" v-if="snackbarTaxCategory">
			<v-card flat>
				<v-card-title noshadow class="title">Update Taxes</v-card-title>
				<v-card-text>
					Consider updating tax category of item(s) as per applicable tax forms.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="snackbarTaxCategory=false">cancel</v-btn>
					<v-btn color="primary" flat @click="fn_getProductData(null)">Okay</v-btn>
				</v-card-actions>
			</v-card>
		</v-bottom-sheet>

	    <dialog-transaction-type-list ref="ref_dialogTransactionTypeList" :transactionTypeId="settings.transactionTypeId" :setTransactionType="fn_setTransactionType" :openConfirmationDialog="fn_openConfirmationDialog" :selectedTypeFormId="Form.transactionTypeFormId" :transactionTypeList="Form.transactionTypeList"></dialog-transaction-type-list>

	    <!-- <dialog-datepicker ref="ref_dialogDatePicker" :minDate="minTransactionDate" :maxDate="maxTransactionDate" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker> -->
		<dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

	    <dialog-note ref="ref_dialogNote"></dialog-note>

	    <dialog-number-series ref="ref_dialogNumberSeries" :checkTransactionNumber="fn_checkTransactionNumber"></dialog-number-series>

	    <dialog-tds ref="ref_dialogTds" :openAccountLedgers="fn_openAccountLedgers" :saveTdsDetails="fn_saveTdsDetails" :deleteTds="fn_removeTds"></dialog-tds>

	    <dialog-product ref="ref_dialogProduct" :openProducts="fn_openProducts" :openTaxCategories="fn_openTaxCategories" :saveItem="fn_saveItem"></dialog-product>

	    <!-- <dialog-tax-categories ref="ref_dialogTaxCategories" :setProductTaxValue="fn_setProductTaxValue" :currentTaxValue="Form.productDataModel.taxValue"></dialog-tax-categories> -->

	    <dialog-tax-categories ref="ref_dialogTaxCategories" :taxCategories="taxCategories" :updateTaxCategory="fn_updateTaxCategory" 
    	:selectedTaxCategoryId="Form.productDataModel.taxCategoryId"></dialog-tax-categories>

	    <dialog-addons ref="ref_dialogAddOns" :openAddOnsList="fn_openAddOnsList" :addOnsProp="Form.addOnsProp" :saveAddOns="fn_saveAddOns"></dialog-addons>

	    <!-- <dialog-confirmation ref="ref_dialogChangeTransactionType" header="Change Transaction Type?" :confirmationMessage="confirmationMessage" :actionMethod="fn_confirm"></dialog-confirmation> -->

	    <dialog-dynamic-fields ref="ref_dialogDynamicFields" :saveFields="fn_saveFields" :openAccountLedgers="fn_openAccountLedgers" :openListItems="fn_openListItems" :openDatePicker="fn_openDatePicker"></dialog-dynamic-fields>

	    <dialog-transactions-list ref="ref_dialogOrders" :items="Form.pendingItemsList" type="orders" :getPendingItems="fn_getPendingItems"></dialog-transactions-list>

	    <dialog-transactions-list ref="ref_dialogChallans" :items="Form.pendingItemsList" type="challans" :getPendingItems="fn_getPendingItems"></dialog-transactions-list>

	    <dialog-transactions-list ref="ref_dialogInvoices" :items="Form.pendingItemsList" type="invoices" :getPendingItems="fn_getPendingItems"></dialog-transactions-list>

	    <dialog-return-form ref="ref_dialogReturnForm" :items="Form.pendingInvoices" type="invioceItems" :addPendingItems="fn_addPendingItems"></dialog-return-form>

	    <dialog-payment-options ref="ref_dialogPaymentOptions" :savePaymentOptions="savePaymentOptions"></dialog-payment-options>

		<dialog-payment-term ref="ref_dialogPaymentTerm" :updatePaymentTerm="fn_updatePaymentTerm" :selectedPaymentTerm="Form.selectedPaymentTerm"></dialog-payment-term>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations"></dialog-discard>

	    <!-- <dialog-confirmation ref="ref_dialogCancelTransaction" header="Cancel Transaction?" :confirmationMessage="confirmationMessage" :actionMethod="fn_callCancelTransaction"></dialog-confirmation> -->

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="confirmationAction" :okBtnText="confirmationHeader == 'Add batches' ? 'Okay' : 'Yes'" :cancelBtnText="confirmationHeader == 'Add batches' ? 'Cancel' : 'No'" :displayView="confirmationHeader == 'Add batches' ? false : true" :params="confirmationActionParam"></dialog-confirmation>

	    <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items>

	    <dialog-roundoff ref="ref_dialogRoundOff"></dialog-roundoff>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

	    <!-- <dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_gotoSetupDrive"></dialog-drive-alert> -->
		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>

		<dialog-parties ref="ref_dialogLedger" :newParty="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-parties>
		<dialog-products ref="ref_dialogProductList" :setNewProduct="this.fn_setNewProduct" :newProduct="fn_menuItemClick" :closeDialog="fn_closeDialog"></dialog-products>
		<dialog-selection-list ref="ref_dialogSelectionList" :fnAction="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

		<dialog-pending-sheet ref="ref_pendingSheet" :menuclick="fn_menuItemClick" :closeDialog="fn_closeDialog" formType="purchase"></dialog-pending-sheet>

		<dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.productDataModel.productId" :productData="Form.productDataModel" :openDatePicker="fn_openDatePicker"></dialog-select-batch>
		<dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker-batch>

		<dialog-old-tax-update 
	    	ref="ref_dialogOldTaxUpdate">
	    </dialog-old-tax-update>

		<dialog-discount-whole ref='ref_dialogDiscountWhole'></dialog-discount-whole>
	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;

const menuItem = require('../../../../config.js').configs.menuItem;
const transactionForms = require('../../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../../config.js').configs.transactionTypes;

const ledgerGroupTypeId = require('../../../../config.js').configs.ledgerGroupTypeId;
const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;
const productGroupTypeId = require('../../../../config.js').configs.productGroupTypeId;
const fixedGstAddOns = require('../../../../config.js').configs.fixedGstAddOns;
const fixedCessAddOns = require('../../../../config.js').configs.fixedCessAddOns;
const fixedAccountIds = require('../../../../config.js').configs.fixedAccountIds;
const fixedGodownIds = require('../../../../config.js').configs.fixedGodownIds;

const accountGstType = require('../../../../config.js').configs.accountGstType;

const transactionData = require('../../datamodel').data.transactionData;

// import dialogCurrencyList from './dialogs/dialog_currency_list';
import dialogTransactionTypeList from '../dialogs/dialog_transaction_type_list'	//coming from outer dialogs folder
import dialogDatePicker from './dialogs/dialog_datepicker';
import dialogNote from '../dialogs/dialog_note'
import dialogNumberSeries from '../dialogs/dialog_number_series_manual'
import dialogTds from '../dialogs/dialog_tds'

import dialogPendingTransactions from './dialogs/dialog_pending_transactions'

import dialogReturnForm from './dialogs/dialog_return_form'

import dialogProduct from './dialogs/dialog_product'
import dialogPaymentOptions from '../dialogs/dialog_payment_options'

import dialogTaxCategories from '../../../dialogs/dialog_tax_categories'

import dialogAddOns from '../../../dialogs/dialog_addons'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import dialogDynamicFields from '../../../dialogs/dialog_dynamic_fields'

import dialogPaymentTerm from '../dialogs/dialog_payment_terms'

import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'
import dialogDraftItems from '../../../dialogs/dialog_draft_items'
import dialogRoundOff from '../dialogs/dialog_roundoff'

import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'

import dialogParties from '../../../dialogs/dialog_parties'
import dialogProducts from '../../../dialogs/dialog_products'
import dialogSelectionList from '../../../dialogs/dialog_selection_list'

import dialogPendingSheet from '../dialogs/dialog_pending_sheet'

import dialogSelectBatch from '../dialogs/dialog_select_batch'
import dialogDatePickerBatch from '../../../dialogs/dialog_datepicker_batch'

import dialogOldTaxUpdate from '../dialogs/dialog_old_tax_update'

import dialogDiscountWhole from '../dialogs/dialog_discount_whole'

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     // this.fn_saveToLocalStorage(this);
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.partyName);
                     }
                     this.unwatch = false;
                },
                deep: true
            }
		},
		data(){
			return{
				Form:{
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
					"partyId":null, "partyName":null, "partylastConfig":null,
					"currencyId":null, "currencyCode":null, "exchangeRate":null,
					"taxMode":0,
					"transactionTypeFormId":null, "transactionTypeFormName":null,

					"items":[],

					"productDataModel": {"groupId":null, "productId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, 
						"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null, "packing":null, "serviceAccountItemId":null, "customFields":[]
					},

					"batches":[],

					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},

					"tdsDataModel":{
						"transactionTdsId":null, "transactionId":null, "tdsAccountId":null, "tdsAccountName":null, "appliedOnAmount":null, "percentage":null, "amount":null
					},

					"transactionAddOns":[],

					"tdsDetails":{"amount":0},

					"addOnsProp":{},

					"itemsSummary":{"grossAmount":0, "grossAmountAsPerMRP":0, "addOnsItems":[], "taxValue":0, "itemsQuanity":[]},

					"settings":{"isInterState":false},

					"transactionTypeData":null,
					"dynamicFields":{"section":null, "items":[], "accountGroupId":null, "accountGroupName":null, "ref":null},

					"dynamicFieldsAdditionalData":{},

					"customFields":[],

					"dynamicMenuItems":[],

					"partyDetails":null,

					"gstType":null,

					"defaultTaxAddOns":[],

					"gstAddOns":[],
					"cessAddOns":null,

					"savedItemData":null,
					"isNew":true,
					
					"pendingItemsList":null,

					"pendingOrders":[],
					"pendingChallans":[],
					"pendingInvoices":[],
					"isPendingItems":false,

					"pendingOrderAndChallan":null,
					"pendingCount":0,

					"transactionTypeList":[],
					"draftItems":[],
					"hideEwayOption": false,
					"placeOfSupplyId":null,
					"placeOfSupplyName":null,
					"placeOfSupplyCountryId":null,
					"placeOfSupplyCountryName":null,
					// "partyGstType":null,
					"netInvoiceValue":null,
					"isRounded":this.$root.TransactionSettings.isAutoRoundOff ? true : false,
					"itemType":0,
					"roundOffValue":null,
					"isRcmApplicable":false,
					"attachments":[],

					"onCredit":true,
					"paymentLedgerId":null,
					"paymentGroups":null,
					"splitPayment":false,
					"paymentOptions":[],
					"balanceAsOn":0,
					"description":null,
					"removeItemParams":null,
					// "newSelection":false,
					"paymentGroupIndex":null,
					"paymentTerm":30,
					"selectedPaymentTerm":-1,
					"selectedBatchType":null,
					"brokerId":null,
					"brokerName":null,
					"godownId":null,
					"godownName":null,
					"itemSectionAndFields":null,
					"dynamicItemSection":[],
				},

				toolbarTitle:null,
				loading:false,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,

				backButtonPress: false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,

				dateType:null,
				selectedDate:null,
				confirmationMessage:null,

				passStockEntry:false,
				passLedgerEntry:false,

				taxCategories:null,
				draftModifiedDate:null,
				transactionNumberSnackbar:false,
				disableSaveBtn:false
			}
		},
		components:{
			// 'dialog-currency-list': dialogCurrencyList,
			'dialog-transaction-type-list': dialogTransactionTypeList,
			'dialog-datepicker': dialogDatePicker,
			'dialog-note':dialogNote,
			'dialog-tds':dialogTds,
			'dialog-product':dialogProduct,
			'dialog-tax-categories':dialogTaxCategories,
			'dialog-addons':dialogAddOns,
			'dialog-confirmation':dialogConfirmation,
			'dialog-dynamic-fields':dialogDynamicFields,
			'dialog-transactions-list':dialogPendingTransactions,
			'dialog-return-form':dialogReturnForm,
			'dialog-payment-options':dialogPaymentOptions,
			'dialog-payment-term': dialogPaymentTerm,
			'dialog-discard': dialogDiscard,
			'dialog-number-series': dialogNumberSeries,
			'dialog-draft-items': dialogDraftItems,
			'dialog-roundoff':dialogRoundOff,
			'dialog-drive-alert':dialogDriveAlert,
			'dialog-pending-sheet':dialogPendingSheet,
			'dialog-parties':dialogParties,
			'dialog-products':dialogProducts,
			'dialog-selection-list':dialogSelectionList,
			'dialog-select-batch':dialogSelectBatch,
			'dialog-datepicker-batch':dialogDatePickerBatch,
			'dialog-old-tax-update': dialogOldTaxUpdate,
			'dialog-discount-whole': dialogDiscountWhole
		},
		methods:{

			fn_openDialogRoundOff: function(){
				if(!this.Form.isRounded || !this.netAmount){
					return;
				}
				this.Form.roundOffValue = this.roundOff;
				this.fn_openDialogWeb('web', 'RoundOff', 'ref_dialogRoundOff');
			},

			fn_setRoundOffValue: function(value, nature){
				this.Form.roundOffValue = nature ? value: -value;
				this.fn_closeDialog();
			},

			fn_openDialogNumberSeries: function(){
				this.fn_openDialogWeb('web', 'NumberSeries', 'ref_dialogNumberSeries');
				this.transactionNumberSnackbar = false;
			},

			fn_openDialogPaymentTerm: function(){
				this.fn_openDialogWeb('web', 'PaymentTerm', 'ref_dialogPaymentTerm')
			},

			// fn_callCancelTransaction: function(){
			// 	this.fn_closeDialog();
			// 	this.fn_cancelTransaction(this.Form.transactionData.transactionId, this.Form.transactionData.transactionListId, 'form');
			// },

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_partyLabel: function(){
				if(this.Form.placeOfSupplyCountryName){
					return "Supplier (" + this.Form.placeOfSupplyCountryName + ")";
				}
				else{
					return "Supplier";
				}
			},

			fn_updatePaymentTerm: function(val){
				this.fn_closeDialog();
				!val ? this.Form.paymentTerm = null : '';
				this.Form.selectedPaymentTerm = val;
			},

			formType: function(){
				if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.id)
					return 'order';
				else if(this.settings.transactionTypeId == transactionTypes.purchaseChallan.id)
					return 'challan';
				else if(this.settings.transactionTypeId == transactionTypes.purchaseInvoice.id)
					return 'invoice';
				else if(this.settings.transactionTypeId == transactionTypes.purchaseReturn.id)
					return 'return';
			},

			fn_getTransactionTypeList: function (setTFT) {
		        let filterObject = {};
		        filterObject.type = this.settings.transactionTypeId;
		        // filterObject.accountGroupStatus = 1;
		        filterObject.accountGroupsHidden = [2];
		        // filterObject.inventory = [0, 1];

		        let self = this;
		        this.getItems("TransactionTypeList", filterObject, 
		          {
		            onSuccess: function (response) {
		              	console.log(response);

		              	self.unwatch = true;

		              	self.Form.transactionTypeList = JSON.parse(response);

		              	setTFT ? self.fn_setLastSelectedTFT() : '';

		    //           	if(!self.loadedFromDraft && self.Form.isNew){

		    //           		if(self.Form.transactionTypeList.length && !self.Form.transactionTypeFormId){

				  //             	if(localStorage.getItem(self.settings.transactionTypeId)){
				              		
				  //    				let transactionTypeFormId = localStorage.getItem(self.settings.transactionTypeId);

				  //             		for(let i=0; i<self.Form.transactionTypeList.length; i++){
				  //             			if(self.Form.transactionTypeList[i].transactionTypeFormId == transactionTypeFormId){
				  //             				self.fn_setTransactionType(self.Form.transactionTypeList[i]);
				  //             				break;
				  //             			}
				  //             		}	              		
				  //             	}
				  //             	else{
				  //             		if(self.Form.transactionTypeList.length == 1){
				  //             			self.fn_setTransactionType(self.Form.transactionTypeList[0]);
				  //             		}
				  //             	}

				  //           }
					
						// }     
		              
		            },
		            onError: function (error) {
		              console.log(error);
		            }
		          }
		        )
		    },

		    fn_setLastSelectedTFT: function(){
		    	if(localStorage.getItem(this.settings.transactionTypeId) && this.Form.transactionTypeList.length){
  					let transactionTypeFormId = localStorage.getItem(this.settings.transactionTypeId);

              		for(let i=0; i<this.Form.transactionTypeList.length; i++){
              			if(this.Form.transactionTypeList[i].transactionTypeFormId == transactionTypeFormId){
              				// this.loading = true;
              				this.fn_setTransactionType(this.Form.transactionTypeList[i], true);
              				break;
              			}
              		}
  				}
  				else{
  					if(this.Form.transactionTypeList.length == 1){
  						// this.loading = true;
  						this.fn_setTransactionType(this.Form.transactionTypeList[0], true);	
  					}
  					else{
  						// this.fn_openTransactionTypeList();
  						//transacion mixin function
  						// this.loading = false
						// this.fn_openTransacionTypeList_onFormLoad();

						for(let i=0;i<this.Form.transactionTypeList.length; i++){
  							if(this.Form.transactionTypeList[i].isDefault){
  								this.fn_setTransactionType(this.Form.transactionTypeList[i], true);
  								break;
  							}
  						}
  					}
              	}
		    },

			fn_saveFields: function (fieldsObj) {
				let data = JSON.parse(JSON.stringify(fieldsObj));

				console.log(JSON.stringify(data));

				//finding if details already exist
				let itemIndex = this.Form.customFields.findIndex(item=>{
					return item.section.sectionId == data.section.sectionId;
				})

				if(itemIndex==-1){
					this.Form.customFields.push(data);
				}
				else{
					this.Form.customFields[itemIndex] = data;
					this.$forceUpdate();
				}

				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#section_'+data.section.sectionId, self.scrollOptions);

					if(data.section.sectionId == self.ewayBillDetailSection.sectionId){
						self.Form.hideEwayOption = true;
					}
					else{
						let index = itemIndex != -1 ? itemIndex : self.Form.customFields.length-1
						self.fn_showHideDynamicFieldOption(index, true);
					}
				},100);
				this.fn_closeDialog();
			},

			fn_removeFields: function (index, sectionId) {
				if(this.ewayBillDetailSection.sectionId == sectionId){
					this.Form.hideEwayOption = false;
				}
				else{
					this.fn_showHideDynamicFieldOption(index, false);
				}
				this.Form.customFields.splice(index, 1);
			},

			fn_showHideDynamicFieldOption: function(index, hideOption){
				for(let j=0; j<this.Form.dynamicMenuItems.length; j++){
					if(this.Form.dynamicMenuItems[j].sectionId == this.Form.customFields[index].section.sectionId){
						this.Form.dynamicMenuItems[j].hideOption = hideOption;
						this.$forceUpdate();
					}
				}
			},

			fn_openConfirmationDialog: function (msg) {
				this.confirmationMessage = msg;
				this.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogChangeTransactionType');
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){

				if(ref.indexOf('dialog') != -1){
					// if(ref=='ref_dialogAddOns_name' && this.Form.newSelection){
					if(ref=='ref_dialogAddOns_name' && localStorage.getItem('newSelection')){
						this.fn_closeDialog();
						let self = this;
						setTimeout(() => {
							let dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
							if(!dialogData || (dialogData && dialogData[0].ref != "ref_dialogAddOns")){
								self.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns')	
							}
							// self.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
						}, 300);
						setTimeout(() => {
							self.fn_updateDialogRef(tagId, ref, selectedValueId, selectedValueName, isRemoved);
						}, 600);
					}
					// else if(ref=="ref_dialogProduct_productName" && this.Form.newSelection){
					else if(ref=="ref_dialogProduct_productName" && localStorage.getItem('newSelection')){
						this.fn_closeDialog();
						let self = this;
						setTimeout(() => {
							let dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
							if(!dialogData || (dialogData && dialogData[0].ref != "ref_dialogProduct")){
								// self.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct')	
								self.fn_openDialogProductForm();
							}
							// self.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
						}, 300);
						setTimeout(() => {
							self.fn_updateDialogRef(tagId, ref, selectedValueId, selectedValueName, isRemoved);
						}, 600);
					}
					else{
						this.fn_updateDialogRef(tagId, ref, selectedValueId, selectedValueName, isRemoved);
					}
					// let key = ref.substring(0, ref.lastIndexOf('_'));
					// let dialogRef = this.$refs[key];
		
					// var checkRefs = setInterval(function(){
			        //   if(dialogRef.$refs.hasOwnProperty(ref)){
			        //   	clearInterval(checkRefs);
			        //   	if(Array.isArray(dialogRef.$refs[ref])){
			        //   		dialogRef.$refs[ref][0].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved, ref);
			        //   	}
			        //   	else{
			        //   		dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved, ref);
			        //   	}
			        //   }
			        // },50);
				}
				else{
					this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
			},

			fn_openStates: function(){
				this.fn_openStateDialog('android', 'state', 'ref_fieldState');
			},

			fn_openStateDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select State/Place of Supply";
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.placeOfSupplyId && this.Form.placeOfSupplyName){
					paramObject.defaultValue = {"id":this.Form.placeOfSupplyId, "name":this.Form.placeOfSupplyName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
			},

			fn_updateState: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.placeOfSupplyId = selectedValueId;
		        	this.Form.placeOfSupplyName = selectedValueName;
		        	this.errors.remove('state');
				}
				else{
					this.Form.placeOfSupplyId = null;
		        	this.Form.placeOfSupplyName = null;
				}
				this.$forceUpdate();

				let oldGstType = this.Form.gstType ? this.Form.gstType : null;

				if(this.Form.gstType != this.$root.fn_getGstType(this.Form.placeOfSupplyId, this.Form.partyDetails.gstType, this.Form.transactionTypeData.importExport)){
		          	this.Form.gstType = this.$root.fn_getGstType(this.Form.placeOfSupplyId, this.Form.partyDetails.gstType, this.Form.transactionTypeData.importExport);
		          	this.fn_bindGstAddOns();
		        }

		        if(oldGstType && oldGstType != this.Form.gstType){
		        	this.fn_removeAddOnsOnPlaceOfSupplyChange(fixedGstAddOns);	
		        }

				// if(this.Form.gstType != this.$root.fn_getGstType(this.Form.placeOfSupplyId, this.Form.partyGstType)){
		  //         	this.Form.gstType = this.$root.fn_getGstType(this.Form.placeOfSupplyId, this.Form.partyGstType);
		  //         	this.fn_bindGstAddOns();
		  //       }
			},

			fn_openSuppliers: function () {

				if(!this.Form.transactionTypeFormId){
					this.fn_openTransactionTypeList();
					this.showToast("Please select transaction form");
					return
				}

				if(this.Form.items.length && (this.Form.pendingOrders.length || this.Form.pendingChallans.length || this.Form.pendingInvoices.length)){
					// this.snackbar_msg = 'Kindly remove dependent items.';
					// this.snackbar = true;
					this.showToast("Please remove dependent items");
					return
				}

				let accountGroups = [];
				if(this.Form.transactionTypeData && !this.Form.transactionTypeData.isAllPartySelected){
					this.Form.transactionTypeData.transactionParties.forEach(function (item) {
						accountGroups.push(item.accountGroupId);
					});
				}
				this.fn_openAccountLedgers('android', 'Supplier', 'ref_fieldSupplier', this.Form.partyId, this.Form.partyName, accountGroups);
			},

			// fn_openCurrencyList: function () {
			// 	this.fn_openDialogWeb('web', 'CurrencyList', 'ref_dialogCurrencyList');	
			// },

			fn_confirm: function () {
				this.fn_closeDialog();
				this.fn_openTransactionTypeList();
			},

			fn_openTransactionTypeList: function () {
				this.fn_openDialogWeb('web', 'TransactionTypeList', 'ref_dialogTransactionTypeList');	
			},

			fn_openTaxCategories: function(){
				this.fn_openDialogWeb('web', 'TaxCategories', 'ref_dialogTaxCategories');
			},

			fn_getTaxCategories: function(){
			  let filterObject = {};
			  let self = this;
			  this.getItems("TaxCategoryList", filterObject, 
			    {
			      onSuccess: function (response) {
			        console.log(response);
			        self.unwatch = true;
			        self.taxCategories = JSON.parse(response);
			      },
			      onError: function (error) {
			        console.log(error);
			      }
			    }
			  )
			},

			fn_addItem: function (isNew) {
				this.$validator.validate('supplier').then((result)=>{
					if(result){

						if(this.Form.transactionTypeList && this.Form.transactionTypeList.length>1){
							if(!this.Form.transactionTypeFormName){
								this.showToast("Select transaction form");
							}
							else{
								this.fn_addNewItem(isNew);
							}
							// this.$validator.validate('transactionType').then((result2)=>{
							// 	if(!result2 || !this.Form.transactionTypeData){
							// 		this.showToast("Select type of transaction");
							// 		this.$vuetify.goTo('#transactionTypeField', this.scrollOptions);
							// 	}
							// 	else{
							// 		this.fn_addNewItem(isNew);
							// 	}
							// })
						}
						else{
							this.fn_addNewItem(isNew);
						}

					}
					else{
						this.$vuetify.goTo('#supplierfield', this.scrollOptions);
					}
				});
				
			},

			fn_addNewItem: function(isNew, doneAndNew){
				if(isNew){
					// this.Form.newSelection = true;
					localStorage.setItem('newSelection', 1);
					// this.Form.productDataModel = {"groupId":null, "productId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, "defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null
					// };

					// this.fn_bindTransactionTypeAddOns();

					// let self = this;
					// setTimeout(function(){
					// 	self.fn_openProducts('android', 'Products', 'ref_dialogProduct_productName', self.Form.productDataModel.productId, self.Form.productDataModel.productName);
					// },400);
					this.fn_openProducts('android', 'Products', 'ref_dialogProduct_productName', null, null);
				}
				else{
					// this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
					this.fn_openDialogProductForm();
				}

				// if(!doneAndNew){
				// 	this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');	
				// }
			},

			fn_openDialogProductForm: function(){
				// if(this.Form.newSelection){
				if(localStorage.getItem('newSelection')){
					this.Form.productDataModel = {"groupId":null, "productId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, "defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null, "cessValueOnQuantity":null, "packing":null, "serviceAccountItemId":null, "customFields":[]};

					this.fn_bindTransactionTypeAddOns();
				}
				this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
			},

			fn_openTdsForm: function () {
				if(this.Form.tdsDetails){
					this.Form.tdsDataModel = JSON.parse(JSON.stringify(this.Form.tdsDetails));
				}
				else{
					this.Form.tdsDataModel = {"transactionTdsId":null, "transactionId":null, "tdsAccountId":null, "tdsAccountName":null, "appliedOnAmount":null, "percentage":null, "amount":null
					}
				}
				this.fn_openDialogWeb('web', 'TDS', 'ref_dialogTds');
			},

			fn_openAddOns: function (addOnsType, isNew) {

				// this.Form.addOnsProp.value = "addOns";
				// this.Form.addOnsProp.toolbarTitle = "Discounts/Taxes/Other Charges";

				// this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');	

				if(isNew){
					// this.Form.newSelection = true;
					localStorage.setItem('newSelection', 1);
					this.Form.addOnsDataModel = {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":addOnsType};

					this.fn_openAddOnsList('android', 'AddOns', 'ref_dialogAddOns_name', null, null, addOnsType);
				}
				else{
					this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
				}
			},

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				// this.selectedDate = date ? date : new Date();
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					if(type=='mfgDate' || type=='expDate'){
						self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerBatch');	
					}
					else{
						self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
					}
				})
			},

			fn_updateDate: function (value) {
				if(this.dateType=="transactionDate"){
					// this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
                    // if(this.Form.isNew){
                    //     this.fn_bindTransactionNumber();
                    // }
					this.fn_updateTransactionDate(value, this.Form.isNew);
				}
				else if(this.dateType=="refDate"){
					// this.Form.transactionData.refDate = value;
					this.Form.transactionData.refDate = this.$root.fn_getLocalDateFormat(value);
				}
				// else if(this.dateType=="dynamicFieldDate"){
				else if(this.dateType.indexOf("dynamicItemFieldDate") != -1){
					this.$refs['ref_dialogProduct'].$refs['ref_componentDynamicFields'][0].fn_updateDynamicDate(value, this.dateType);
				}
				else if(this.dateType.indexOf("dynamicFieldDate") != -1){
					this.$refs['ref_dialogDynamicFields'].fn_updateDynamicDate(value, this.dateType);
				}
				else if(this.dateType == 'mfgDate' || this.dateType == 'expDate'){
					this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
				}

				this.fn_closeDialog();
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			// fn_openAccountLedgers: function (platform, name, ref, itemId, itemName, accountGroups) {

			// 	let viewDialogObject = { ToolbarTitle:"Ledger", groupTypeId:null, action:null, accountGroups:null, accountGstTypes:null };
			// 	viewDialogObject.ToolbarTitle = ref == 'ref_fieldSupplier' ? 'Supplier' : "Ledger";
			// 	viewDialogObject.selectedItem = {itemId:itemId, itemName:itemName};
			// 	viewDialogObject.ref = ref;

			// 	// let action = "newledger";
			// 	// this.viewDialogObject.groupTypeId = 103;

			// 	if(name == 'Supplier'){
			// 		// action = "newsupplier";
			// 		viewDialogObject.action = "newsupplier";
			// 		viewDialogObject.groupTypeId = 102;
			// 	}
			// 	else if(name == "TdsAccounts"){
			// 		viewDialogObject.action = "newledger"
			// 	}
			// 	else if(name == 'AccountLedgers'){
			// 		viewDialogObject.action = "dynamicAccountField";
			// 	}

			// 	// this.viewDialogObject.action = action;

			// 	// this.Form.dynamicFields.accountGroupId ? action = "dynamicAccountField" : "";
			// 	// this.Form.dynamicFields.accountGroupId ? viewDialogObject.action = "dynamicAccountField" : "";

			// 	// this.viewDialogObject.accountGstTypes = null;

			// 	if(accountGroups && accountGroups.length){
			// 		viewDialogObject.accountGroups = JSON.parse(JSON.stringify(accountGroups));
			// 	}

			// 	let isDynamicField = ref.indexOf("ref_dialogDynamicFields_accountLedger") == -1 ? false : true;

			// 	if(this.Form.transactionTypeData.importExport && this.Form.transactionTypeData.importExportTransactionAccountId && !isDynamicField){
			// 		viewDialogObject.accountGstTypes = [accountGstType.overseas.id, accountGstType.sez.id]
			// 	}
			// 	else{
			// 		viewDialogObject.accountGstTypes = [accountGstType.registered.id, accountGstType.composition.id, accountGstType.unregistered.id, accountGstType.consumer.id, accountGstType.deemed.id];
			// 	}

			// 	ref == 'ref_dialogTds_AccountLedger' ? viewDialogObject.accountGstTypes = null : '';

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.$nextTick(() => {
			// 		this.fn_openDialogWeb('web', 'Ledger', 'ref_dialogLedger');
			// 	})
			// },

			fn_openAccountLedgers: function (platform, name, ref, itemId, itemName, accountGroups) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = ref == 'ref_fieldSupplier' ? 'Select Supplier' : "Select Ledger";

				let action = "newledger";

				if(name == 'Supplier'){
					// viewDialogObject.groupTypeId = ledgerGroupTypeId.supplier;
					action = "newsupplier";
				}

				this.Form.dynamicFields.accountGroupId ? action = "dynamicAccountField" : "";

				// let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":action};
				// viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				// viewDialogObject.accountGroups = [];
				// viewDialogObject.accountGroupIds = [];
				viewDialogObject.accountGstTypes = null;

				if(accountGroups && accountGroups.length){
					viewDialogObject.accountGroups = JSON.parse(JSON.stringify(accountGroups));
					// viewDialogObject.accountGroupIds = JSON.parse(JSON.stringify(accountGroups));
				}

				let isDynamicField = ref.indexOf("ref_dialogDynamicFields_accountLedger") == -1 ? false : true;

				if(this.Form.transactionTypeData.importExport && this.Form.transactionTypeData.importExportTransactionAccountId && !isDynamicField){
					viewDialogObject.accountGstTypes = [accountGstType.overseas.id, accountGstType.sez.id]
				}
				else{
					viewDialogObject.accountGstTypes = [accountGstType.registered.id, accountGstType.composition.id, accountGstType.unregistered.id, accountGstType.consumer.id, accountGstType.deemed.id];
				}

				ref == 'ref_dialogTds_AccountLedger' ? viewDialogObject.accountGstTypes = null : '';

				if(ref == 'ref_fieldBroker'){
					// passing employess groupid as broker lies under employees group
					viewDialogObject.accountGroups = [accountGroupIds.brokers.id];
					viewDialogObject.accountGstTypes = null;
					action = "newbroker";
				}
				else{
					viewDialogObject.accountGroupsHidden = [accountGroupIds.brokers.id];
				}

				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":action};
				viewDialogObject.TopMenu = [menuItemCustom];

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			// fn_openProducts: function () {
			// 	if(this.$refs['ref_dialogProduct'] && !this.$refs['ref_dialogProduct'].dialog_product){
			// 		this.Form.productDataModel.productId = null;
			// 		this.Form.productDataModel.productName = null;
			// 	// 	this.Form.productDataModel = {"groupId":null, "productId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "cessAmount":0, "taxCategoryId": null, "taxCategoryName": null, "defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null, "description":null};
			// 	}

			// 	let viewDialogObject = {
			// 		ToolbarTitle:"Item", 
			// 		action:"newproduct",
			// 		// groupTypeId:productGroupTypeId.product,
			// 		inventory:1,
			// 		selectedItem:{itemId:this.Form.productDataModel.productId, itemName:this.Form.productDataModel.productName}
			// 	};

			// 	localStorage.setItem("dialog_properties", JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Products', 'ref_dialogProductList');
			// },

			fn_openProducts: function (platform, name, ref, itemId, itemName) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				// viewDialogObject.groupTypeId = productGroupTypeId.product;
				viewDialogObject.inventory = 1;
				viewDialogObject.hideChip = true;

				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newproduct"};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;

				if(this.toolbarTitle == 'Debit Note'){
					viewDialogObject.serviceAccountItem = true;
				}

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
			},

			fn_openListItems: function (platform, name, ref, itemId, itemName, listId, listName) {

				this.Form.dynamicFieldsAdditionalData.listId = listId;
				this.Form.dynamicFieldsAdditionalData.listName = listName;

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newListItem"};
				viewDialogObject.TopMenu = [menuItemCustom];

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.listId = listId;

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'listItems', tagId, paramObject, ref);
			},

			// fn_openAddOnsList: function(platform, name, ref, itemId, itemName, addOnsType){

			// 	let viewDialogObject = { ToolbarTitle:"Add On", fnName:"AddOnsDialog", ref:ref, dbSearch:true };

			// 	viewDialogObject.addOnType = addOnsType;
			// 	// let actionValue = null;
			// 	if(addOnsType == 1){
			// 		this.Form.addOnsProp.toolbarTitle = "Discounts";
			// 		viewDialogObject.action = "adddiscount";
			// 	}
			// 	else if(addOnsType == 2){
			// 		this.Form.addOnsProp.toolbarTitle = "Taxes";
			// 		viewDialogObject.action = "addtaxes";
			// 	}
			// 	else{
			// 		this.Form.addOnsProp.toolbarTitle = "Other Charges";
			// 		viewDialogObject.action = "addothercharges";	
			// 	}

			// 	viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;

			// 	if(itemId && itemName){
			// 		viewDialogObject.selectedItem = {"itemId":itemId, "itemName":itemName};
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },


			fn_openAddOnsList: function (platform, name, ref, itemId, itemName, addOnsType) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				// viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;
				// let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":this.Form.addOnsProp.value};
				// viewDialogObject.TopMenu = [menuItemCustom];
				this.Form.addOnsProp.addOnsType = addOnsType;

				// let actionValue = null;
				if(addOnsType == 1){
					this.Form.addOnsProp.toolbarTitle = "Discounts";
					viewDialogObject.TopMenu = [menuItem.addDiscount];
					// actionValue = "adddiscount";
				}
				else if(addOnsType == 2){
					this.Form.addOnsProp.toolbarTitle = "Taxes";
					viewDialogObject.TopMenu = [menuItem.addTaxes];
					// actionValue = "addtaxes";
				}
				else{
					this.Form.addOnsProp.toolbarTitle = "Other Charges";
					viewDialogObject.TopMenu = [menuItem.addOtherCharges];	
					// actionValue = "addothercharges";
				}

				viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.addOnType = Number(addOnsType);

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, "addOns", tagId, paramObject, ref);
			},

			fn_saveAddOns: function (data) {

				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				if(data.mode==0 && (data.percentage==null || data.percentage=='')){
					data.value = null;
				}

				if(!data.isDefault)
					data.isDefault = false;

				!data.transactionAddOnsId ? data.transactionAddOnsId = this.guid() : '';

				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.transactionAddOnsId == data.transactionAddOnsId;
				});

				// if(itemIndex==-1){
				// 	this.Form.transactionAddOns.push(data);
				// }
				// else{
				// 	this.Form.transactionAddOns.splice(itemIndex, 1, data);
				// }

				// this.fn_closeDialog();

				if(data.addOnsType == 2){
					this.fn_checkTaxAddOns(data);
				}
				else{
					let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
						return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
					});

					if(itemIndex==-1){
						this.Form.transactionAddOns.push(data);
					}
					else{
						this.Form.transactionAddOns.splice(itemIndex, 1, data);
					}

					this.fn_closeDialog();
				}
			},

			fn_checkTaxAddOns: function(data){
				let data2 = null
				if(this.Form.gstType == "IntraState" && (fixedGstAddOns.CGST.id == data.addOnsId || fixedGstAddOns.SGST.id == data.addOnsId)){
					data2 = JSON.parse(JSON.stringify(data));
					data2.transactionAddOnsId = this.guid();
					if(fixedGstAddOns.CGST.id == data.addOnsId){
						data2.addOnsId = fixedGstAddOns.SGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.sgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.sgst.id : '';
						data2.name = "SGST";
						
						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.outputSgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputSgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputSgst.id;
						// }
						// data2.name = "SGST";
					}
					else{
						data2.addOnsId = fixedGstAddOns.CGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.cgst.id : '';
						data2.name = "CGST";

						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.outputCgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputCgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputCgst.id;
						// }
						// data2.name = "CGST";
					}
				}
				else if(this.Form.gstType == "UnionTerritory" && (fixedGstAddOns.CGST.id == data.addOnsId || fixedGstAddOns.UTGST.id == data.addOnsId)){
					data2 = JSON.parse(JSON.stringify(data));
					data2.transactionAddOnsId = this.guid();
					if(fixedGstAddOns.CGST.id == data.addOnsId){
						data2.addOnsId = fixedGstAddOns.UTGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.utgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.utgst.id : '';
						data2.name = "UTGST";

						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.outputUtgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputUtgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputUtgst.id;
						// }
						// data2.name = "UTGST";
					}
					else{
						data2.addOnsId = fixedGstAddOns.CGST.id;
						data2.purchaseAccountItemId = fixedAccountIds.cgst.id;
						this.Form.isRcmApplicable ? data2.saleAccountItemId = fixedAccountIds.cgst.id : '';
						data2.name = "CGST";

						// if(this.Form.isRcmApplicable){
						// 	data2.saleAccountItemId = fixedAccountIds.outputCgst.id;
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputCgst.id;
						// }
						// else{
						// 	data2.purchaseAccountItemId = fixedAccountIds.inputCgst.id;
						// }
						// data2.name = "CGST";
					}
				}

				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
				});

				if(itemIndex==-1){
					this.Form.transactionAddOns.push(data);
				}
				else{
					this.Form.transactionAddOns.splice(itemIndex, 1, data);
				}

				if(data2){
					let data2Index = this.Form.transactionAddOns.findIndex(item=>{
						return item.addOnsId == data2.addOnsId;
					});

					if(data2Index==-1){
						this.Form.transactionAddOns.push(data2);
					}
					else{
						this.Form.transactionAddOns.splice(data2Index, 1, data2);
					}
				}

				this.fn_closeDialog();

			},

			fn_removeAddOns: function(item, index){
				let addOnIndex = this.Form.transactionAddOns.findIndex(addOnItem=>{
					return item.transactionAddOnsId == addOnItem.transactionAddOnsId;
				})

				// this.Form.transactionAddOns.splice(index, 1);
				this.Form.transactionAddOns.splice(addOnIndex, 1);

				if(item.addOnsId == fixedGstAddOns.CGST.id){
					let self = this;
					if(this.Form.gstType == "UnionTerritory"){
						this.fn_removeAddOnsPair(fixedGstAddOns.UTGST.id)
					}
					else{
						this.fn_removeAddOnsPair(fixedGstAddOns.SGST.id)	
					}
				}
				else if(item.addOnsId == fixedGstAddOns.SGST.id || item.addOnsId == fixedGstAddOns.UTGST.id){
					this.fn_removeAddOnsPair(fixedGstAddOns.CGST.id)
				}
			},

			fn_removeAddOnsPair: function(addOnId){
				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.addOnsId == addOnId;
				})

				this.Form.transactionAddOns.splice(itemIndex, 1);
			},

			fn_editAddOns: function (item) {
				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				this.Form.addOnsDataModel = JSON.parse(JSON.stringify(item));
				this.fn_openAddOns(item.addOnsType);
			},

			// fn_setProductTaxValue: function (item) {
			// 	this.Form.productDataModel.taxValue = item.value;
			// 	this.fn_closeDialog();
			// },

			fn_updateTaxCategory: function (item, preventCloseDialog) {
				this.Form.productDataModel.taxValue = item.taxValue;

				// emptying before assigning updated;
				this.Form.productDataModel.cessValue = null;
				this.Form.productDataModel.cessValueOnQuantity = null;

				// this.Form.productDataModel.cessValue = item.cessValue;
				if(!item.cessType || item.cessType != 2){
					this.Form.productDataModel.cessValue = item.cessValue;
				}

				if(item.cessType != 1){
					this.Form.productDataModel.cessValueOnQuantity = item.cessValueOnQuantity;
				}

				this.Form.productDataModel.taxCategoryId = item.taxCategoryId;
				this.Form.productDataModel.taxCategoryName = item.taxCategoryName;
				this.Form.productDataModel.isCessApplicable = item.isCessApplicable;
				this.$forceUpdate();
				!preventCloseDialog ? this.fn_closeDialog() :'';

				this.fn_checkTaxCategory();
				// if(this.fn_isNewTaxForm() && !localStorage.getItem('hide_old_tax_message')){
				// 	let taxPer = this.Form.productDataModel.taxValue;
				// 	if(taxPer != 5 && taxPer != 18 && taxPer != 40 && taxPer != 3 && taxPer != 0.25 && taxPer != 1.5){
				// 		// this.$parent.snackbarTaxCategory = true;
				// 		this.fn_openDialogWeb('web', 'OldTaxUpdate', 'ref_dialogOldTaxUpdate');
				// 		this.$refs['ref_dialogProduct'].disableBtn = false;
				// 		return;
				// 	}
				// }
			},

			fn_checkTaxCategory: function(){
				if(this.fn_isNewTaxForm() && !localStorage.getItem('hide_old_tax_message')){
					let taxPer = this.Form.productDataModel.taxValue;
					if(taxPer != null && taxPer != 0 && taxPer != 5 && taxPer != 18 && taxPer != 40 && taxPer != 3 && taxPer != 0.25 && taxPer != 1.5){
						// this.$parent.snackbarTaxCategory = true;
						this.fn_openDialogWeb('web', 'OldTaxUpdate', 'ref_dialogOldTaxUpdate');
						this.$refs['ref_dialogProduct'].disableBtn = false;
					}
				}
			},

			fn_appendBatches: function(batches){
				if(batches.length){
					this.$set(this.Form.productDataModel, 'batches', JSON.parse(JSON.stringify(batches)));
					let totalQty = 0;
					let bat = null;
					if(this.Form.selectedBatchType == 2){
						bat = batches.filter(field=>{
							return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4
						})

						if(this.Form.productDataModel){
							if(this.Form.productDataModel.productVariants[0].selectedUnit){
								this.Form.productDataModel.productVariants[0].selectedUnit = {"itemId":this.Form.productDataModel.productVariants[0].primaryUnitId, "itemName":this.Form.productDataModel.productVariants[0].primaryUnitName}
							}
						}
					}
					else{
						bat = batches.filter(field=>{
							return !field.field1 && !field.field2 && !field.field3
						})
					}
					// for(let i=0; i<this.Form.productDataModel.batches.length; i++){
					// 	totalQty += Number(this.Form.productDataModel.batches[i].productQty);
					// }
					for(let i=0; i<bat.length; i++){
						totalQty += Number(bat[i].productQty);
					}
					this.Form.productDataModel.productVariants[0].qty = Number(totalQty);
				}
				this.fn_closeDialog();
			},

			fn_fieldVisibilty: function(field, selectedBatchType){
				if(field.status){
					if(selectedBatchType == 2){
						if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
							return true;
						}
						else{
							return false;
						}
					}
					else{
						if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'opening' || field.id == 'field4'){
							return true;
						}
						else{
							return false;
						}
					}
				}
				else{
					return false
				}
			},

			fn_saveItem: function (data, doneAndNew) {
				let itemIndex = null;
				let self = this;

				console.log(JSON.stringify(this.Form.items));

				//checking bill quantity in case of return when return item belongs to already creadted invoice
				if(this.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id && data.baseTransactionListId == transactionTypes.purchaseInvoice.id){

					for(let i=0; i<data.productVariants.length; i++){
						if(data.productVariants[i].qty > data.productVariants[i].billQty){
							// this.snackbar_msg = 'Return quantity should be less then or equal to bill quantity';
							// this.snackbar = true;
							this.hideLoading();
							setTimeout(function(){
								self.$refs['ref_dialogProduct'].disableBtn = false;	
							},1000);
							this.showToast('Return quantity should be less then or equal to bill quantity');
							return;
						}
					}

				}

				let itemData = JSON.parse(JSON.stringify(data));

				!itemData.mrp ? itemData.mrp = 0 : '';
				!itemData.rate ? itemData.rate = 0 : '';

				itemData.selectedBatchType = this.Form.selectedBatchType;

				// filtering batches as per selected batch type (batch/series)
				if(itemData.batches && itemData.batches.length){
					itemData.batches = itemData.batches.filter(batch=>{
						if(itemData.selectedBatchType == 1){
							return batch.batchNumber || batch.batchMRP || batch.purchaseRate || batch.batchSize || batch.mfgDate || batch.expDate || batch.opening || batch.field4
						}
						else{
							return  batch.field1 || batch.field2 || batch.field3
						}
					});
				}


				if(!itemData.groupId){

					//baseTransactionListId and baseTransactionNumber using only for grouping items not saving anywhere
					itemData.baseTransactionListId = this.settings.transactionTypeId;
					// itemData.baseTransactionNumber = this.Form.transactionData.transactionNumber;
					itemData.baseTransactionNumber = this.Form.transactionData.mergeTransactionNumber;

					itemData.groupId = this.guid();
					
					this.Form.items.push(itemData);
				}
				else{
					itemIndex = this.Form.items.findIndex(item=>{
						return item.groupId == itemData.groupId;
					})
					this.Form.items.splice(itemIndex, 1, itemData);
				}

				console.log(JSON.stringify(this.Form.items));

				// !doneAndNew ? this.fn_closeDialog() : '';
				this.fn_closeDialog();

				setTimeout(function(){
					self.$refs['ref_dialogProduct'].disableBtn = false;	
				},1000);

				this.Form.netInvoiceValue = null;
				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				this.fn_removeTaxAddons(doneAndNew);
			},

			fn_removeTaxAddons: function(doneAndNew){
				this.Form.transactionAddOns = this.Form.transactionAddOns.filter(item=>{
					return item.addOnsType != 2;
				});

				if(doneAndNew){
					this.showToast("Item added");
					this.fn_addNewItem(true, doneAndNew);
				}
			},

			fn_editItem: function (item, category, groupIndex) {

				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				let itemData = JSON.parse(JSON.stringify(item));
				this.Form.productDataModel.groupId = itemData.groupId;
				this.Form.productDataModel.productId = itemData.productId;
				this.Form.productDataModel.productName = itemData.productName;
				this.Form.productDataModel.mrp = itemData.mrp;
				this.Form.productDataModel.rate = itemData.rate;
				this.Form.productDataModel.productVariants = itemData.productVariants;
				this.Form.productDataModel.taxValue = itemData.taxValue;
				this.Form.productDataModel.taxAmount = itemData.taxAmount;
				this.Form.productDataModel.description = itemData.description;

				this.Form.productDataModel.packing = itemData.packing;

				this.Form.productDataModel.customFields = itemData.customFields ? itemData.customFields : null;

				this.Form.productDataModel.cessValue = itemData.cessValue >= 0 ? itemData.cessValue : null;
				this.Form.productDataModel.cessAmount = itemData.cessAmount ? itemData.cessAmount : 0;

				this.Form.productDataModel.cessValueOnQuantity = itemData.cessValueOnQuantity ? itemData.cessValueOnQuantity : null;

				this.Form.productDataModel.taxCategoryId = itemData.taxCategoryId;
				this.Form.productDataModel.taxCategoryName = itemData.taxCategoryName;

				this.Form.productDataModel.hsnCode = itemData.hsnCode;
				this.Form.productDataModel.orderNumber = itemData.orderNumber;
				this.Form.productDataModel.grossAmount = itemData.grossAmount;
				this.Form.productDataModel.grossAmountAsPerMRP = itemData.grossAmountAsPerMRP;
				this.Form.productDataModel.netAmount = itemData.netAmount;

				this.Form.productDataModel.defaultTaxValue = itemData.defaultTaxValue;
				this.Form.productDataModel.defaultCessValue = itemData.defaultCessValue;
				this.Form.productDataModel.defaultHsnCode = itemData.defaultHsnCode;
				this.Form.productDataModel.defaultTaxCategoryId = itemData.defaultTaxCategoryId;
				this.Form.productDataModel.defaultTaxCategoryName = itemData.defaultTaxCategoryName;
				this.Form.productDataModel.isCessApplicable = itemData.isCessApplicable;

				//baseTransactionListId and baseTransactionNumber using only for grouping items not saving anywhere
				this.Form.productDataModel.baseTransactionListId = itemData.baseTransactionListId;
				this.Form.productDataModel.baseTransactionNumber = itemData.baseTransactionNumber;

				// capturing params only for removing item directly from product dialog
				this.Form.removeItemParams = {};
				this.Form.removeItemParams.groupId = itemData.groupId;
				this.Form.removeItemParams.category = category;
				this.Form.removeItemParams.groupIndex = groupIndex;
				this.Form.removeItemParams.baseTransactionNumber = itemData.baseTransactionNumber;

				if(itemData.serviceAccountItemId){
					this.Form.productDataModel.serviceAccountItemId = itemData.serviceAccountItemId;
				}

				this.Form.selectedBatchType = itemData.selectedBatchType;

				// batch
				if(itemData.batches && itemData.batches.length){
					// this.Form.productDataModel.batches = itemData.batches;
					this.$set(this.Form.productDataModel, 'batches', JSON.parse(JSON.stringify(itemData.batches)));
				}
				else{
					this.Form.productDataModel.batches = null;
				}

				this.$refs['ref_dialogProduct'].fn_getProductData(true, itemData.productId, itemData.baseTransactionListId);

				this.fn_refreshAddons(itemData);


				if(!this.Form.isNew && this.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id && itemData.baseTransactionListId == transactionTypes.purchaseInvoice.id){
					this.fn_getBillQuantity(this.Form.productDataModel);
				}

				this.$refs['ref_dialogProduct'].fn_getBatches(itemData.productId, itemData.batches);
				
				// binding custom item fields if any and not binded already
				if(this.Form.dynamicItemSection && this.Form.dynamicItemSection.length && !this.Form.productDataModel.customFields){
					!this.Form.productDataModel.customFields ? this.Form.productDataModel.customFields = [] : '';
					this.fn_bindDynamicItemFields(this.Form.dynamicItemSection[0].sectionId);
				}
			},

			fn_getBillQuantity: function (itemData) {
				let filterObject = {};
				filterObject.formTransactionListId = [transactionTypes.purchaseReturn.id];

				filterObject.transactionListId = [transactionTypes.purchaseInvoice.id];


				let refTId = null;
				if(itemData.productVariants[0].refTId){
					refTId = itemData.productVariants[0].refTId;
				}
				else{
					return
				}

				let self = this;
				this.getFilterData('BillQuantity', refTId, filterObject, 
					{
						onSuccess: function(response){

							console.log(response);

							let variants = JSON.parse(response);

							for(let i=0; i<variants.length; i++){

								for(let j=0; j<itemData.productVariants.length; j++){

									if(itemData.productVariants[j].unitId == variants[i].unitId){

										// itemData.productVariants[j].billQty = itemData.productVariants[j].qty + variants[i].billQty;
										let billQty = itemData.productVariants[j].qty + variants[i].billQty;
										itemData.productVariants[j].billQty = Number(billQty.toFixed(3));

										self.$forceUpdate();

									}

								
								}

							}

							if(itemData.batches && itemData.batches.length){
								self.fn_getBatchBillQuantity(itemData);
							}

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );	
			},

			fn_getBatchBillQuantity: function (itemData) {

				// if(this.Form.transactionData.transactionListId == transactionTypes.salesReturn.id && itemData.baseTransactionListId == transactionTypes.salesInvoice.id){

				let filterObject = {};
				filterObject.transactionId = itemData.productVariants[0].refTId;

				let self = this;
				this.getFilterData('PendingBatchQuantity', itemData.productId, filterObject,
					{
						onSuccess: function(response){

							console.log(response);

							let pendingBatches = JSON.parse(response);

							if(!pendingBatches || !pendingBatches.length){
								pendingBatches = []
							}

							for(let i=0; i<itemData.batches.length; i++){
								if(!pendingBatches.length){
									itemData.batches[i].billQty = itemData.batches[i].qty;
								}
								for(let j=0; j<pendingBatches.length; j++){
									if(itemData.batches[i].batchId == pendingBatches[j].batchId){
										itemData.batches[i].billQty = self.roundUpto2Decimals(itemData.batches[i].qty + pendingBatches[j].batchBillQty)
									}
								}
							}

							if(self.Form.pendingInvoices && self.Form.pendingInvoices.length){
								for(let i=0; i<self.Form.pendingInvoices[0].transactionProducts.length; i++){
									if(itemData.transactionProductId == self.Form.pendingInvoices[0].transactionProducts[i].transactionProductId){
										if(self.Form.pendingInvoices[0].transactionProducts[i].batches && self.Form.pendingInvoices[0].transactionProducts[i].batches.length){
											for(let j=0; j<self.Form.pendingInvoices[0].transactionProducts[i].batches.length; j++){
												for(let k=0; k<itemData.batches.length; k++){
													if(self.Form.pendingInvoices[0].transactionProducts[i].batches[j].batchId == itemData.batches[k].batchId){
														self.Form.pendingInvoices[0].transactionProducts[i].batches[j].billQty = itemData.batches[k].billQty;
													}
												}
											}
										}
									}
								}
							}
						}, 
						onError: function(error){
							console.log(error);
						}
					});
				// }
				// else{
				// 	return;
				// }

				},

			fn_refreshAddons: function (itemData) {

      			let defaultAddons = this.Form.productDataModel.addOnsItems;

      			for(let i=0; i<defaultAddons.length; i++){

      				let shared = false;

      				for(let j=0; j<itemData.addOnsItems.length; j++){
      					if (itemData.addOnsItems[j].addOnsId == defaultAddons[i].addOnsId) {
				   			defaultAddons[i].percentage = itemData.addOnsItems[j].percentage;
				   			defaultAddons[i].value = itemData.addOnsItems[j].value;

				   			if(this.Form.transactionData.transactionId){
				   				defaultAddons[i].transactionProductsAddOnsId = itemData.addOnsItems[j].transactionProductsAddOnsId;
				   			}

				   			shared = true;
				           	break;
				       }
      				}

      				if(!shared){
      					defaultAddons[i].percentage = null;
				   		defaultAddons[i].value = null;
      				}

      			}

				this.fn_addItem();
			},

			fn_removeItem: function (item_groupId, item_category, item_groupIndex, item_baseTransactionNumber) {
				let groupId = item_groupId;
				let category = item_category;
				let groupIndex = item_groupIndex;
				let baseTransactionNumber = item_baseTransactionNumber;

				// when deleting item directly from dialog
				if(!item_groupId){
					groupId = this.Form.removeItemParams.groupId;
					category = this.Form.removeItemParams.category;
					groupIndex = this.Form.removeItemParams.groupIndex;
					baseTransactionNumber = this.Form.removeItemParams.baseTransactionNumber;
				}

				let itemIndex = this.Form.items.findIndex(item=>{
					return item.groupId == groupId;
				});
				this.Form.items.splice(itemIndex, 1);

				// when deleting item directly from dialog
				if(!item_groupId){
					this.fn_closeDialog();
					this.showToast("Item removed");
				}

				if(category=='order' || category=='challan' || category=='invoice'){

					if(category=='order'){
						this.fn_removeFromPendingItemslist(this.Form.pendingOrders, groupId, baseTransactionNumber);
					}
					else if(category=='challan'){
						this.fn_removeFromPendingItemslist(this.Form.pendingChallans, groupId, baseTransactionNumber);	
					}
					else if(category=='invoice'){
						this.fn_removeFromPendingItemslist(this.Form.pendingInvoices, groupId, baseTransactionNumber);	
					}
					
					if(!this.filteredItems[category][groupIndex].items.length){
						this.fn_removeGroup(category, baseTransactionNumber);
					}
				}
			},

			fn_removeFromPendingItemslist: function (pendingItems, groupId, baseTransactionNumber) {
				let transactionIndex = pendingItems.findIndex(item=>{
					return item.baseTransactionNumber == baseTransactionNumber;
				});

				let pItemIndex = pendingItems[transactionIndex].transactionProducts.findIndex(item=>{
					return item.groupId == groupId;
				});

				pendingItems[transactionIndex].transactionProducts.splice(pItemIndex, 1);
			},

			fn_removeGroup: function (category, baseTransactionNumber) {
				let baseTransactionListId = null;
				let itemIndex = null;
				let removedTransactionId = null;

				if(category=='order'){

					baseTransactionListId = transactionTypes.purchaseOrder.id;

					itemIndex = this.Form.pendingOrders.findIndex(item=>{
						return item.baseTransactionNumber == baseTransactionNumber;
					});

					removedTransactionId = this.Form.pendingOrders[itemIndex].transactionId;

					this.Form.pendingOrders.splice(itemIndex, 1);

				}
				else if(category == 'challan'){

					baseTransactionListId = transactionTypes.purchaseChallan.id;

					itemIndex = this.Form.pendingChallans.findIndex(item=>{
						return item.baseTransactionNumber == baseTransactionNumber;
					});

					removedTransactionId = this.Form.pendingChallans[itemIndex].transactionId;

					this.Form.pendingChallans.splice(itemIndex, 1);

				}
				else if(category == 'invoice'){

					baseTransactionListId = transactionTypes.purchaseInvoice.id;

					itemIndex = this.Form.pendingInvoices.findIndex(item=>{
						return item.baseTransactionNumber == baseTransactionNumber;
					});

					removedTransactionId = this.Form.pendingInvoices[itemIndex].transactionId;

					this.Form.pendingInvoices.splice(itemIndex, 1);

				}

				this.Form.items = this.Form.items.filter(item => {
					return !(item.baseTransactionListId == baseTransactionListId && item.baseTransactionNumber == baseTransactionNumber);
				});
			},

			fn_saveTdsDetails: function (data) {
				data.transactionTdsId = this.guid();
				this.Form.tdsDetails = JSON.parse(JSON.stringify(data));
				this.fn_closeDialog();
			},

			fn_removeTds: function(){
				this.Form.tdsDetails = {"amount":null};
				this.fn_closeDialog();
			},

			fn_updateSupplier: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.partyId = selectedValueId;
		        	this.Form.partyName = selectedValueName;
		        	this.fn_getPartyDetails(selectedValueId, true);

		        	if(this.Form.transactionTypeData){
		        		this.fn_validateParty(this.Form.transactionTypeData.transactionParties);
		        	}

		        	this.$forceUpdate();
		        	this.errors.remove('supplier');
				}
				else{
					this.Form.partyId = null;
		        	this.Form.partyName = null;
				}
			},

			fn_getPartyDetails: function (partyId, bindPlaceofSupply) {
				var self = this;
		  		this.getData('Ledger', partyId, 
					{
						onSuccess: function(response){

				            console.log(response);

					        // let partyDetails = JSON.parse(response);
					        self.Form.partyDetails = JSON.parse(response);

					        // self.Form.partyGstType = partyDetails.gstType;

					        if(bindPlaceofSupply){
					        	let placeOfSupplyId = self.Form.partyDetails.placeOfSupplyId ? self.Form.partyDetails.placeOfSupplyId : self.$root.CurrentBusiness.StateID;

					        	let placeOfSupplyName = self.Form.partyDetails.placeOfSupply ? self.Form.partyDetails.placeOfSupply : self.$root.CurrentBusiness.State;

					        	if(self.Form.partyDetails.countryId && self.Form.partyDetails.country){
					        		placeOfSupplyId = null;
					        		placeOfSupplyName = null;
					        	}

					        	self.Form.placeOfSupplyCountryId = self.Form.partyDetails.countryId;
					        	self.Form.placeOfSupplyCountryName = self.Form.partyDetails.country;

					        	self.fn_updateState(placeOfSupplyId, placeOfSupplyName, false);

					        }


					        self.Form.partyDetails.lastConfig ? self.Form.partyLastConfig = JSON.parse(self.Form.partyDetails.lastConfig) : '';

					        if(self.Form.partyLastConfig && self.Form.partyLastConfig.purchase){
					        	self.Form.taxMode = self.Form.partyLastConfig.purchase.taxMode;
					        }

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getDefaultGstAddOns: function () {
				let self = this;
				this.Form.defaultTaxAddOns = [];

				for(let key in fixedGstAddOns){
					(function (itemId) {
				  		self.getData('AddOns', itemId, 
							{
								onSuccess: function(response){
						          console.log(response);

						          let itemIndex = self.Form.defaultTaxAddOns.findIndex(item=>{
						          	return item.addOnsId == itemId;
						          });

						          if(itemIndex==-1){
						          	self.unwatch = true;
						          	self.Form.defaultTaxAddOns.push(JSON.parse(response));
						          }

						        }, 
						        onError: function(error){
						          console.log(error);
						        }
							}
				        );
					}(fixedGstAddOns[key].id));
				}
			},

			fn_getDefaultCessAddOns: function () {
				let self = this;

				self.getData('AddOns', fixedCessAddOns.CESS.id, {

					onSuccess: function(response){
			          console.log(response);
			          self.unwatch = true;
			          self.Form.cessAddOns = JSON.parse(response);

			        }, 
			        onError: function(error){
			          console.log(error);
			        }
				});
			},

			fn_bindGstAddOns: function () {

				let self = this;
				this.Form.gstAddOns = [];

				this.Form.defaultTaxAddOns.forEach(function (addOnsItem, index) {

					let taxAddOnsItem = JSON.parse(JSON.stringify(addOnsItem));
								
					taxAddOnsItem.percentage = 0;
      				taxAddOnsItem.value = 0;

      				if(self.Form.gstType == 'IntraState' && 
      					(fixedGstAddOns.CGST.id == taxAddOnsItem.addOnsId || fixedGstAddOns.SGST.id == taxAddOnsItem.addOnsId))
      				{
      					self.Form.gstAddOns.push(taxAddOnsItem);
      				}
      				else if(self.Form.gstType == 'InterState' && fixedGstAddOns.IGST.id == taxAddOnsItem.addOnsId){
      					self.Form.gstAddOns.push(taxAddOnsItem);
      				}
      				else if(self.Form.gstType == 'UnionTerritory' &&
      					(fixedGstAddOns.CGST.id == taxAddOnsItem.addOnsId || fixedGstAddOns.UTGST.id == taxAddOnsItem.addOnsId)){
      					self.Form.gstAddOns.push(taxAddOnsItem);
      				}
				});

				if(this.Form.items.length){
					this.fn_calculateTax();
				}
			},

			// fn_checkTransactionType: function (item) {
			// 	if(this.Form.transactionAddOns.length || this.Form.items.length || this.Form.customFields.length){
			// 		let msg = "In case of transaction type change, <b>Discounts/Taxes/Other Charges</b> and other details may change or remove."
			// 		this.fn_openConfirmationDialog(msg);
			// 	}
			// 	else{
			// 		this.fn_openTransactionTypeList();
			// 	}
			// },

			fn_setTransactionType: function (item, openParty) {
				let self = this;
				
				let transactionTypeSelected = this.Form.transactionTypeFormId ?  true : false;
				// this.loading = true;
				if(this.Form.transactionTypeFormId != item.transactionTypeFormId){

					// this.Form.items.forEach(function (itemData) {
					// 	itemData.addOnsItems = [];
					// 	(function (itemData) {
					// 		itemData.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(itemData);
					// 	}(itemData));
					// });

					// !dont remove as will be useful if transaction form open for user
					// this.Form.dynamicFields = {"section":null, "items":[], "accountGroupId":null, "accountGroupName":null};
					// this.Form.dynamicFieldsAdditionalData = {};
					// this.Form.customFields = [];
					// this.Form.dynamicMenuItems = [];
					this.Form.dynamicFields = {"section":null, "items":[], "accountGroupId":null, "accountGroupName":null};
					this.Form.dynamicFieldsAdditionalData = {};
					this.Form.customFields = [];
					this.Form.dynamicMenuItems = [];

					this.fn_getTransactionTypeData(item.transactionTypeFormId, null, true);
				}

				this.Form.transactionTypeFormId = item.transactionTypeFormId;
				this.Form.transactionTypeFormName = item.name;

				localStorage.setItem(this.settings.transactionTypeId, item.transactionTypeFormId);

				// this.errors.remove('transactionType');
				this.$forceUpdate();
				this.fn_closeDialog();

				if(!this.$route.query.loadItems){
					if(!transactionTypeSelected && this.Form.draftItems && this.Form.draftItems.length){
						this.loading = false;
						this.fn_openDialogDraftItems();
					}
					else if(!this.$root.CurrentBusiness.DataDrive && this.Form.isNew){
						this.fn_checkTransactionCount(()=>{
							if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
								this.fn_openDialogDriveSetup();
							}
						})
					}
					else{
						//transacion mixin function
						!this.Form.partyName ? this.fn_openParties_onFormLoad(openParty, this.fn_openSuppliers) : '';
					}
				}
				
				// this.fn_openParties_onFormLoad(openParty, this.fn_openSuppliers);

				// setTimeout(function(){

				// 	(openParty && !self.$route.query.dt) || !self.Form.partyId ? self.fn_openSuppliers() : '';
				// },500)
			},

			//updateNS = update number series
			fn_getTransactionTypeData: function(itemId, callback, updateNS, callingFrom){
				// this.showLoading('Please wait...');
				// this.loading = true;
				var self = this;
				// let transactionDate = this.Form.transactionData.transactionDate ? this.Form.transactionData.transactionDate : new Date();
				let transactionDate = this.Form.transactionData.transactionDate ? this.Form.transactionData.transactionDate : this.$root.fn_getLocalDateFormat();
				let filterObject = {};
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(transactionDate));
				this.getFilterData('TransactionTypeForm', itemId, filterObject,
					{
						onSuccess: function(response){
					        console.log(response);
					        self.Form.transactionTypeData = JSON.parse(response);

					        self.Form.transactionData.paymentMode = self.Form.transactionTypeData.paymentMode;

					         if(self.Form.transactionData.paymentMode == 1){
					        	self.fn_getPaymentGroups();
					        }
					        else{
					        	self.Form.splitPayment = false;
					        }

					        if(callingFrom == 'draft'){
					        	//refereshing transactiontype data if form is loaded from draft
					          	self.fn_refreshTransactionTypeData(self.Form.transactionTypeData);
					        }
					        else{
								self.Form.items.forEach(function (itemData) {
									// removing addons if transaction type change
									if(itemData.addOnsItems && itemData.addOnsItems.length){
										itemData.addOnsItems = [];
									}

									if(updateNS && itemData.customFields && itemData.customFields.items && itemData.customFields.items.length){
										itemData.customFields = null;
										self.Form.dynamicItemSection = [];
										self.Form.itemSectionAndFields = null;
									}
								})
					        	self.fn_bindTransactionTypeData(callback, updateNS);
					        }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			//updateNS = update number series

			fn_bindTransactionTypeData: function (callback, updateNS) {
				
				updateNS && this.Form.isNew ? this.fn_bindTransactionNumber() : '';

				// this.fn_bindTransactionTypeAddOns(true, callback);

				this.fn_bindTransactionTypeAddOns(true);

				if(this.Form.partyId && this.Form.isNew){
					this.fn_validateParty(this.Form.transactionTypeData.transactionParties);
				}

				this.Form.dynamicMenuItems = [];

				let self = this;
				if(this.Form.transactionTypeData && this.Form.transactionTypeData.transactionSections.length){
					this.Form.transactionTypeData.transactionSections.forEach(function (item) {
						let obj = {};
						obj.MenuID = null;
						obj.Icon = null;
						obj.Text = item.sectionName;
						obj.Action = 'section_'+item.sectionId;
						obj.sectionId = item.sectionId;
						obj.hideOption = false;
						self.Form.dynamicMenuItems.push(obj);
					});
				}

				//inserting eway bill details to transaction type fields manually
				//inserting eway bill details to transaction type fields manually
				this.fn_bindEwayBillSection();

				if(updateNS && this.Form.customFields.length){
					this.Form.dynamicMenuItems.length ? this.fn_bindCustomFieldValues() : this.Form.customFields = [];
				}
				/*if(this.settings.transactionTypeId != transactionTypes.purchaseOrder.id){
					this.Form.transactionTypeData.transactionSections.push(this.ewayBillDetailSection);

					!this.Form.transactionTypeData.transactionTypeFields.length ? this.Form.transactionTypeData.transactionTypeFields = [] : '';

					for(let i=0; i<this.ewayBillDetailFields.length; i++){
						this.Form.transactionTypeData.transactionTypeFields.push(this.ewayBillDetailFields[i]);
					}
				}
				else{
					this.Form.hideEwayOption = true;
				}*/

				// callback != undefined ? callback(1) : '';

				if(callback != undefined){
					callback(1);
				}
				else{
					setTimeout(function(){
						self.$root.fn_copyFormObject(self.Form, self.formId);
					},500);
				}

				this.fn_getItemDetailFields(this.Form.transactionTypeData.transactionTypeFormId);

				// this.hideLoading();
				this.loading = false;
			},

			fn_bindEwayBillSection: function(){
				if(this.settings.transactionTypeId != transactionTypes.purchaseOrder.id){
					this.Form.transactionTypeData.transactionSections.push(this.ewayBillDetailSection);

					!this.Form.transactionTypeData.transactionTypeFields.length ? this.Form.transactionTypeData.transactionTypeFields = [] : '';

					for(let i=0; i<this.ewayBillDetailFields.length; i++){
						this.Form.transactionTypeData.transactionTypeFields.push(this.ewayBillDetailFields[i]);
					}
				}
				else{
					this.Form.hideEwayOption = true;
				}
			},

			fn_bindCustomFieldValues: function(){
				for(let i=0; i<this.Form.customFields.length; i++){

					// updating section key values on transaction type form change
					let customFieldItem = this.Form.customFields[i];
					customFieldItem.section.transactionTypeFormId = this.Form.transactionTypeData.transactionTypeFormId;
					for(let j=0; j<this.Form.transactionTypeData.transactionSections.length; j++){
						if(customFieldItem.section.sectionName == this.Form.transactionTypeData.transactionSections[j].sectionName){
							customFieldItem.section.sectionId = this.Form.transactionTypeData.transactionSections[j].sectionId;
						}
					}

					// updating section fields key values on transaction type form change
					for(let k=0; k<customFieldItem.items.length; k++){
						let fieldItem = customFieldItem.items[k];
						fieldItem.transactionTypeFormId = this.Form.transactionTypeData.transactionTypeFormId;
						for(let l=0; l<this.Form.transactionTypeData.transactionTypeFields.length; l++){

							if(fieldItem.fieldId == this.Form.transactionTypeData.transactionTypeFields[l].fieldId){
								fieldItem.sectionId = customFieldItem.section.sectionId;
								fieldItem.transactionTypeFieldId = this.Form.transactionTypeData.transactionTypeFields[l].transactionTypeFieldId;
							}
							
						}	
					}

					// hiding dynamic menu option if custom field exist on transaction type form change
					for(let m=0; m<this.Form.dynamicMenuItems.length; m++){
						if(customFieldItem.section.sectionId == this.Form.dynamicMenuItems[m].sectionId){
							this.Form.dynamicMenuItems[m].hideOption = true;
						}
					}
				}
				
			},

			// fn_bindTransactionNumber: function () {

			// 	this.transactionNumberSnackbar = false;

			// 	let numberSeriesData = this.Form.transactionTypeData.numberSeries;

			// 	this.Form.transactionData.prefix = numberSeriesData.prefix;
			// 	this.Form.transactionData.suffix = numberSeriesData.suffix;

			// 	//For reference use only as incrementing transaction number by numberSeries id in transaction number
			// 	this.Form.transactionData.numberSeriesId = numberSeriesData.numberSeriesId;

			// 	this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId

			// 	let self = this;

			// 	// this.getData('TransactionNumber', numberSeriesData.numberSeriesId, 
			// 	this.getData('TransactionNumber', numberSeriesData.transactionNumberId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let data = JSON.parse(response);
			// 				self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
			// 				self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	        }
			// 		}
		 //        );
				
			// },

			fn_bindTransactionNumber: function () {

				if(!this.Form.transactionTypeData){
					return;
				}

				this.transactionNumberSnackbar = false;

				let numberSeriesData = this.Form.transactionTypeData.numberSeries;

				// this.Form.transactionData.prefix = numberSeriesData.prefix;
				// if(this.$refs['ref_dialogNumberSeries'] && this.$refs['ref_dialogNumberSeries'].prefix){
				// 	this.Form.transactionData.prefix = this.$refs['ref_dialogNumberSeries'].prefix;
				// }
				// else{
				// 	this.Form.transactionData.prefix = numberSeriesData.otherPrefix ? numberSeriesData.otherPrefix : numberSeriesData.prefix;
				// 	this.Form.transactionData.suffix = numberSeriesData.suffix;
				// }
				this.Form.transactionData.prefix = numberSeriesData.otherPrefix !== null ? numberSeriesData.otherPrefix : numberSeriesData.prefix;
				this.Form.transactionData.suffix = numberSeriesData.suffix;

				//For reference use only as incrementing transaction number by numberSeries id in transaction number
				this.Form.transactionData.numberSeriesId = numberSeriesData.numberSeriesId;

				// this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId;

				let filterObject = {};
				filterObject.numberSeriesId = numberSeriesData.numberSeriesId;
				// filterObject.transactionNumberId = numberSeriesData.transactionNumberId;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));

				filterObject.typeId = this.settings.transactionTypeId;

				let self = this;

				this.getFilterData('TransactionNumber', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
							self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
							self.Form.transactionData.transactionNumberId = data.transactionNumberId;
							if(self.$root.appVersion >= 136){
								self.Form.transactionData.prefix = data.otherPrefix !== null ? data.otherPrefix : data.prefix;
							}
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
				
			},

			// fn_bindTransactionTypeAddOns: function (bindAll, callback) {
			fn_bindTransactionTypeAddOns: function (bindAll) {
				let self = this;
				let tempAddOns = null;

				if(bindAll){
					this.Form.productDataModel.addOnsItems = [];
					// !dont remove as will be useful if transaction form open for user
					// this.Form.transactionAddOns = [];
				}

				this.Form.transactionTypeData.transactionTypeAddOns.forEach(function (item) {

					if(item.type==0){

						if(bindAll){
							self.Form.items.forEach(function (itemData) {

								itemData.addOnsItems.push(JSON.parse(JSON.stringify(item)));

								(function (itemData) {
									itemData.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(itemData);
								}(itemData));

							});
						}

	          			self.Form.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
					}
					else if(item.type==1 && bindAll){
						let addOnsData = JSON.parse(JSON.stringify(item));
						addOnsData.transactionAddOnsId = self.guid();
						addOnsData.isDefault = true;
						self.Form.transactionAddOns.push(addOnsData);
					}
	          	});

				// callback != undefined ? callback(1) : '';
			},

			fn_validateParty: function (partyGroups) {
				if(!partyGroups && !this.Form.transactionTypeData.importExportTransactionAccountId){
					return
				}

				let filterObject = {};
				filterObject.accountGroups = null;
				filterObject.accountGstTypes = null;

				if(partyGroups && partyGroups.length){
					filterObject.accountGroups = [];
					partyGroups.forEach(function (item) {
						filterObject.accountGroups.push(item.accountGroupId);
					});
				}

				if(this.Form.transactionTypeData.importExport && this.Form.transactionTypeData.importExportTransactionAccountId){
					filterObject.accountGstTypes = [accountGstType.overseas.id, accountGstType.sez.id];
				}
				else{
					filterObject.accountGstTypes = [accountGstType.registered.id, accountGstType.composition.id, accountGstType.unregistered.id, accountGstType.consumer.id, accountGstType.deemed.id];
				}

				let self = this;
				this.getFilterData('ValidateParty', this.Form.partyId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							self.isPartyValid = JSON.parse(response);
							if(!self.isPartyValid){
								self.Form.partyId = null;
								self.Form.partyName = null;
								self.Form.placeOfSupplyId = null;
								self.Form.placeOfSupplyName = null;
								self.Form.placeOfSupplyCountryId = null;
								self.Form.placeOfSupplyCountryName = null;
								self.Form.partyDetails = null;
								self.showToast("Ledger created is not a Supplier");
							}
							else{
								if(self.Form.isNew && (self.Form.transactionData.transactionListId != transactionTypes.purchaseOrder.id)){
									self.fn_checkPendingItemsCount();
								}
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_openDialogPendingSheet: function(){
				this.fn_openDialogWeb('web', 'PendingSheet', 'ref_pendingSheet');
			},

			fn_checkPendingItemsCount: function (callType) {

				if(this.$root.appVersion < 109){
					if(callType == 2){
						this.fn_getBottomMenu();
					}
					return;
				}

				let filterObject = {};

				filterObject.formTransactionListId = [transactionTypes.purchaseChallan.id, transactionTypes.purchaseInvoice.id];

				if(this.Form.transactionData.transactionListId == transactionTypes.purchaseChallan.id){
					filterObject.transactionListId = [transactionTypes.purchaseOrder.id];	
				}
				else if(this.Form.transactionData.transactionListId == transactionTypes.purchaseInvoice.id){
					filterObject.transactionListId = [transactionTypes.purchaseOrder.id, transactionTypes.purchaseChallan.id];	
				}
				else if(this.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id){
					filterObject.transactionListId = [transactionTypes.purchaseInvoice.id];	
					filterObject.formTransactionListId = [transactionTypes.purchaseReturn.id];
				}

				let self = this;
				this.getFilterData('PendingItemsCount', self.Form.partyId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							self.Form.pendingOrderAndChallan = JSON.parse(response);
							if(!callType && self.Form.pendingOrderAndChallan && Object.keys(self.Form.pendingOrderAndChallan).length){
								self.Form.pendingCount = 0;
								for (const key in self.Form.pendingOrderAndChallan) {
									self.Form.pendingCount = self.Form.pendingCount + Number(self.Form.pendingOrderAndChallan[key]);
								}
							}

							if(!self.Form.pendingOrderAndChallan || !Object.keys(self.Form.pendingOrderAndChallan).length){
								self.Form.pendingCount = 0;
							}

							// if(callType){
							// 	self.fn_openDialogPendingSheet();
							// }
							if(callType){
								// calltype 2 is from triple dots to open bottom sheet always
								if(Object.keys(self.Form.pendingOrderAndChallan).length > 1 || callType == 2){
									self.fn_openDialogPendingSheet();
								}
								else{
									if(Object.keys(self.Form.pendingOrderAndChallan)[0] == transactionTypes.purchaseOrder.id){
										self.fn_menuItemClick(null, null, 'loadpurchaseorder');
									}
									else if(Object.keys(self.Form.pendingOrderAndChallan)[0] == transactionTypes.purchaseChallan.id){
										self.fn_menuItemClick(null, null, 'loadpurchasechallan');
									}
								}
							}
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_getPendingAlertMsg: function(){
				if(this.Form.pendingOrderAndChallan && Object.keys(this.Form.pendingOrderAndChallan).length){
					if(Object.keys(this.Form.pendingOrderAndChallan).length > 1){
						return "Purchase Orders/Challans are pending.";
					}
					else{
						if(Object.keys(this.Form.pendingOrderAndChallan)[0] == transactionTypes.purchaseOrder.id){
							return this.Form.pendingOrderAndChallan[transactionTypes.order.id] > 1 ? "Purchase Orders are pending." : "Purchase Order is pending.";
						}
						else if(Object.keys(this.Form.pendingOrderAndChallan)[0] == transactionTypes.purchaseChallan.id){
							return this.Form.pendingOrderAndChallan[transactionTypes.deliveryChallan.id] > 1 ? "Purchase Challans are pending." : "Purchase Challan is pending.";
						}
					}
				}
			},

			fn_loadItems: function (transactionListId, pendingItemsData, ref) {

				if(!this.Form.partyId){
					this.showToast("Select party");
					return;
				}

				let filterObject = {};

				if(ref == "ref_dialogOrders"){
					filterObject.formTransactionListId = [transactionTypes.purchaseChallan.id, transactionTypes.purchaseInvoice.id]
				}
				else{
					filterObject.formTransactionListId = [this.Form.transactionData.transactionListId];
				}

				filterObject.transactionListId = [transactionListId];

				let self = this;
				this.getFilterData('PendingItems', self.Form.partyId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let items = JSON.parse(response);

							self.Form.pendingItemsList = items.filter(item=>{

								item.selected = false;

								for(let i=0; i<pendingItemsData.length; i++){
									if(item.transactionId == pendingItemsData[i].transactionId){
										item.selected = true;
										self.$forceUpdate();
										break;
									}
								}
								
								return true;
							});

							self.fn_openDialogPendingItemsList(ref);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getPendingItems: function (transactionIds, type) {
				let self = this;

				let filterObject = {};
				filterObject.transactionIds = transactionIds;

				
				this.getFilterData('PendingItemsData', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);

							if(type=='orders'){

								self.Form.pendingOrders = JSON.parse(response);
								self.fn_bindPendingItems(self.Form.pendingOrders, type);
								// if(self.$root.TransactionSettings.enableBatch){
								// 	self.showToast("Add batches to product");
								// }
							}
							else if(type=='challans'){

								self.Form.pendingChallans = JSON.parse(response);
								self.fn_bindPendingItems(self.Form.pendingChallans, type);
							}
							else if(type=='invoices'){

								self.Form.pendingInvoices = JSON.parse(response);
								self.fn_bindPendingItems(self.Form.pendingInvoices, type);
							}

							if(self.$root.TransactionSettings.enableBatch && type=='orders'){
								self.confirmationHeader = "Add batches";
								self.confirmationMessage = "<div>Consider adding batches into items<div><ul><li>Edit Item</li><li>Add/Select Batch</li></ul>"
								self.confirmationAction = self.fn_closeDialog;
								self.fn_openDialogWeb('web', 'confirmationDialog', 'ref_dialogConfirmation');
							}

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_checkPendingTransaction: function(transactionIds, callback){
				let self = this;

				let filterObject = {};
				//draft last modifiedDate
				filterObject.transactionIds = transactionIds;
				filterObject.startDate = this.draftModifiedDate;
				
				this.getFilterData('CheckPendingTransaction', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							//if draft modifiedDate is less than entry date
							callback(JSON.parse(response));
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindPendingItems: function (pendingItems, type) {

				// checking only first item for isRounded flag and applying in current form
				if(!this.Form.isRounded && pendingItems[0].isRounded){
					this.Form.isRounded = true;
				}

				if(pendingItems[0].roundOffValue){
					this.Form.roundOffValue = pendingItems[0].roundOffValue;
				}

				let self = this;

				self.fn_closeDialog();

				pendingItems.forEach(function (pendingItem) {

					pendingItem.transactionProducts.forEach(function (itemData) {

						// generating new transactionProductId for each pendingItem
						// and
						// assigning refTId and RefTpId
						itemData.productVariants.forEach(function(vItem){
							vItem.refTId = vItem.transactionId;
							vItem.refTpId = vItem.transactionProductId;
							vItem.transactionProductId = self.guid();

							if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
								if(itemData.transactionProductBatches && itemData.transactionProductBatches.length){
									for(let i=0; i<itemData.transactionProductBatches.length; i++){
										if(itemData.transactionProductBatches[i].refTpBatchId){
											itemData.transactionProductBatches[i].refTpBatchId = null;
										}
									}
								}
							}

							if(itemData.transactionProductBatches && itemData.transactionProductBatches.length){
								for(let i=0; i<itemData.transactionProductBatches.length; i++){
									if(itemData.transactionProductBatches[i].transactionProductBatchId){
										itemData.transactionProductBatches[i].refTransactionProductBatchId = itemData.transactionProductBatches[i].transactionProductBatchId;
										itemData.transactionProductBatches[i].transactionProductBatchId = null;
									}
								}
							}

							if(vItem.secondaryUnitId){
								vItem.selectedUnit = {};
								vItem.selectedUnit.itemId = vItem.unitId;
								vItem.selectedUnit.itemName = vItem.unitName;

								if(vItem.unitId == vItem.secondaryUnitId){
									vItem.qty = self.roundUpto2Decimals((vItem.qty * vItem.secondaryUnitPackQuantity) / vItem.packQuantity);
									if(itemData.transactionProductBatches && itemData.transactionProductBatches.length){
										for(let i=0; i<itemData.transactionProductBatches.length; i++){
											itemData.transactionProductBatches[i].qty = self.roundUpto2Decimals((itemData.transactionProductBatches[i].qty * vItem.secondaryUnitPackQuantity) / vItem.packQuantity);
										}
									}
								}
								else{
									vItem.qty = self.roundUpto2Decimals(vItem.qty);
									if(itemData.transactionProductBatches && itemData.transactionProductBatches.length){
										for(let i=0; i<itemData.transactionProductBatches.length; i++){
											itemData.transactionProductBatches[i].qty = self.roundUpto2Decimals(itemData.transactionProductBatches[i].qty);
										}
									}
								}
								// else{
								// 	vItem.qty = self.roundUpto2Decimals((vItem.qty * vItem.packQuantity) / vItem.secondaryUnitPackQuantity);
								// }
							}
						});

						itemData.taxValue = 0;
						itemData.taxAmount = 0;
						// itemData.hsnCode = null;

						itemData.cessValue = null;
						itemData.cessAmount = 0;
						itemData.cessValueOnQuantity = null;

						let tValue = 0;
						let tAmount = 0;

						if(pendingItem.taxMode){

							itemData.transactionProductAddOns.filter(addOnsItem=>{

								addOnsItem.mode == 1 ? addOnsItem.percentage = null : '';

								if(addOnsItem.isGst==1){
									// itemData.taxValue += addOnsItem.percentage;
									// itemData.taxAmount += addOnsItem.value;
									tValue += addOnsItem.percentage;
									tAmount += addOnsItem.value;
									// itemData.hsnCode = addOnsItem.hsnCode;
								}
								else if(addOnsItem.isGst==2){
									if(addOnsItem.cessValueOnQuantity){
										itemData.cessValueOnQuantity = addOnsItem.cessValueOnQuantity;
										itemData.cessAmount = addOnsItem.value;
									}
									else{
										itemData.cessValue = addOnsItem.percentage != null ? addOnsItem.percentage : null;
										itemData.cessAmount = addOnsItem.value;
									}
									// itemData.hsnCode = addOnsItem.hsnCode;
								}

							});

							itemData.taxValue = self.roundUpto2Decimals(tValue);
							itemData.taxAmount = self.roundUpto2Decimals(tAmount);
						}

						
						let addOns = null;

						itemData.addOnsItems = [];

						self.Form.productDataModel.addOnsItems.forEach(function (defaultAddOns) {

							let itemIndex = itemData.transactionProductAddOns.findIndex(item=>{
								return defaultAddOns.addOnsId == item.addOnsId;
							});

							if(itemIndex!=-1){
								addOns = JSON.parse(JSON.stringify(itemData.transactionProductAddOns[itemIndex]));
								addOns.appliedOn = defaultAddOns.appliedOn;
								addOns.adjustInTotal = defaultAddOns.adjustInTotal;
							}
							else{
								addOns = JSON.parse(JSON.stringify(defaultAddOns));
							}

							addOns ? itemData.addOnsItems.push(addOns) : '';
							
						});

						// if(itemData.transactionProductBatches && itemData.transactionProductBatches.length){
						// 	for(let i=0; i<itemData.transactionProductBatches.length; i++){
						// 		itemData.transactionProductBatches[i].productQty = itemData.transactionProductBatches[i].qty;
						// 	}
						// 	itemData.batches = itemData.transactionProductBatches;
						// }

						if(type == 'challans'){
							itemData.productVariants[0].billQty = itemData.productVariants[0].qty;
						}
						
						if(itemData.transactionProductBatches && itemData.transactionProductBatches.length){
							itemData.batches = [];
							for(let i=0; i<itemData.transactionProductBatches.length; i++){
								if(itemData.transactionProductBatches[i].qty){
									itemData.transactionProductBatches[i].productQty = self.roundUpto2Decimals(itemData.transactionProductBatches[i].qty);
									if(type == 'challans' || type == 'invoices'){
										itemData.transactionProductBatches[i].selected = false;
										itemData.transactionProductBatches[i].billQty = self.roundUpto2Decimals(itemData.transactionProductBatches[i].qty);
									}

									if(type=='invoices'){
										itemData.transactionProductBatches[i].productQty = null;
									}
									itemData.batches.push(itemData.transactionProductBatches[i]);
								}
								
							}
						}
						
					});

					if(type!='invoices'){
						(function (pendingItem) {
							self.fn_addPendingItems(pendingItem.transactionProducts, pendingItem.transactionAddOns, null, pendingItems[0].transactionDate);
						}(pendingItem));
					}
				});

				if(type=='invoices'){
					this.fn_editLoadedItems(pendingItems[0].transactionProducts);
				}
			},

			fn_addPendingItems: function (transactionProducts, transactionAddOns, type, pendingTransactionDate) {
				let self = this;

				if(type=='invioceItems'){
					//this step will remove all the items from the item list who belongs to invoice as we will add fresh items to it after selection.
					self.Form.items = self.Form.items.filter(item=>{
						return item.baseTransactionListId != transactionTypes.purchaseInvoice.id;
					});
				}

				transactionProducts.forEach(function (tItem) {

					let itemIndex = self.Form.items.findIndex(item=>{
						return item.groupId == tItem.groupId;
					});

					if(itemIndex!=-1)
						self.Form.items.splice(itemIndex, 1, tItem);
					else
						self.Form.items.push(tItem);

					if(tItem.batches && tItem.batches.length){
						let qty = 0;
						if(tItem.groupId == self.Form.productDataModel.groupId){
							self.Form.productDataModel.batches = JSON.parse(JSON.stringify(tItem.batches));
							for(let j=0; j<self.Form.productDataModel.batches.length; j++){
								qty = qty + Number(self.Form.productDataModel.batches[j].productQty);
							}
							self.Form.productDataModel.productVariants[0].qty = qty;
						}
					}
				});
				
				self.fn_calculateTax(true);

				transactionAddOns && transactionAddOns.length ? this.fn_addPendingAddOns(transactionAddOns, type) : '';

				if(type=="invioceItems"){
					this.fn_closeDialog();
				}

				let tDay = new Date(pendingTransactionDate).getDate();
				let tMonth = new Date(pendingTransactionDate).getMonth() + 1;
				let tYear = new Date(pendingTransactionDate).getFullYear();

				if(this.fn_isNewTaxForm() && new Date(tMonth + '/' + tDay + '/' + tYear) < new Date('09/22/2025')){
					this.snackbarTaxCategory = true;
				}
			},

			fn_addPendingAddOns: function (transactionAddOns, type) {
				//appending transaction addons of orders or challans
				let self = this;

				transactionAddOns.forEach(function (item) {

					let itemCopy = JSON.parse(JSON.stringify(item));
					itemCopy.percentage = null;
					itemCopy.transactionAddOnsId = self.guid();

					let sharedItem = false;

					for(let i=0; i<self.Form.transactionAddOns.length; i++){
						if(self.Form.transactionAddOns[i].addOnsId == itemCopy.addOnsId && self.Form.transactionAddOns[i].transactionId){
							self.Form.transactionAddOns[i].percentage = null;

							let value = self.roundUpto2Decimals(self.Form.transactionAddOns[i].value + itemCopy.value);
							self.Form.transactionAddOns[i].value = value;
							sharedItem = true;
						}
					}

					if(!sharedItem){
						self.Form.transactionAddOns.push(itemCopy);
					}

				});
			},

			fn_editLoadedItems: function (transactionProducts) {
				//updating items return qty for dialog_item_selection

				this.Form.items.forEach(function (item) {

					let tProduct = transactionProducts.find(tItem=>{
						return tItem.groupId == item.groupId;;
					});

					if(tProduct){

						tProduct.productVariants.forEach(function (tVariant) {
						
							item.productVariants.forEach(function (variant) {
								
								if(tVariant.productVariantId == variant.productVariantId){
									tVariant.returnQty = variant.qty;
								}

							});

						});

					}
					

					
				});

				this.fn_openDialogReturnForm('ref_dialogReturnForm');
			},

			fn_getBottomMenu: function (tagId) {

				let menuItems = [];

				// !this.Form.isNew ? menuItems.unshift(menuItem.cancelTransaction) : '';

				
				if(!this.Form.isPendingItems){

					if(this.Form.transactionData.transactionListId == transactionTypes.purchaseChallan.id){
						menuItems.push(menuItem.loadPurchaseOrder);
					}
					else if(this.Form.transactionData.transactionListId == transactionTypes.purchaseInvoice.id){
						menuItems.push(menuItem.loadPurchaseOrder);
						menuItems.push(menuItem.loadPurchaseChallan);
					}
					else if(this.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id){
						menuItems.push(menuItem.loadPurchaseInvoice);
					}

				}

				// this.Form.dynamicMenuItems.forEach(function (item) {
				// 	menuItems.push(item);
				// });

				var bottomMenu = {"BottomMenu": menuItems};

				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			// fn_getBottomMenuAddOns: function () {

			// 	var bottomMenu = {"BottomMenu": [menuItem.addDiscount, menuItem.addTaxes, menuItem.addOtherCharges]};

			// 	this.setBottomMenu(null, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_getBottomMenuAttachment: function () {

				if(!this.$root.CurrentBusiness.DataDrive && this.transactionCount>=3){
					this.fn_openDialogDriveSetup();
	                // this.showToast("Set up backup drive to attach documents");
	                return;
	            }

				if(this.Form.attachments.length === 5){
					this.showToast("Maximum 5 attachments are allowed.");
					return;
				}

				var bottomMenu = {"BottomMenu": [menuItem.camera, menuItem.fileManager]};

				this.setBottomMenu(null, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_closeDialog: function (tagId) {
				// if(this.$refs['ref_dialogPermission'].dialog_permission){
				// 	this.$refs['ref_dialogPermission'].dialog_permission = false;
				// 	return;
				// }
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_calculateTax: function (updateTaxMode) {
				let self = this;
				this.Form.taxMode == 0 ? this.Form.isRcmApplicable = false : '';
				this.Form.items.forEach(function (item) {

					if(self.Form.taxMode && updateTaxMode){
						!item.taxValue ? item.taxValue = item.defaultTaxValue : '';
						//isCessApplicable is coming by using taxCategoryId saved in transactionProducts and using only to check cess is applicable or not at master level
						// Rest all default keys are coming from taxCategory table via productId saved in transactionProducts

						// !item.cessValue && item.isCessApplicable ? item.cessValue = item.defaultCessValue : '';
						if(item.isCessApplicable){
							!item.cessValue && !item.cessAmount ? item.cessValue = item.defaultCessValue : '';
						}
						

						if(!item.taxCategoryId){
							item.taxCategoryId = item.defaultTaxCategoryId;
							item.taxCategoryName = item.defaultTaxCategoryName;
						}

						// item.addOnsItems.forEach(function (addOnsItem) {
						// 	addOnsItem.hsnCode = item.defaultHsnCode;
						// });
						if(!item.hsnCode){
                            item.hsnCode = item.defaultHsnCode;
                        }
					}

					(function (item) {
						item.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(item);
					}(item))
				});
			},

			fn_checkValidations: function(){
				this.disableSaveBtn = true;
				var self = this;
				this.showLoading('Please wait...');
			    this.$validator.validateAll().then((result) => {
			        if (result) {

			        	// if(this.roundedAmount <= 0){
			        	// 	this.hideLoading();
						// 	this.showToast("Bill amount can't be zero or less then zero");
						// 	this.disableSaveBtn = false;
			        	// 	return;
			        	// }
						if(this.settings.transactionTypeId == transactionTypes.purchaseOrder.id || this.settings.transactionTypeId == transactionTypes.purchaseChallan.id){
							if(this.roundedAmount < 0){
								this.hideLoading();
								this.showToast("Bill amount can't less then zero");
								this.disableSaveBtn = false;
								return;
							}
							else if(!this.Form.items || (this.Form.items && !this.Form.items.length)){
								this.hideLoading();
								this.showToast("Add item to create "+ this.toolbarTitle);
								this.disableSaveBtn = false;
								return;
							}
						}
						else{
							if(this.roundedAmount <= 0){
								this.hideLoading();
								this.showToast("Bill amount can't be zero or less then zero");
								this.disableSaveBtn = false;
								return;
							}
						}

			        	if(this.splitPayentTotal != this.roundedAmount){
			        		this.hideLoading();
							this.showToast("Please adjust payment as per invoice total");
							this.disableSaveBtn = false;
			        		this.fn_openDialog_PaymentOptions();
			        		return
			        	}

			        	// if(!this.Form.items.length){
			        	// 	this.showToast("Please add items");
			        	// 	this.hideLoading();
			        	// 	return;
			        	// }
			        	// else if(this.roundedAmount <= 0){
			        	// 	this.showToast("Bill amount can't be zero or less then zero");
			        	// 	this.hideLoading();
			        	// 	return;
			        	// }

			        	this.fn_checkTransactionNumber(function(){
			        		self.fn_post();
			        	});
			          	// return; 

			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        	this.hideLoading();
			        	this.disableSaveBtn = false;
			        }
			    });
			},

			fn_checkTransactionNumber: function(callback){
				var self = this;
				let filterObject = {};
				filterObject.mergeTransactionNumber = this.Form.transactionData.mergeTransactionNumber;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				filterObject.typeId = this.settings.transactionTypeId;
				let transactionId = this.Form.transactionData.transactionId ? this.Form.transactionData.transactionId : null;
				this.getFilterData('CheckTransactionNumber', transactionId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							callback ? callback() : '';
				        }, 
				        onError: function(error){
				        	self.disableBtn = false;
							self.disableSaveBtn = false;
				          	console.log(error);
				          	self.showToast('Transaction number already exists');
				          	self.hideLoading();
				          	self.transactionNumberSnackbar = true;
				        }
					}
		        );
			},

			fn_saveLocal: function(dataObj){
				this.backButtonPress = false;
				var self = this;
				this.postData('Purchase', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
						  let batchCount = dataObj.transactionProductBatches && dataObj.transactionProductBatches.length ? dataObj.transactionProductBatches.length : 0;
				          self.fn_cleanUp(batchCount);
				        },
				        onError: function(error){
				          console.log(error);
						  self.disableBtn = false;
							self.disableSaveBtn = false;
				          self.hideLoading();

				          	let response = JSON.parse(error);
				          	
				          	if(response && response.orderAlreadyCompleteError){
	                            if(self.Form.pendingOrders.length){
	                                self.showToast("Order already cleared.")
	                            }

	                            if(self.Form.pendingChallans.length){
	                                self.showToast("Challan already cleared.")
	                            }

								if(self.Form.pendingInvoices.length){
                                    self.showToast("Invoice already cleared.")
                                }
	                        }
				        }
					}
		        );
			},

			fn_cleanUp: function (batchCount) {
				// this.loadedFromDraft = false;
	   			let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("transaction_items_state")){
						let obj = JSON.parse(localStorage.getItem("transaction_items_state"));
						obj.itemId = self.Form.transactionData.transactionId;
						localStorage.setItem("transaction_items_state",JSON.stringify(obj));
					}

					let toolTitle = self.toolbarTitle.toLowerCase().replace(' ', '_');

					// posting metrics on save
					let postObj = {"eventName":toolTitle + '_save',"eventData":[{"eventKey":"transaction_number","eventValue":self.Form.transactionData.mergeTransactionNumber}]}

					if(batchCount){
						let obj = {};
						obj.eventKey = "transaction_batch_count";
						obj.eventValue = batchCount;
						postObj.eventData.push(obj);
					}

					let saveObj = {};
					saveObj.eventKey = "transaction_save";
					saveObj.eventValue = self.Form.transactionData.mergeTransactionNumber;
					postObj.eventData.push(saveObj);

        			self.$root.fn_postMetrics(postObj);
					
					self.hideLoading();
					// self.$router.go(-1);
					// self.fn_previewInvoice(false, 'purchase');
					if(self.$route.query.section_id){
						self.$router.go(-1);
					}
					else{
						self.fn_previewInvoice(false, 'purchase');
					}
				});
			},

			fn_post: function(){

				let addOnsTotal = 0;
				let purchaseLedgerAmount = this.Form.itemsSummary.grossAmount;
				// let totalGst = 0;
				let totalDiscount = 0;
				let totalTax = 0;
				let totalOtherCharges = 0;
				let refTId = [];

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
				}

				this.Form.transactionData.partyId = this.Form.partyId;
				this.Form.transactionData.grossAmount = this.Form.itemsSummary.grossAmount;
				this.Form.transactionData.netAmount = this.netAmount;
				this.Form.transactionData.amount = this.totalAmount;
				this.Form.transactionData.roundedAmount = this.roundedAmount//Math.round(this.totalAmount);
				this.Form.transactionData.taxMode = this.Form.taxMode;
				this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.placeOfSupplyId = null;

				// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
		        // 	this.Form.transactionData.placeOfSupplyId = this.Form.placeOfSupplyId;
		        // 	this.Form.transactionData.placeOfSupplyCountryId = this.Form.placeOfSupplyCountryId;
		        // }
				this.Form.transactionData.placeOfSupplyId = this.Form.placeOfSupplyId;
				this.Form.transactionData.placeOfSupplyCountryId = this.Form.placeOfSupplyCountryId;

		        if(this.Form.transactionData.paymentMode!=null){
					this.Form.transactionData.splitPayment = this.Form.splitPayment;
				}

		        this.Form.transactionData.isRounded = this.Form.isRounded;
				// this.Form.transactionData.itemType = !this.Form.items.length ? this.Form.itemType : null;
				if(!this.Form.items.length){
					this.Form.transactionData.itemType = this.Form.itemType ? 1 : 0;
					this.Form.transactionData.description = this.Form.description;
				}
				else{
					this.Form.transactionData.itemType = null;
					this.Form.transactionData.description = null;
				}

		        this.Form.transactionData.roundOffValue = this.Form.roundOffValue;
		        this.Form.transactionData.isRcmApplicable = this.Form.isRcmApplicable ? 1 : 0;
		        this.Form.transactionData.documentDetails = this.Form.attachments;

				this.Form.transactionData.paymentTerm = this.Form.selectedPaymentTerm ? this.Form.selectedPaymentTerm : this.Form.paymentTerm;

				// this.Form.transactionData.prefix = this.Form.transactionData.prefix ? this.Form.transactionData.prefix : null;
				this.Form.transactionData.suffix = this.Form.transactionData.suffix ? this.Form.transactionData.suffix : null;

				let postObj = {};
				postObj = JSON.parse(JSON.stringify(this.Form.transactionData));

				postObj.transactionSections = [];
				postObj.transactionFields = [];
				postObj.transactionProducts = [];
				postObj.transactionProductAddOns = [];
				postObj.transactionAddOns = [];
				postObj.transactionTds = [];
				postObj.ledgerAccounts = [];

				postObj.masterProductBatches = [];
				postObj.transactionProductBatches = [];

				let self = this;

				//Inserting 
					// dynamic/custom section to transactionSections
					// dynamic/custom fields to transactionFields
				if(this.Form.customFields.length){

					this.Form.customFields.forEach(function (item, index) {

						let sectionObj = {};
						sectionObj.transactionSectionId = self.guid()
						sectionObj.sectionId = item.section.sectionId;
						sectionObj.sectionName = item.section.sectionName;
						// sectionObj.orderNumber = index+1;
						sectionObj.orderNumber = item.section.orderNumber;

						postObj.transactionSections.push(sectionObj);

						item.items.forEach(function (fieldItem, index) {

							let fieldObj = {};
							fieldObj.transactionFieldId	= self.guid();
							fieldObj.transactionSectionId = sectionObj.transactionSectionId;
							fieldObj.transactionTypeFieldId = fieldItem.transactionTypeFieldId;
							fieldObj.sectionId = item.section.sectionId;
							fieldObj.orderNumber = index+1;
							fieldObj.fieldId = fieldItem.fieldId;
							fieldObj.fieldName = fieldItem.displayName;
							fieldObj.fieldValue = fieldItem.value;
							fieldObj.fieldDataType = fieldItem.fieldType;

							fieldObj.accountLedgerId = fieldItem.accountLedgerId ? fieldItem.accountLedgerId : null;
							fieldObj.listItemId = fieldItem.listItemId ? fieldItem.listItemId : null;

							postObj.transactionFields.push(fieldObj);
						})
					})

				}

				//Inserting 
					// products/items to transactionProducts 
					// product's addOns to transactionProductAddOns
				if(this.Form.items.length){

					this.Form.items.forEach(function(item){

						item.groupId = self.guid();

						//Transaction Products Entries
						item.productVariants.forEach(function (vItem) {

							let tpObj = {};

							if(vItem.qty){

								!vItem.transactionProductId ? tpObj.transactionProductId = self.guid() : tpObj.transactionProductId = vItem.transactionProductId;

								tpObj.productId = vItem.productId;

								tpObj.productVariantId = vItem.productVariantId;

								tpObj.groupId = item.groupId;

								tpObj.mrp = item.mrp ? item.mrp : 0;

								tpObj.rate = item.rate ? item.rate : 0;

								tpObj.description = item.description;

								tpObj.additionalData = null;

								// tpObj.unitId = vItem.unitId;

								tpObj.unitId = vItem.selectedUnit && vItem.selectedUnit.itemId ? vItem.selectedUnit.itemId : vItem.unitId;

								tpObj.primaryUnitId = vItem.primaryUnitId;

								if(vItem.secondaryUnitId && vItem.selectedUnit && vItem.selectedUnit.itemId){
									tpObj.secondaryUnitId = vItem.secondaryUnitId;
									tpObj.secondaryUnitPackQuantity = vItem.secondaryUnitPackQuantity;
								}

								tpObj.qty = vItem.qty;

								tpObj.packQuantity = vItem.packQuantity ? vItem.packQuantity : 1;

								tpObj.transactionProductMode = 1;

								if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
									tpObj.actualQty = -vItem.qty;
								}
								else{
									tpObj.actualQty = vItem.qty;
								}

								if(vItem.primaryUnitId && tpObj.unitId != vItem.primaryUnitId){
									tpObj.actualQty = self.roundUpto5Decimals((tpObj.actualQty * vItem.packQuantity) / vItem.secondaryUnitPackQuantity);
								}

								tpObj.netAmount = item.netAmount;
								tpObj.taxableValue = item.taxableValue;

								let packQty = vItem.packQuantity ? vItem.packQuantity : 1;

								let amount = item.rate * vItem.qty * packQty;
								tpObj.amount = self.roundUpto2Decimals(amount);


								tpObj.transactionListId = self.Form.transactionData.transactionListId;
								tpObj.stockInventory = self.passStockEntry;

								if(item.baseTransactionListId != self.settings.transactionTypeId  && item.baseTransactionListId == transactionTypes.purchaseChallan.id){
									tpObj.stockInventory = false;								
								}

								if(self.toolbarTitle == 'Debit Note'){
									tpObj.stockInventory = false;
								}

								tpObj.refTId = null;
								tpObj.refTpId = null;

								//refTId and refTpId only will goes in case of invoice, challan and return only for the items are loaded from orders or challans;
								if((self.settings.transactionTypeId == transactionTypes.purchaseInvoice.id || self.settings.transactionTypeId == transactionTypes.purchaseReturn.id || self.settings.transactionTypeId == transactionTypes.purchaseChallan.id) && item.baseTransactionListId != self.settings.transactionTypeId){

									tpObj.refTId = vItem.refTId ? vItem.refTId : vItem.transactionId;
									tpObj.refTpId = vItem.refTpId ? vItem.refTpId : vItem.transactionProductId;

									refTId.push(tpObj.refTId);

									//Generating new in case of order or challan item as old transactionProductId already saved while creating order or challan
									// tpObj.transactionProductId = self.guid();
									// self.Form.isNew ? tpObj.transactionProductId = self.guid() : '';

								}

								//saving tax category id in transaction products in case of tax mode exclusive/inclusive
								tpObj.taxCategoryId = item.taxCategoryId;

								tpObj.hsnCode = item.hsnCode;

								if(!self.Form.taxMode){
									tpObj.taxCategoryId = item.defaultTaxCategoryId ? item.defaultTaxCategoryId : '';
								}

								// tpObj.orderNumber = postObj.transactionProducts.length + 1;
								if(!item.baseTransactionListId || (item.baseTransactionListId && item.baseTransactionListId == self.settings.transactionTypeId)){
									tpObj.orderNumber = postObj.transactionProducts.length + 1;
								}
								else{
									tpObj.orderNumber = item.orderNumber;
								}

								tpObj.selectedBatchType = item.selectedBatchType;

								tpObj.packing = item.packing;

								tpObj.toGodownId = self.Form.godownId;

								if(item.customFields){
									tpObj.itemDetailFields = {};
									tpObj.itemDetailFields.data = [JSON.parse(JSON.stringify(item.customFields))];
								}

								if(item.serviceAccountItemId){
									tpObj.serviceAccountItemId = item.serviceAccountItemId;
								}

								postObj.transactionProducts.push(tpObj);

							}

							if(item.batches && item.batches.length){
								//adding batches to transaction
								for(let i=0; i<item.batches.length; i++){
									let obj = {};
									obj.productId = tpObj.productId;
									obj.transactionProductBatchId = !self.Form.isNew && item.batches[i].transactionProductBatchId ? item.batches[i].transactionProductBatchId : self.guid();
									obj.batchId = item.batches[i].batchId;
									obj.transactionProductId = tpObj.transactionProductId;
									// obj.qty = !tpObj.refTId ? item.batches[i].productQty : 0;
									obj.qty = item.batches[i].productQty;
									obj.orderNumber = i + 1;
									obj.transactionId = self.Form.transactionData.transactionId;
									obj.transactionListId = self.Form.transactionData.transactionListId;

									if(tpObj.refTId){
										obj.refTId = tpObj.refTId;
										// obj.refTpBatchId = item.batches[i].refTpBatchId ? item.batches[i].refTpBatchId : item.batches[i].transactionProductBatchId;
										if(item.baseTransactionListId != transactionTypes.purchaseOrder.id){
											if(item.batches[i].refTpBatchId){
												obj.refTpBatchId = item.batches[i].refTpBatchId;
											}
											else if(item.batches[i].refTransactionProductBatchId){
												obj.refTpBatchId = item.batches[i].refTransactionProductBatchId;
											}
											else{
												obj.refTpBatchId = item.batches[i].transactionProductBatchId;
											}
										}
									}
									
									if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
										obj.actualQty = -item.batches[i].productQty;
									}
									else{
										obj.actualQty = item.batches[i].productQty;
									}

									if(item.productVariants[0].selectedUnit && item.productVariants[0].selectedUnit.itemId != item.productVariants[0].primaryUnitId){
										obj.actualQty = self.roundUpto5Decimals((obj.actualQty * item.productVariants[0].packQuantity) /item.productVariants[0].secondaryUnitPackQuantity);
									}

									// if(!tpObj.refTId || self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
									// 	if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
									// 		obj.actualQty = -item.batches[i].productQty;
									// 	}
									// 	else{
									// 		obj.actualQty = item.batches[i].productQty;
									// 	}
									// }
									// else{
									// 	obj.actualQty = 0;
									// }
									postObj.transactionProductBatches.push(obj);

									if(item.batches[i].isNew){
										delete item.batches[i].isNew;
										item.batches[i].productId = tpObj.productId;
										item.batches[i].orderNumber = self.Form.batches.length + (i + 1);
										postObj.masterProductBatches.push(item.batches[i]);
									}
								}
							}

						})

						if(item.addOnsItems && item.addOnsItems.length){

							item.addOnsItems.forEach(function (addOnsItem, index) {

								let addOnsObj = {};

								if(addOnsItem.value!==null && addOnsItem.value!==''){

									if(!addOnsItem.isGst){

										addOnsItem.addOnsType == 1 ? totalDiscount += addOnsItem.value : addOnsItem.addOnsType == 2 ? totalTax += addOnsItem.value : totalOtherCharges += addOnsItem.value;

										addOnsObj.transactionProductsAddOnsId = self.guid();
										addOnsObj.transactionProductGroupId = item.groupId;
										addOnsObj.orderNumber = index+1;
										addOnsObj.addOnsId = addOnsItem.addOnsId;

										//saving name, nature and mode for display purpose only
										addOnsObj.addOnsName = addOnsItem.name;
										addOnsObj.addOnsNature = addOnsItem.nature;
										addOnsObj.addOnsMode = addOnsItem.mode;

										addOnsObj.addOnsType = addOnsItem.addOnsType;
										addOnsObj.percentage = addOnsItem.percentage;
										addOnsObj.value = addOnsItem.value;
										addOnsObj.isGst = null;
										// addOnsObj.hsnCode = item.hsnCode ? item.hsnCode : null;

										// sending taxable value to transaction product addons as per puran request
										addOnsObj.fullTaxableValue = item.taxableValue;

										postObj.transactionProductAddOns.push(addOnsObj);

										//Passing ledger entry if purchase account selected

										let ledgerObj = {};

										if(addOnsItem.nature){
											ledgerObj.amountType = 0;//Credit
											ledgerObj.amount = -addOnsItem.value;
										}
										else{
											ledgerObj.amountType = 1;//Debit
											ledgerObj.amount = addOnsItem.value;
										}

										if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry){
											ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
											let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
											postObj.ledgerAccounts.push(data);
										} 
										else{

											if(addOnsItem.nature){
												purchaseLedgerAmount -= addOnsItem.value;
											}
											else{
												purchaseLedgerAmount += addOnsItem.value;
											}

										}

									}
									
								}
							});
						}

						// adding tax as addons
						self.Form.gstAddOns.forEach(function (addOnsItem, index) {
							

							let tpAddOnsId = self.fn_getSavedGstAddOns(item.groupId, addOnsItem.addOnsId);

							if(self.Form.taxMode){

								let addOnsObj = {};

								!tpAddOnsId ? addOnsObj.transactionProductsAddOnsId = self.guid() : addOnsObj.transactionProductsAddOnsId = tpAddOnsId;

								addOnsObj.transactionId = self.Form.transactionData.transactionId;
								addOnsObj.transactionProductGroupId = item.groupId;
								addOnsObj.orderNumber = postObj.transactionProductAddOns.length+1;
								addOnsObj.addOnsId = addOnsItem.addOnsId;

								//saving name, nature and mode for display purpose only
								addOnsObj.addOnsName = addOnsItem.name;
								addOnsObj.addOnsNature = addOnsItem.nature;
								addOnsObj.addOnsMode = addOnsItem.mode;

								addOnsObj.addOnsType = 2;

								addOnsObj.percentage = item.taxValue / self.Form.gstAddOns.length;//addOnsItem.percentage;

								addOnsObj.value = item.taxAmount / self.Form.gstAddOns.length;//addOnsItem.value;

								addOnsObj.isGst = 1;

								postObj.transactionProductAddOns.push(addOnsObj);

								totalTax += addOnsObj.value;
								// totalGst += addOnsObj.value;

								//Passing ledger entry if purchase account selected
								//purchaseAccountItemId is the account selected in gst taxes master
								
								// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus == 1){
								if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && ((self.$root.CurrentBusiness.GSTRegistrationStatus == 1 && !self.Form.isRcmApplicable) || (self.$root.CurrentBusiness.GSTRegistrationStatus == 2 && self.Form.isRcmApplicable))){

									let ledgerObj = {};

									addOnsTotal += addOnsObj.value;
									// ledgerObj.amountType = 1//debit;
									if(self.$root.CurrentBusiness.GSTRegistrationStatus == 2 && self.Form.isRcmApplicable){
										ledgerObj.amountType = 0//credit;
										ledgerObj.amount = -addOnsObj.value;
									}
									else{
										ledgerObj.amountType = 1//debit;
										ledgerObj.amount = addOnsObj.value;
									}

									// if(self.Form.isRcmApplicable){
									// 	ledgerObj.accountId = addOnsItem.saleAccountItemId;

									// 	// Rcm input tax entry
									// 	let ledgerObjRcm = {};
									// 	ledgerObjRcm.amountType = 0//credit;
									// 	ledgerObjRcm.accountId = addOnsItem.purchaseAccountItemId;
									// 	ledgerObjRcm.amount = -addOnsObj.value;
									// 	let rcmData = self.fn_bindAndReturnSimilarValues(ledgerObjRcm);
									// 	postObj.ledgerAccounts.push(rcmData);
									// }
									// else{
									// 	ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
									// }

									ledgerObj.accountId = addOnsItem.purchaseAccountItemId;

									// ledgerObj.amount = addOnsObj.value;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(data);


								}

							}
						});

						//adding cess as addons
						if(item.isCessApplicable && self.Form.taxMode){

							let addOnsItem = null;
							let addOnsObj = {};

							if(item.cessValueOnQuantity){
								addOnsItem = self.Form.cessAddOns;

								let tpAddOnsId = self.fn_getSavedGstAddOns(item.groupId, addOnsItem.addOnsId);

								!tpAddOnsId ? addOnsObj.transactionProductsAddOnsId = self.guid() : addOnsObj.transactionProductsAddOnsId = tpAddOnsId;

								addOnsObj.transactionId = self.Form.transactionData.transactionId;
								addOnsObj.transactionProductGroupId = item.groupId;
								addOnsObj.orderNumber = postObj.transactionProductAddOns.length+1;
								addOnsObj.addOnsId = addOnsItem.addOnsId;

								//saving name, nature and mode for display purpose only
								addOnsObj.addOnsName = addOnsItem.name;
								addOnsObj.addOnsNature = addOnsItem.nature;
								addOnsObj.addOnsMode = addOnsItem.mode;

								addOnsObj.addOnsType = 2;

								// addOnsObj.percentage = self.roundUpto2Decimals(item.cessValue);//addOnsItem.percentage;
								addOnsObj.percentage = null;

								addOnsObj.value = self.roundUpto2Decimals(Number(item.cessValueOnQuantity) * Number(item.productVariants[0].qty));//addOnsItem.value;

								addOnsObj.cessValueOnQuantity = Number(item.cessValueOnQuantity);

								addOnsObj.isGst = 2;

								postObj.transactionProductAddOns.push(JSON.parse(JSON.stringify(addOnsObj)));

								totalTax += addOnsObj.value != null ? addOnsObj.value : 0;
								// totalGst += addOnsObj.value != null ? addOnsObj.value : 0;

								//Passing ledger entry if purchase account selected

								if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && ((self.$root.CurrentBusiness.GSTRegistrationStatus == 1 && !self.Form.isRcmApplicable) || (self.$root.CurrentBusiness.GSTRegistrationStatus == 2 && self.Form.isRcmApplicable))){

									let ledgerObj = {};
									if(self.$root.CurrentBusiness.GSTRegistrationStatus == 2 && self.Form.isRcmApplicable){
										ledgerObj.amountType = 0//credit;
										ledgerObj.amount = -addOnsObj.value;
									}
									else{
										ledgerObj.amountType = 1//debit;
										ledgerObj.amount = addOnsObj.value;
									}
									addOnsTotal += addOnsObj.value;
									
									ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(data);
								}

								// if(addOnsItem.saleAccountItemId && self.passLedgerEntry){

								// 	let ledgerObj = {};
								// 	addOnsTotal += addOnsObj.value;
								// 	ledgerObj.amountType = 0//credit;
								// 	ledgerObj.accountId = addOnsItem.saleAccountItemId;
								// 	ledgerObj.amount = -addOnsObj.value;
								// 	let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// 	postObj.ledgerAccounts.push(data);
								// }
							}

							// addOnsItem = self.Form.cessAddOns;

							// let tpAddOnsId = self.fn_getSavedGstAddOns(item.groupId, addOnsItem.addOnsId);

							let addOnsObj2 = {};

							if(item.cessValue !=undefined && item.cessValue !=null){
								addOnsItem = self.Form.cessAddOns;
								let tpAddOnsId = self.fn_getSavedGstAddOns(item.groupId, addOnsItem.addOnsId);

								!tpAddOnsId ? addOnsObj2.transactionProductsAddOnsId = self.guid() : addOnsObj2.transactionProductsAddOnsId = tpAddOnsId;

								addOnsObj2.transactionId = self.Form.transactionData.transactionId;
								addOnsObj2.transactionProductGroupId = item.groupId;
								addOnsObj2.orderNumber = postObj.transactionProductAddOns.length+1;
								addOnsObj2.addOnsId = addOnsItem.addOnsId;

								//saving name, nature and mode for display purpose only
								addOnsObj2.addOnsName = addOnsItem.name;
								addOnsObj2.addOnsNature = addOnsItem.nature;
								addOnsObj2.addOnsMode = addOnsItem.mode;

								addOnsObj2.addOnsType = 2;

								// addOnsObj.percentage = self.roundUpto2Decimals(item.cessValue);//addOnsItem.percentage;
								addOnsObj2.percentage = item.cessValue!=null ? self.roundUpto2Decimals(item.cessValue) : null;

								addOnsObj2.value = self.roundUpto2Decimals(item.cessAmount);//addOnsItem.value;

								addOnsObj2.isGst = 2;
								// addOnsObj.hsnCode = item.hsnCode;

								postObj.transactionProductAddOns.push(addOnsObj2);

								totalTax += addOnsObj2.value != null ? addOnsObj2.value : 0;
								// totalGst += addOnsObj.value != null ? addOnsObj.value : 0;

								//Passing ledger entry if purchase account selected
								//purchaseAccountItemId is the account selected in gst taxes master
								// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus != 3){
								if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && ((self.$root.CurrentBusiness.GSTRegistrationStatus == 1 && !self.Form.isRcmApplicable) || (self.$root.CurrentBusiness.GSTRegistrationStatus == 2 && self.Form.isRcmApplicable))){

									let ledgerObj = {};
									if(self.$root.CurrentBusiness.GSTRegistrationStatus == 2 && self.Form.isRcmApplicable){
										ledgerObj.amountType = 0//credit;
										ledgerObj.amount = -addOnsObj2.value;
									}
									else{
										ledgerObj.amountType = 1//debit;
										ledgerObj.amount = addOnsObj2.value;
									}
									addOnsTotal += addOnsObj2.value;
									
									ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(data);
								}
							}

						}
					})

				}

				//Inserting
					// transaction's addOns to transactionAddOns
				if(this.Form.transactionAddOns.length){

					this.Form.transactionAddOns.forEach(function (addOnsItem, index) {
						
						let addOnsObj = {};

						if(addOnsItem.value!==null && addOnsItem.value!==''){

							addOnsItem.addOnsType == 1 ? totalDiscount += addOnsItem.value : addOnsItem.addOnsType == 2 ? totalTax += addOnsItem.value : totalOtherCharges += addOnsItem.value;

							addOnsObj.transactionAddOnsId = addOnsItem.transactionAddOnsId;
							addOnsObj.orderNumber = index+1;
							addOnsObj.addOnsId = addOnsItem.addOnsId;

							//saving name, nature and mode for display purpose only
							addOnsObj.addOnsName = addOnsItem.name;
							addOnsObj.addOnsNature = addOnsItem.nature;
							addOnsObj.addOnsMode = addOnsItem.mode;

							addOnsObj.addOnsType = addOnsItem.addOnsType;
							addOnsObj.percentage = addOnsItem.percentage;
							addOnsObj.value = addOnsItem.value;
							addOnsObj.appliedOn = addOnsItem.appliedOn;
							addOnsObj.adjustInTotal = addOnsItem.adjustInTotal;

							addOnsObj.isDefault = addOnsItem.isDefault;

							if(addOnsItem.addOnsType==2 && (addOnsItem.addOnsId == fixedGstAddOns.CGST.id || addOnsItem.addOnsId == fixedGstAddOns.SGST.id || addOnsItem.addOnsId == fixedGstAddOns.UTGST.id || addOnsItem.addOnsId == fixedGstAddOns.IGST.id)){
								addOnsObj.isGst = 1;
							}

							addOnsItem.addOnsId == fixedCessAddOns.CESS.id ? addOnsObj.isGst = 2 : '';

							// sending taxable value to transaction addons as per puran request
							addOnsObj.fullTaxableValue = self.Form.transactionData.taxableValue;

							postObj.transactionAddOns.push(addOnsObj);

							//Passing ledger entry if purchase account selected

							let isTaxLedger = false;
							if(fixedGstAddOns.CGST.id == addOnsItem.addOnsId || fixedGstAddOns.SGST.id == addOnsItem.addOnsId || fixedGstAddOns.UTGST.id == addOnsItem.addOnsId || fixedGstAddOns.IGST.id == addOnsItem.addOnsId || fixedCessAddOns.CESS.id == addOnsItem.addOnsId){
								isTaxLedger = true;
							}

							// if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry && self.$root.CurrentBusiness.GSTRegistrationStatus != 3){
							if(addOnsItem.purchaseAccountItemId && self.passLedgerEntry){
								// if(self.Form.isRcmApplicable){
								// 	ledgerObj.accountId = addOnsItem.saleAccountItemId;

								// 	// Rcm input tax entry
								// 	let ledgerObjRcm = {};
								// 	ledgerObjRcm.amountType = 0//credit;
								// 	ledgerObjRcm.accountId = addOnsItem.purchaseAccountItemId;
								// 	ledgerObjRcm.amount = -addOnsObj.value;
								// 	let rcmData = self.fn_bindAndReturnSimilarValues(ledgerObjRcm);
								// 	postObj.ledgerAccounts.push(rcmData);
								// }
								// else{
								// 	ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
								// }
								// let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// postObj.ledgerAccounts.push(data);

								//Passing ledger entry if purchase account selected
								if(self.$root.CurrentBusiness.GSTRegistrationStatus==1 && !self.Form.isRcmApplicable){
									let ledgerObj = {};

									if(addOnsItem.nature){
										ledgerObj.amountType = 0;//credit
										ledgerObj.amount = -addOnsItem.value;
									}
									else{
										ledgerObj.amountType = 1;//debit
										ledgerObj.amount = addOnsItem.value;
									}

									ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
									let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
									postObj.ledgerAccounts.push(data);
								}
								else{
									if(!isTaxLedger){
										let ledgerObj = {};

										// ledgerObj.amountType = 0;//credit
										// ledgerObj.amount = -addOnsItem.value;
										if(addOnsItem.nature){
											ledgerObj.amountType = 0;//credit
											ledgerObj.amount = -addOnsItem.value;
										}
										else{
											ledgerObj.amountType = 1;//debit
											ledgerObj.amount = addOnsItem.value;
										}

										ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
										let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
										postObj.ledgerAccounts.push(data);
									}
								}

								// if(self.$root.CurrentBusiness.GSTRegistrationStatus==2 && self.Form.isRcmApplicable){
								// 	let ledgerObj = {};

								// 	ledgerObj.amountType = 0;//credit
								// 	ledgerObj.amount = -addOnsItem.value;

								// 	ledgerObj.accountId = addOnsItem.purchaseAccountItemId;
								// 	let data = self.fn_bindAndReturnSimilarValues(ledgerObj);
								// 	postObj.ledgerAccounts.push(data);
								// }
							}
							else{
								if(addOnsItem.nature){
									purchaseLedgerAmount -= addOnsItem.value;
								}
								else{
									purchaseLedgerAmount += addOnsItem.value;
								}

							}
						}

					})
				}

				//Inserting
					// transaction's tds to transactionTdsId
				if(this.Form.tdsDetails.transactionTdsId){

					postObj.transactionTds.push(this.Form.tdsDetails);

					//Passing ledger entry if purchase account selected
					if(this.passLedgerEntry){
						let ledgerObj = {};

						ledgerObj.amountType = 0//credit;
						ledgerObj.accountId = this.Form.tdsDetails.tdsAccountId;
						ledgerObj.amount = -this.Form.tdsDetails.amount;
						let data = this.fn_bindAndReturnSimilarValues(ledgerObj);
						postObj.ledgerAccounts.push(data);
					}
				}

				
				if(this.passLedgerEntry){
					//Inserting
						// transaction's type entry ledgers to ledger accounts

					let purchaseLedgerObj = {};
					purchaseLedgerObj.amountType = 1;//debit

					if(this.Form.gstType=='IntraState' || this.Form.gstType=='UnionTerritory'){
						if(this.Form.transactionTypeData.importExport)
							purchaseLedgerObj.accountId = this.Form.transactionTypeData.importExportTransactionAccountId;
						else
							purchaseLedgerObj.accountId = this.Form.transactionTypeData.localTransactionAccountId;
					}
					else{
						if(this.Form.transactionTypeData.importExport)
							purchaseLedgerObj.accountId = this.Form.transactionTypeData.importExportTransactionAccountId;
						else
							purchaseLedgerObj.accountId = this.Form.transactionTypeData.centralTransactionAccountId;
					}



					// if(this.Form.taxMode==2){
					// 	purchaseLedgerObj.amount  = purchaseLedgerAmount - this.roundUpto2Decimals(totalGst);
					// }
					// else{
					// 	purchaseLedgerObj.amount  = purchaseLedgerAmount;
					// }

					// if(this.$root.CurrentBusiness.GSTRegistrationStatus!=3){
					// if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
					// if(this.$root.CurrentBusiness.GSTRegistrationStatus!=2 || this.Form.isRcmApplicable){
					if(this.$root.CurrentBusiness.GSTRegistrationStatus==1 || this.Form.isRcmApplicable || !this.Form.items.length){
						purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount);
					}
					else{
						// purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount + totalGst);
						purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount + totalTax);
					}

					if(this.$root.CurrentBusiness.GSTRegistrationStatus==2 && this.Form.isRcmApplicable && !this.Form.items.length){
						// purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount + totalGst);
						purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount + totalTax);
					}

					// purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount);

					let purchaseLedger = this.fn_bindAndReturnSimilarValues(purchaseLedgerObj);
					// postObj.ledgerAccounts.push(purchaseLedger);

					if(this.toolbarTitle == 'Debit Note'){
						for(let i=0; i<this.Form.items.length; i++){
							let obj = {};
							obj.amountType = 1;
							obj.accountId = this.Form.items[i].serviceAccountItemId;
							
							if(this.$root.CurrentBusiness.GSTRegistrationStatus==1 || this.Form.isRcmApplicable){
								// purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount);
								obj.amount = this.roundUpto2Decimals(this.Form.items[i].taxableValue);
							}
							else{
								let taxAmount = this.Form.items[i].taxAmount;
								if(this.Form.items[i].cessAmount){
									taxAmount = taxAmount + this.Form.items[i].cessAmount;
								}
								obj.amount = this.roundUpto2Decimals(this.Form.items[i].taxableValue + taxAmount);
								// purchaseLedgerObj.amount  = this.roundUpto2Decimals(purchaseLedgerAmount + totalTax);
							}

							if(this.$root.CurrentBusiness.GSTRegistrationStatus==2 && this.Form.isRcmApplicable){
								let taxAmount = this.Form.items[i].taxAmount;
								if(this.Form.items[i].cessAmount){
									taxAmount = taxAmount + this.Form.items[i].cessAmount;
								}
								obj.amount = this.roundUpto2Decimals(this.Form.items[i].taxableValue + taxAmount);
							}
							
							// obj.amount = this.roundUpto2Decimals(this.Form.items[i].taxableValue);
							let ledgerObj = this.fn_bindAndReturnSimilarValues(obj);
							postObj.ledgerAccounts.push(ledgerObj);
						}
					}
					else{
						postObj.ledgerAccounts.push(purchaseLedger);
					}

					postObj.transactionLedgers = [];

					if(!this.Form.transactionData.paymentMode){
						let partyLedgerObj = {};
						partyLedgerObj.amountType = 0;//credit
						partyLedgerObj.accountId = this.Form.partyId;
						partyLedgerObj.amount = -this.roundedAmount;
						// partyLedgerObj.amount = -this.roundUpto2Decimals(this.roundedAmount - totalTax);
						let partyLedger = this.fn_bindAndReturnSimilarValues(partyLedgerObj);
						postObj.ledgerAccounts.push(partyLedger);	
					}
					else{
						this.fn_generatePaymentEntries(postObj.ledgerAccounts, postObj.transactionLedgers);
					}
					

					// if(this.roundedAmount!=this.totalAmount){
					if(this.roundOff){
						// let roundOffAmount = this.roundUpto2Decimals(Math.abs(this.roundedAmount - this.totalAmount));
						let roundOffAmount = this.roundUpto2Decimals(Math.abs(this.roundOff));
						let roundOffLedgerObj = {};
						roundOffLedgerObj.amountType = this.totalAmount > this.roundedAmount ?  0 : 1;//credit/debit
						roundOffLedgerObj.accountId = "9d58ac9d-bf1b-4093-919a-2d68849e6176"; //round off ledgeraccountid //static for now
						roundOffLedgerObj.amount = roundOffLedgerObj.amountType == 0 ? -roundOffAmount : roundOffAmount;
						// roundOffLedgerObj.amount = roundOffAmount;
						let roundOffLedger = this.fn_bindAndReturnSimilarValues(roundOffLedgerObj);
						postObj.ledgerAccounts.push(roundOffLedger);
					}
				}

				//Swaping amountType from debit to credit and credit to debit in case of purchase return
				if(self.settings.transactionTypeId == transactionTypes.purchaseReturn.id){
					postObj.ledgerAccounts.forEach(function (item) {
						item.amount = -item.amount;
						item.amountType == 1 ? item.amountType = 0 : item.amountType = 1;
					});
				}

				postObj.discount = this.roundUpto2Decimals(totalDiscount);
				postObj.tax = this.roundUpto2Decimals(totalTax);
				postObj.otherCharges = this.roundUpto2Decimals(totalOtherCharges);

				if(this.Form.partyLastConfig && this.Form.partyLastConfig.purchase){
					this.Form.partyLastConfig.purchase.taxMode = this.Form.taxMode;
				}
				else{
					this.Form.partyLastConfig = {};
					this.Form.partyLastConfig.purchase = {"taxMode":this.Form.taxMode};
				}

				postObj.partyLastConfig = JSON.stringify(this.Form.partyLastConfig);
				
				postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

				postObj.onCredit = this.onCreditValue;

				// adding tax in taxable value in case of unregister/composite business
				// if(this.$root.CurrentBusiness.GSTRegistrationStatus != 1){
				// 	postObj.taxableValue = this.roundedAmount;
				// }

				postObj.isItcEligible = true;

				postObj.refTId = refTId ? refTId : null;

				postObj.transactionListItemData = [];

				if(this.Form.brokerId && this.Form.brokerName){
					let obj = {};
					obj.transactionListItemDataId = this.guid();
					obj.transactionId = this.Form.transactionData.transactionId;
					obj.listId = "brokers";
					obj.listItemId = null
					obj.listItemData = {'type':'brokers'};
					obj.ledgerId = this.Form.brokerId;
					obj.groupType = "brokers"
					postObj.transactionListItemData.push(obj);
				}
                
                postObj.isNew = this.Form.isNew;

				if(this.toolbarTitle == 'Debit Note'){
					postObj.isCreditDebitNote = true;
				}

				postObj.toGodownId = this.Form.godownId;

				console.log(JSON.stringify(postObj));
				this.fn_saveLocal(postObj);
			},

			// fn_bindAndReturnSimilarValues: function (ledgerObj) {
			// 	ledgerObj.ledgerAccountId = this.guid();
			// 	ledgerObj.transactionListId = this.Form.transactionData.transactionListId;
			// 	ledgerObj.transactionDate = this.Form.transactionData.transactionDate;	
			// 	return ledgerObj;
			// },

			fn_get: function(itemId, copyData){
				var self = this;
				this.Form.isNew = false;
				this.getData('Purchase', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);

							self.Form.savedItemData = JSON.parse(response);

							self.fn_bindData(data, copyData);
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function (data) {
				
				this.Form.transactionData.additionalData = data.additionalData;
				this.Form.transactionData.createdBy = data.createdBy;
				this.Form.transactionData.createdDate = data.createdDate;
				// this.Form.transactionData.currencyId = data.currencyId;
				this.Form.transactionData.notes = data.notes;
				this.Form.partyId = data.partyId;
				this.Form.partyName = data.partyName;

				// this.Form.placeOfSupplyId = data.placeOfSupplyId;
				// this.Form.placeOfSupplyName = data.placeOfSupplyName;
				this.Form.placeOfSupplyCountryId = data.placeOfSupplyCountryId;
				this.Form.placeOfSupplyCountryName = data.placeOfSupplyCountryName;

				this.Form.partyLastConfig = data.lastConfig ? JSON.parse(data.lastConfig) : data.lastConfig;

				//getting party details
				this.fn_getPartyDetails(data.partyId);

				this.Form.transactionData.refDate = data.refDate;
				this.Form.transactionData.refNumber = data.refNumber;
				this.Form.transactionData.status = data.status;
				this.Form.taxMode = data.taxMode;

				this.Form.transactionData.transactionDate = data.transactionDate;
				this.Form.transactionData.transactionId = data.transactionId;
				this.Form.transactionData.prefix = data.prefix;
				this.Form.transactionData.transactionNumber = data.transactionNumber;
				this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
				this.Form.transactionData.suffix = data.suffix;

				this.Form.transactionTypeFormId = data.transactionTypeFormId;
				this.Form.transactionTypeFormName = data.transactionTypeFormName;

				this.Form.transactionData.numberSeriesId = data.numberSeriesId;
				this.Form.transactionData.transactionNumberId = data.transactionNumberId;

				!data.transactionProducts ? this.Form.netInvoiceValue = data.netAmount : '';
				this.Form.isRounded = data.isRounded;
				// this.Form.itemType = data.itemType;
				this.Form.itemType = data.itemType == 1 ? true : false;
				this.Form.isRcmApplicable = data.isRcmApplicable == 1 ? true : false;
				this.Form.attachments = data.documentDetails ?  data.documentDetails : [];

				this.Form.splitPayment = data.splitPayment;
				this.Form.description = data.description;

				this.Form.paymentTerm = data.paymentTerm;
				// this.Form.selectedPaymentTerm = data.paymentTerm > 30 ? null : data.paymentTerm;
				this.Form.selectedPaymentTerm = data.paymentTerm ? data.paymentTerm : -1;

				if(data.transactionListItemData && data.transactionListItemData.length){
					// broker
					let brokerDetails = data.transactionListItemData.filter(item=>{
						return item.groupType == 'brokers';
					})

					if(brokerDetails && brokerDetails.length){
						this.Form.brokerId = brokerDetails[0].ledgerId;
						this.Form.brokerName = brokerDetails[0].partyName;	
					}
				} 

				if(data.godownId && data.godownName){
					this.Form.godownId = data.godownId;
					this.Form.godownName = data.godownName;
				}

				let self = this;

				this.fn_getTransactionTypeData(data.transactionTypeFormId, function (args) {

					self.fn_updateState(data.placeOfSupplyId, data.placeOfSupplyName, false);
					
					console.log(args);

					self.Form.items = [];

					let obj = {};
					obj.transactionProducts = [];

					if(data.transactionProducts && data.transactionProducts.length){

						data.transactionProducts.forEach(function (item) {
					
							let itemObj = {};
							itemObj.groupId = item.groupId;
							itemObj.mrp = item.mrp;
							itemObj.rate = item.rate;
							itemObj.description = item.description;
							itemObj.productId = item.productId;
							itemObj.productName = item.productName;
							itemObj.taxValue = 0;
							itemObj.taxAmount = 0;
							itemObj.cessValue = null;
							itemObj.cessAmount = 0;
							itemObj.cessValueOnQuantity = null;
							itemObj.addOnsItems = [];
							itemObj.batches = [];

							itemObj.baseTransactionListId = item.baseTransactionListId;
							itemObj.baseTransactionNumber = item.baseTransactionNumber;

							itemObj.hsnCode = item.hsnCode;

							//getting default tax values from product master

							itemObj.defaultTaxValue = item.defaultTaxValue;
							itemObj.defaultCessValue = item.defaultCessValue;
							itemObj.defaultHsnCode = item.defaultHsnCode;
							itemObj.defaultTaxCategoryId = item.defaultTaxCategoryId;
							itemObj.defaultTaxCategoryName = item.defaultTaxCategoryName;
							itemObj.isCessApplicable = item.isCessApplicable;

							itemObj.taxCategoryId = item.taxCategoryId;
							itemObj.taxCategoryName = item.taxCategoryName;

							itemObj.productVariants = JSON.parse(JSON.stringify(item.productVariants));

							for(let l=0; l<itemObj.productVariants.length; l++){
								itemObj.productVariants[l].selectedUnit = {};
								itemObj.productVariants[l].selectedUnit.itemId = itemObj.productVariants[l].unitId;
								itemObj.productVariants[l].selectedUnit.itemName = itemObj.productVariants[l].unitName;

								if(itemObj.productVariants[l].secondaryUnitId){
									itemObj.productVariants[l].secondaryUnitId = itemObj.productVariants[l].secondaryUnitId;
									itemObj.productVariants[l].secondaryUnitPackQuantity = itemObj.productVariants[l].secondaryUnitPackQuantity;
								}
							}

							itemObj.selectedBatchType = item.selectedBatchType;

							if(item.serviceAccountItemId){
								itemObj.serviceAccountItemId = item.serviceAccountItemId;
							}	

							// removing order/challan/invoice reference in case of copy
							if(self.$route.query.copy && item.baseTransactionListId != self.Form.transactionData.transactionListId){
								item.baseTransactionListId = self.Form.transactionData.transactionListId;
								item.baseTransactionNumber = self.Form.transactionData.mergeTransactionNumber;
								itemObj.baseTransactionListId = item.baseTransactionListId;
								itemObj.baseTransactionNumber = item.baseTransactionNumber;
								for(let k=0; k<itemObj.productVariants.length; k++){
									itemObj.productVariants[k].refTId = null;
									itemObj.productVariants[k].refTpId = null;
								}
							}

							let tValue = 0;
							let tAmount = 0;

							item.transactionProductAddOns.forEach(function (addOnsItem) {

								addOnsItem.mode == 1 ? addOnsItem.percentage = null : '';
								
								if(addOnsItem.isGst==1){
									// itemObj.taxValue += addOnsItem.percentage;
									// itemObj.taxAmount += addOnsItem.value;
									tValue += addOnsItem.percentage;
									tAmount += addOnsItem.value;
									// itemObj.hsnCode = addOnsItem.hsnCode;
								}
								else if(addOnsItem.isGst==2){
									// itemObj.cessValue = addOnsItem.percentage != null ? addOnsItem.percentage : null;
									// itemObj.cessAmount = addOnsItem.value;

									if(addOnsItem.cessValueOnQuantity){
										itemObj.cessValueOnQuantity = addOnsItem.cessValueOnQuantity;
									}
									else{
										itemObj.cessValue = addOnsItem.percentage != null ? addOnsItem.percentage : null;
										itemObj.cessAmount = addOnsItem.value;
									}
									// itemObj.hsnCode = addOnsItem.hsnCode;
								}

							});

							itemObj.taxValue = self.roundUpto2Decimals(tValue);
							itemObj.taxAmount = self.roundUpto2Decimals(tAmount);

							//doing this as default addons configuration can be changed from transactionType
							self.Form.productDataModel.addOnsItems.forEach(function (defaultAddOns) {

								let addOns = null;

								let itemIndex = item.transactionProductAddOns.findIndex(item=>{
									return defaultAddOns.addOnsId == item.addOnsId;
								});

								if(itemIndex!=-1){
									addOns = JSON.parse(JSON.stringify(item.transactionProductAddOns[itemIndex]));
									addOns.appliedOn = defaultAddOns.appliedOn;
									addOns.adjustInTotal = defaultAddOns.adjustInTotal;
								}

								addOns ? itemObj.addOnsItems.push(addOns) : '';
								
							});

							itemObj.orderNumber = item.orderNumber;

							// if(data.masterProductBatches && data.masterProductBatches.length){
							// 	itemObj.batches = [];
							// 	for(let i=0; i<data.masterProductBatches.length; i++){
							// 		if(data.masterProductBatches[i].productId == itemObj.productId){
							// 			for(let j=0; j<data.transactionProductBatches.length; j++){
							// 				if(data.transactionProductBatches[j].batchId == data.masterProductBatches[i].batchId){
							// 					data.masterProductBatches[i].productQty = data.transactionProductBatches[j].qty;
							// 					break;
							// 				}
							// 			}
							// 			itemObj.batches.push(JSON.parse(JSON.stringify(data.masterProductBatches[i])));
							// 		}
							// 	}
							// }

							if(item.transactionProductBatches && item.transactionProductBatches.length){
								for(let i=0; i<item.transactionProductBatches.length; i++){
									item.transactionProductBatches[i].productQty = item.transactionProductBatches[i].qty;
									itemObj.batches.push(item.transactionProductBatches[i]);
								}
							}

							itemObj.packing = item.packing;

							if(item.itemDetailFields && item.itemDetailFields.data && item.itemDetailFields.data.length){
								itemObj.customFields = item.itemDetailFields.data[0];
							}

							self.Form.items.push(itemObj);

						});	
					}
					

					//adding order and challan items to pending orders and pending challans for data grouping

					if(self.settings.transactionTypeId == transactionTypes.purchaseInvoice.id || self.settings.transactionTypeId == transactionTypes.purchaseReturn.id || self.settings.transactionTypeId == transactionTypes.purchaseChallan.id){

						self.Form.isPendingItems = false;

						self.Form.items.forEach(function (item) {

							if(item.baseTransactionListId != self.Form.transactionData.transactionListId){

								if(item.baseTransactionListId == transactionTypes.purchaseOrder.id){
									assignPendingItems(self.Form.pendingOrders);
								}

								else if(item.baseTransactionListId == transactionTypes.purchaseChallan.id){
									assignPendingItems(self.Form.pendingChallans);
								}

								else if(item.baseTransactionListId == transactionTypes.purchaseInvoice.id){
									assignPendingItems(self.Form.pendingInvoices);
								}

							}

							function assignPendingItems(pendingItems) {
								
								self.Form.isPendingItems = true;

								let itemIndex = pendingItems.findIndex(pItem=>{
									return pItem.baseTransactionNumber == item.baseTransactionNumber;
								});

								if(itemIndex==-1){
									let obj = {};
									obj.baseTransactionNumber = item.baseTransactionNumber;
									obj.baseTransactionListId = item.baseTransactionListId;
									obj.baseTransactionId = item.baseTransactionId;
									obj.transactionProducts = [];
									obj.transactionProducts.push(item);
									pendingItems.push(obj);
								}
								else{
									pendingItems[itemIndex].transactionProducts.push(item);
								}
							}
							

						});
					}

					self.Form.transactionAddOns = [];

					if(data.transactionAddOns && data.transactionAddOns.length){

						data.transactionAddOns.forEach(function (item) {

							item.mode == 1 ? item.percentage = null : '';

							let addOnsItem = JSON.parse(JSON.stringify(item));
							
							self.Form.transactionAddOns.push(addOnsItem);

						});

					}
					

					if(data.transactionTds && data.transactionTds.length){
						self.Form.tdsDetails = JSON.parse(JSON.stringify(data.transactionTds[0]));
					}


					if(data.customFields && data.customFields.length){
						data.customFields.forEach(function (item) {

							//manual eway bill insertion
							if(self.settings.transactionTypeId != transactionTypes.purchaseOrder.id && item.section.sectionId == self.ewayBillDetailSection.sectionId){
								item.items = [];
								self.ewayBillDetailFields.forEach(function (eWayField){
									item.items.push(eWayField);
								})	
							}

							let customFieldItems = [];

							for(let i=0; i<self.Form.transactionTypeData.transactionTypeFields.length; i++){

								let transactionTypeField = self.Form.transactionTypeData.transactionTypeFields[i];

								for(let j=0; j<item.items.length; j++){

									if(transactionTypeField.sectionId == item.section.sectionId && transactionTypeField.fieldId == item.items[j].fieldId){
										//assigning display name from transaction type settings in case updated or not
										// item.items[j].displayName = transactionTypeField.displayName;
										customFieldItems.push(item.items[j]);
										break;
									}
								}
							}

							item.items = JSON.parse(JSON.stringify(customFieldItems));

							item.items.forEach(function (fieldItem) {
								fieldItem.additionalData = JSON.parse(fieldItem.additionalData);

								//manual eway bill insertion
								if(self.settings.transactionTypeId != transactionTypes.purchaseOrder.id){
									for(let i=0; i<data.transactionFields.length; i++){
										if(data.transactionFields[i].fieldId == fieldItem.fieldId){
											fieldItem.value = data.transactionFields[i].fieldValue;
											if(fieldItem.fieldType == "accountItem" && fieldItem.accountLedgerId){
                                                fieldItem.selectedAccountItem = {itemId:fieldItem.accountLedgerId, itemName:fieldItem.value};
                                            }
										}
									}
								}

							});
						});

						self.Form.customFields = JSON.parse(JSON.stringify(data.customFields));
					}

					//appending payment modes if applicable
					if(self.Form.transactionTypeData.paymentMode == 1 && data.transactionLedgers && data.transactionLedgers.length){
						if(self.Form.splitPayment){
							self.Form.paymentOptions = JSON.parse(JSON.stringify(data.transactionLedgers));	
						}
						else{
							self.Form.paymentLedgerId = data.transactionLedgers[0].accountLedgerId;
						}
					}

					// hide/show dynamic menu options
					for(let i=0; i<self.Form.customFields.length; i++){
						for(let j=0; j<self.Form.dynamicMenuItems.length; j++){
							if(self.Form.customFields[i].section.sectionId == self.Form.dynamicMenuItems[j].sectionId){
								self.Form.dynamicMenuItems[j].hideOption = true;
								self.$forceUpdate();
							}
							else if(self.Form.customFields[i].section.sectionId == self.ewayBillDetailSection.sectionId){
								self.Form.hideEwayOption = true;
							}
						}
					}

					self.fn_calculateTax();

					// removing ids in case of copy transaction
					if(self.$route.query.copy){
						self.Form.transactionData.transactionId = null;
						self.Form.transactionData.transactionDate = self.$root.fn_getLocalDateFormat();
						if(self.Form.attachments && self.Form.attachments.length){
							for(let i=0; i<self.Form.attachments.length; i++){
								self.Form.attachments[i].documentId = self.guid();
							}
						}
						if(self.Form.items && self.Form.items.length){
							for(let i=0; i<self.Form.items.length; i++){
								let pItem = self.Form.items[i];
								pItem.groupId = self.guid();
								if(pItem && pItem.productVariants.length){
									for(let i2=0; i2<pItem.productVariants.length; i2++){
										pItem.productVariants[i2].transactionProductId = self.guid();
									}
								}
								
								if(pItem.transactionProductAddOns && pItem.transactionProductAddOns.length){
									for(let j=0; j<pItem.transactionProductAddOns.length; j++){
										pItem.transactionProductAddOns[j].transactionProductsAddOnsId = self.guid();
										pItem.transactionProductAddOns[j].transactionProductGroupId = pItem.groupId;
									}
								}
							}
						}
						if(self.Form.transactionAddOns && self.Form.transactionAddOns.length){
							for(let i=0; i<self.Form.transactionAddOns.length; i++){
								self.Form.transactionAddOns[i].transactionAddOnsId = self.guid();
							}
						}
						self.fn_bindTransactionNumber();
					}

					if(self.$route.query.section_id){
						setTimeout(() => {
							self.fn_bindDynamicFields(self.$route.query.section_id);
						}, 300);
					}

					setTimeout(function(){
						// assigning at the end as making roundOffValue null while calculating net amount;
						self.Form.roundOffValue = data.roundOffValue;
						self.$root.fn_copyFormObject(self.Form, self.formId);
					},500);

				});

			},

			fn_getSavedGstAddOns: function (groupId, gstAddOnsId) {
				if(!this.Form.isNew && this.Form.savedItemData && this.Form.savedItemData.transactionProducts){
					let productItem = this.Form.savedItemData.transactionProducts.find(item=>{
						return item.groupId == groupId;
					});

					if(productItem){
						let gstAddOnsItem = productItem.transactionProductAddOns.find(addOnsItem=>{
							return addOnsItem.addOnsId == gstAddOnsId && addOnsItem.isGst;
						});

						// if true function will break here and will return transactionProductsAddOnsId
						if(gstAddOnsItem && gstAddOnsItem.transactionProductsAddOnsId)
							return gstAddOnsItem.transactionProductsAddOnsId;
					}
				}
				
				return null;
			},

			fn_clearForm: function(){
				this.unwatch = true;
				this.Form = {
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
					"partyId":null, "partyName":null, "partylastConfig":null,
					"currencyId":null, "currencyCode":null, "exchangeRate":null,
					"taxMode":0,
					"transactionTypeFormId":null, "transactionTypeFormName":null,

					"items":[],

					"productDataModel": {"groupId":null, "productId":null, "productName":null, "mrp":null, "rate":null, "productVariants":[], "taxValue":null, "taxAmount":0, "hsnCode":null, "orderNumber":null, "grossAmount":0, "grossAmountAsPerMRP":0, "netAmount":0, "addOnsItems":[], "cessValue":null, "taxCategoryId": null, "taxCategoryName": null, 
						"defaultTaxValue":null, "defaultCessValue":null, "defaultHsnCode":null, "defaultTaxCategoryId":null, "defaultTaxCategoryName": null, "isCessApplicable":false, "taxableValue":null
					},

					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},

					"tdsDataModel":{
						"transactionTdsId":null, "transactionId":null, "tdsAccountId":null, "tdsAccountName":null, "appliedOnAmount":null, "percentage":null, "amount":null
					},

					"transactionAddOns":[],

					"tdsDetails":{"amount":0},

					"addOnsProp":{},

					"itemsSummary":{"grossAmount":0, "grossAmountAsPerMRP":0, "addOnsItems":[], "taxValue":0, "itemsQuanity":[]},

					"settings":{"isInterState":false},

					"transactionTypeData":null,
					"dynamicFields":{"section":null, "items":[], "accountGroupId":null, "accountGroupName":null, "ref":null},

					"dynamicFieldsAdditionalData":{},

					"customFields":[],

					"dynamicMenuItems":[],

					"partyDetails":null,

					"gstType":null,

					"defaultTaxAddOns":[],

					"gstAddOns":[],
					"cessAddOns":null,

					"savedItemData":null,
					"isNew":true,

					"pendingItemsList":null,

					"pendingOrders":[],
					"pendingChallans":[],
					"pendingInvoices":[],
					"isPendingItems":false,
					"transactionTypeList":[],
					"draftItems":[],
					"hideEwayOption": false,
					"placeOfSupplyId":null,
					"placeOfSupplyName":null,
					"placeOfSupplyCountryId":null,
					"placeOfSupplyCountryName":null,
					// "partyGstType":null,
					"netInvoiceValue":null,
					"isRounded":true,
					"itemType":0,
					"isRcmApplicable":false
				};

				this.fn_initializeSettings();

				this.fn_getTransactionTypeList(true);
			},

			// fn_saveToLocalStorage: function(){
			// 	if(!this.unwatch){
			// 		var dataObj = {};
			// 		dataObj.type = this.toolbarTitle;//formName
			// 		dataObj.formType = "new";//eliminate
			// 		dataObj.modifiedDate = new Date();
			// 		dataObj.formId = this.formId;
			// 		dataObj.draftId = this.draftStorageId;
			// 		dataObj.uri = this.$route.path;//formPath
			// 		dataObj.dataModel = JSON.parse(JSON.stringify(this.Form));//data
			// 		dataObj.dataModel.name = this.Form.partyName ? this.Form.partyName : "no name";

			// 		localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
			// 	}
			// 	this.unwatch = false;
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){

				this.backButtonPress = false;
				if(menuAction.indexOf('section_')!=-1){
					let sectionId = menuAction.substring(menuAction.indexOf('_')+1);
					this.fn_bindDynamicFields(sectionId);
				}
				else if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='newledger'){
					//Force save to local storage as dynamic fields need to be save in local storage
					this.fn_saveDraft(this.Form.partyName);
					// this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), ls:1, type:'ledger'}})
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId: ledgerGroupTypeId.other, ls:1, type:this.ledgerType}})
				}
				else if(menuAction=='newsupplier'){
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), groupTypeId: ledgerGroupTypeId.supplier, ls:1, type:'supplier'}})
				}
				else if(menuAction=='dynamicAccountField'){
					this.fn_newDynamicAccount()
				}
				else if(menuAction=='newproduct'){
					if(this.toolbarTitle == 'Debit Note'){
						this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1, service_account_item:1}});
					}
					else{
						this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1}});
					}
					
				}
				else if(menuAction=='newListItem'){
					//Force save to local storage as dynamic fields need to be save in local storage
					this.fn_saveDraft(this.Form.partyName);
					this.$router.push({path:'/masters/lists/'+this.Form.dynamicFieldsAdditionalData.listId+'/items/new', query:{tagId:this.guidWeb(), listTitle:this.Form.dynamicFieldsAdditionalData.listName, ls:1, type:'listItem'}});
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
				else if(menuAction=='addnote'){
					this.fn_addNote();	
				}
				// else if(menuAction=='attachdocuments'){
				// 	if(!this.$root.CurrentBusiness.DataDrive){
				// 		this.showToast("Set up backup drive to attach documents");
				// 		return;
				// 	}
				// 	this.fn_uploadFiles();
				// }
				else if(menuAction=='camera'){
					let self = this;
					this.$root.fn_checkCameraPermission(function(){
	                   	self.fn_captureImage();
	                });
				}
                else if(menuAction=='fileManager'){
					let self = this;
					this.$root.fn_checkStoragePermission(function(){
	                   	self.fn_uploadFiles(); 
	                });
				}
				else if(menuAction=='applytds'){
					this.fn_openTdsForm();
				}
				else if(menuAction=='addonsmenu'){
					this.fn_openAddOns(null, true);
				}
				// else if(menuAction=='addOns'){
				// 	this.fn_getBottomMenuAddOns();
				// }
				else if(menuAction=='adddiscount'){
					this.$router.push({path:'/addons/discounts/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='addtaxes'){
					this.$router.push({path:'/addons/taxes/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='addothercharges'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), ls:1}});
				}
				else if(menuAction=='loadpurchaseorder'){
					this.fn_loadItems(transactionTypes.purchaseOrder.id, this.Form.pendingOrders, 'ref_dialogOrders');
				}
				else if(menuAction=='loadpurchasechallan'){
					this.fn_loadItems(transactionTypes.purchaseChallan.id, this.Form.pendingChallans, 'ref_dialogChallans');
				}
				else if(menuAction=='loadpurchaseinvoice'){
					this.fn_loadItems(transactionTypes.purchaseInvoice.id, this.Form.pendingInvoices, 'ref_dialogInvoices');
				}
				else if(menuAction=='newbroker'){
					this.fn_newBroker();
				}
				else if(menuAction=='newgodown'){
					this.fn_newGodown();
				}
				// else if(menuAction=='cancel'){
				// 	this.fn_openDialogCancelTransaction();
				// }
			},

			fn_newDynamicAccount: function(){
				let groupTypeId = null;
				if(this.Form.dynamicFields.accountGroupId == accountGroupIds.debtors.id)
					groupTypeId = 101;
				else if(this.Form.dynamicFields.accountGroupId == accountGroupIds.creditors.id || this.Form.dynamicFields.accountGroupId == accountGroupIds.transporter.id)
					groupTypeId = 102;
				else if(this.Form.dynamicFields.accountGroupId == accountGroupIds.brandAndDivision.id)
					groupTypeId = 104;
				else
					groupTypeId = 103;

				// setting up default account group to be selected
				let data = {};
				data.type = 'accountGroup';
				data.id = this.Form.dynamicFields.accountGroupId;
				data.name = this.Form.dynamicFields.accountGroupName;
				localStorage.setItem('newItem', JSON.stringify(data));

				this.$router.push({
					path:'/masters/accounts/ledgers/items/new', 
					query:{
						tagId:this.guidWeb(), 
						groupTypeId: groupTypeId, 
						ls:1
					}
				})
			},

			// fn_openDialogCancelTransaction: function(){
			// 	this.confirmationMessage = "Cancelled transaction cannot be revoke."
			// 	this.fn_openDialogWeb('web', 'Cancel Transaction', 'ref_dialogCancelTransaction');
			// },

			fn_openDialogPendingItemsList: function (ref) {
				this.fn_openDialogWeb('web', 'PendingItemsList', ref);
			},

			fn_openDialogReturnForm: function (ref) {
				this.fn_openDialogWeb('web', 'ReturnForm', ref);
			},

			fn_bindDynamicFields: function (sectionId) {

				this.Form.dynamicFields = {"section":null, "items":[], "additionalData":{}, "accountGroupId":null, "accountGroupName":null};

				let itemIndex = this.Form.customFields.findIndex(item=>{
					return item.section.sectionId == sectionId;
				});

				this.Form.dynamicFields.section = this.Form.transactionTypeData.transactionSections.find(item=>{
					return sectionId == item.sectionId;
				});

				this.Form.dynamicFields.items = this.Form.transactionTypeData.transactionTypeFields.filter(item=>{
					if(sectionId == item.sectionId){
						item.additionalData = typeof(item.additionalData) == 'string' ? JSON.parse(item.additionalData) : item.additionalData;
						item.value = null;
						item.listItemId = null;
						item.accountLedgerId = null;

						if(item.fieldType == 'yes/no'){
							item.value = item.additionalData.defaultValue;
						}

						if(item.fieldType == 'choice'){
							item.value = item.additionalData.defaultChoice;
							// item.value = item.additionalData.choices[0];
						}

						// if(item.fieldType == 'dateTime'){
						// 	item.value = new Date();
						// }
						
						return true;
					}
				});

				if(itemIndex!=-1){

					for(let i=0; i<this.Form.dynamicFields.items.length; i++){

						let defaultField = this.Form.dynamicFields.items[i];

						for(let j=0; j<this.Form.customFields[itemIndex].items.length; j++){

							let existingField = this.Form.customFields[itemIndex].items[j];

							if(defaultField.fieldId == existingField.fieldId){
								defaultField.value = existingField.value;

								if(defaultField.fieldType == 'linkedItem'){
									defaultField.listItemId = existingField.listItemId;
								}
								else if(defaultField.fieldType == 'accountItem'){
									defaultField.accountLedgerId = existingField.accountLedgerId;
								}

							}

						}

					}

				}
				

				console.log(JSON.stringify(this.Form.dynamicFields));

				this.fn_openDialogDynamicFields();
			},

			fn_openDialogDynamicFields: function () {
				this.fn_openDialogWeb('web', 'DynamicFields', 'ref_dialogDynamicFields');
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;
				
				if(this.Form.transactionData.transactionId){
					this.fn_get(this.Form.transactionData.transactionId);
				}
				else{
					this.fn_clearForm();
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					// self.snackbar = true;
					// self.snackbar_msg = "Item deleted from draft";
					self.showToast("Item deleted from draft");
				});
			},

			fn_initializeSettings: function () {
				let self = this;
				transactionForms.filter(item => {
					if(item.id == this.settings.transactionTypeId){
						this.unwatch = true;
						this.toolbarTitle = item.title;
						this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
						// this.Form.transactionData.transactionDate = new Date();
						// this.Form.transactionData.refDate = new Date();
						if(new Date().getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
							this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
							// this.Form.transactionData.refDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
						}
						else{
							this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();
							// this.Form.transactionData.refDate = this.$root.fn_getLocalDateFormat();
						}
					}
				});

				if(this.$route.path.indexOf('debitnote') != -1){
					this.toolbarTitle = 'Debit Note';
				}

				let typeId = this.settings.transactionTypeId;

				if(typeId == transactionTypes.purchaseChallan.id || typeId == transactionTypes.purchaseInvoice.id 
					|| typeId == transactionTypes.purchaseReturn.id){
					this.passStockEntry = true;
				}

				if(typeId == transactionTypes.purchaseInvoice.id || typeId == transactionTypes.purchaseReturn.id){
					this.passLedgerEntry = true;
				}

				this.fn_getDefaultGstAddOns();
				this.fn_getDefaultCessAddOns();
				this.fn_getTaxCategories();

				if(this.$route.query.copy && !this.$root.CurrentBusiness.DataDrive){
					this.fn_checkTransactionCount(()=>{
						if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
							this.fn_openDialogDriveSetup();
						}
					})
				}

				if(this.Form.isNew && this.$root.TransactionSettings.enableGodown){
					this.Form.godownId = fixedGodownIds.mainGodown.id;
					this.Form.godownName = fixedGodownIds.mainGodown.name;
				}
			},

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			// fn_setFormDataFromLocalStorage: function () {
			// 	if(localStorage.getItem(this.draftStorageId)){
			// 		var formData = JSON.parse(localStorage.getItem(this.draftStorageId));
			// 		this.unwatch = true;
			// 		this.Form = JSON.parse(JSON.stringify(formData.dataModel));

			// 		if((this.$route.query && this.$route.query.draft) || (this.$route.params && this.$route.params.tagId)){
			// 			this.loadedFromDraft = true;
			// 			this.Form.isNew ? this.fn_getTransactionTypeData(this.Form.transactionTypeFormId, null, false, 'draft') : '';
			// 		}
			// 	}
			// },

			fn_refreshTransactionTypeData: function(transactionTypeData){

				this.fn_bindTransactionNumber();

				// if(this.Form.partyId && !transactionTypeData.isAllPartySelected){
				// 	this.fn_validateParty(transactionTypeData.transactionParties);
				// }

				if(this.Form.partyId){
					this.fn_validateParty(transactionTypeData.transactionParties);
				}

				let self = this;

				self.Form.productDataModel.addOnsItems = [];

				transactionTypeData.transactionTypeAddOns.forEach(function (item) {
					if(item.type==0){
	          			self.Form.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
					}
	          	});


	          	for(let i=0; i<this.Form.items.length; i++){

	          		let addOnsItems = [];

					for(let j=0; j<transactionTypeData.transactionTypeAddOns.length; j++){

						if(transactionTypeData.transactionTypeAddOns[j].type==0){

							for(let k=0; k<this.Form.items[i].addOnsItems.length; k++){
								if(this.Form.items[i].addOnsItems[k].addOnsId == transactionTypeData.transactionTypeAddOns[j].addOnsId){
									addOnsItems.push(this.Form.items[i].addOnsItems[k]);
								}
							}

						}

					}

					this.Form.items[i].addOnsItems = JSON.parse(JSON.stringify(addOnsItems));
				}

				// binding dynamic field options to the menu
				// this.Form.dynamicMenuItems = [];

				// if(transactionTypeData && transactionTypeData.transactionSections.length){
				// 	transactionTypeData.transactionSections.forEach(function (item) {
				// 		let obj = {};
				// 		obj.MenuID = null;
				// 		obj.Icon = null;
				// 		obj.Text = item.sectionName;
				// 		obj.Action = 'section_'+item.sectionId;
				// 		obj.sectionId = item.sectionId;
				// 		obj.hideOption = false;
				// 		self.Form.dynamicMenuItems.push(obj);
				// 	});
				// }

				//inserting eway bill details to transaction type fields manually
				this.fn_bindEwayBillSection();

				// this.hideLoading();
				this.loading = false;
			},

			fn_setNewItem: function(){
				let itemData = null;
				let self = this;
				if(localStorage.getItem('newItem')){

					itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "transactionTypeForm":
					    	this.fn_setTransactionType({transactionTypeFormId:itemData.id, name:itemData.name});
					        break;
					    case "supplier":
					    	this.fn_updateSupplier(itemData.id, itemData.name, false);
					        break;
					    case "product":
							this.fn_setNewProduct(itemData.id, itemData.name, false);
					    	// this.$refs['ref_dialogProduct'].fn_updateProduct(itemData.id, itemData.name, false);
					        break;
					    case "newTaxCategory":
					    	this.fn_updateTaxCategory(itemData, true);
					        break;
					    case "discounts":
					    case "taxes":
					    case "otherCharges":
							this.fn_setNewAddOns(itemData.id, itemData.name, false);
					    	// this.$refs['ref_dialogAddOns'].fn_updateAddOns(itemData.id, itemData.name, false);
					        break;
					    case "listItem":
					    	// this.fn_updateLinkedItem(itemData);
					    	this.$refs['ref_dialogDynamicFields'].fn_updateLinkedItem(itemData.id, itemData.name, false)
					        break;
					    case "ledger":
					    	// this.fn_updateAccountLedger(itemData);
					    	this.$refs['ref_dialogDynamicFields'].fn_updateAccountLedger(itemData.id, itemData.name, false, null, itemData.accountGroupId)
					        break;
					    case "ledger_other":
					    	this.fn_getPaymentGroups();
					        break;
						case "broker":
					    	this.fn_updateBroker(itemData.id, itemData.name, false);
							break;
						case "godown":
					    	this.fn_updateGodown(itemData.id, itemData.name, false);
					        break;
					        
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				if(this.$route.query && this.$route.query.dt && !itemData){
					this.fn_updateSupplier(this.$route.query.id, this.$route.query.name, false);
				}
			},

			// fn_updateLinkedItem: function(itemData){
			// 	let self = this;
			// 	setTimeout(function(){
			// 		self.$refs['ref_dialogDynamicFields'].fn_updateLinkedItem(itemData.id, itemData.name, false)
			// 	},1000)
			// },

			// fn_updateAccountLedger: function(itemData){
			// 	let self = this;
			// 	setTimeout(function(){
			// 		self.$refs['ref_dialogDynamicFields'].fn_updateAccountLedger(itemData.id, itemData.name, false)
			// 	},1000)
			// },

			fn_showSnackBar: function(msg, timeout){
				let self = this;
				setTimeout(function(){
					// self.snackbar = true;
					// self.snackbar_msg = msg;
					self.showToast(msg);
				},timeout);
			},

			fn_updateBroker: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.brokerId = selectedValueId;
		        	this.Form.brokerName = selectedValueName;
				}
				else{
					this.Form.brokerId = null;
		        	this.Form.brokerName = null;
				}
			},

			fn_newBroker: function(){
				// setting up default account group to be selected
				let data = {};
				data.type = 'accountGroup';
				data.id = accountGroupIds.brokers.id;
				data.name = accountGroupIds.brokers.name;
				localStorage.setItem('newItem', JSON.stringify(data));

				this.$router.push({
					path:'/masters/accounts/ledgers/items/new', 
					query:{
						tagId:this.guidWeb(), 
						groupTypeId: 103, 
						ls:1,
						type:'broker',
					}
				})
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				// !this.$root.CurrentBusiness.DataDrive && localStorage.getItem("SetDataDrive") ?  this.fn_checkTransactionCount() : '';
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ?  this.fn_checkTransactionCount() : '';
			// if(!this.$root.CurrentBusiness.DataDrive){
			// 	this.fn_checkTransactionCount(()=>{
			// 		if(this.transactionCount>10){
			// 			this.fn_openDialogDriveSetup();
			// 		}
			// 	})
			// }

			var formsArray = [];
			if(localStorage.getItem('purchaseforms')){
				formsArray = JSON.parse(localStorage.getItem('purchaseforms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('purchaseforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}
			// dialogjs.fn_checkAndShowOpenDialogs(this);

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				this.unwatch = true;
				// this.fn_setFormDataFromLocalStorage();
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.draftModifiedDate = draft.modifiedDate;
						self.Form = JSON.parse(draft.formData);

						if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
							// self.loadedFromDraft = true;

							if(self.Form.isNew){
								self.fn_getTransactionTypeData(self.Form.transactionTypeFormId, null, false, 'draft');
							}
							else{
								self.loading = false;
							}

							// self.Form.isNew ? self.fn_getTransactionTypeData(self.Form.transactionTypeFormId, null, false, 'draft') : '';
						}
						else{
							self.loading = false;
						}
					}

		            self.$route.query.tagId ? self.fn_checkDraftItems(self.toolbarTitle) : '';

				});
			}

			this.fn_initializeSettings();

			// posting metrics on open
			this.fn_isDraft(isDraft=>{
				if(!isDraft){
					let postObj = {"eventName":this.toolbarTitle.toLowerCase() + '_open',"eventData":[{"eventKey":"form_type","eventValue":this.$route.params && this.$route.params.tagId && !this.$route.query.copy ? "edit" : "new"}]}
        			this.$root.fn_postMetrics(postObj);
				}
			})

			// let formElement = document.getElementsByClassName("form-element")[0];

			// formElement.addEventListener("submit", function(e){
			//     e.preventDefault();
			// });

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('Transaction', this.toolbarTitle);
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
				}

				//edit from list view
		  		else if(to.params && to.params.tagId){
		  			itemId = to.params.tagId;
		  		}
		  		//checking if draft exist
		  		vm.fn_isDraft(function(isDraft){
		  			if(itemId && !isDraft){
		  				vm.fn_get(itemId);
		  			}

		  			let setTFT = !itemId && !isDraft;

		  			vm.fn_getTransactionTypeList(setTFT);
		  		})


		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('purchaseforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {

			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true, 1);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('purchaseforms', function(){
						localStorage.removeItem("SetDataDrive");
						next();
					})
				}
			}

			// if(this.$refs['ref_dialogPermission'].dialog_permission){
			// 	this.$refs['ref_dialogPermission'].dialog_permission = false;
			// 	next(false);
			// }
			// else{
			// 	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			// 	if(dialogData && dialogData.length){

			// 		if(this.backButtonPress){
			// 			dialogjs.fn_checkAndCloseOpenDialogs(this);
			// 			next(false);
			// 		}
			// 		else{
			// 			localStorage.removeItem("SetDataDrive");
			// 			next(true);
			// 		}
			// 	}
			// 	else{
			// 		if(this.fn_showDialogDiscard()){
			// 			this.fn_openDialogDiscard();
			// 			next(false);
			// 		}
			// 		else{
			// 			this.fn_clearData('purchaseforms', function(){
			// 				localStorage.removeItem("SetDataDrive");
			// 				next();
			// 			})
			// 		}
			// 	}
			// }
			
			
	    },
	    computed:{
	    	netAmount: function () {
	    		let netAmount = 0;
	    		let grossAmount = 0;
	    		let grossAmountAsPerMRP = 0;
	    		let taxValue = 0;
	    		let cessValue = 0;
				let cessValueOnQuantity = 0;
	    		let taxableValue = 0;
	    		let self = this;

	    		this.Form.itemsSummary.addOnsItems = [];
	    		this.Form.itemsSummary.itemsQuanity = [];

	    		this.Form.items.forEach(function (item) {
	    			grossAmount += item.grossAmount;
	    			grossAmountAsPerMRP += item.grossAmountAsPerMRP;

	    			taxableValue += item.taxableValue;

	    			item.addOnsItems.forEach(function (addOnsItem) {

	    				if(addOnsItem.value!==null && addOnsItem.value!==''){
	    					let value = addOnsItem.value;

		    				let itemIndex = self.Form.itemsSummary.addOnsItems.findIndex(onsItem=>{
		    					return onsItem.addOnsId == addOnsItem.addOnsId;
								// return onsItem.addOnsType == addOnsItem.addOnsType;
		    				})

		    				if(itemIndex!=-1){
		    					let addOnsSum = self.Form.itemsSummary.addOnsItems[itemIndex].value;
		    					addOnsSum += value;
		    					self.Form.itemsSummary.addOnsItems[itemIndex].value = self.roundUpto2Decimals(addOnsSum);
								if(self.Form.itemsSummary.addOnsItems[itemIndex].percentage != addOnsItem.percentage){
									self.Form.itemsSummary.addOnsItems[itemIndex].percentage = null;
								}
							}
		    				else{
		    					let obj = {};
		    					obj.addOnsId = addOnsItem.addOnsId;
		    					obj.name = addOnsItem.name;
		    					obj.value = addOnsItem.value;
		    					obj.mode = addOnsItem.mode;
		    					obj.nature = addOnsItem.nature;
								obj.addOnsType = addOnsItem.addOnsType;
								obj.percentage = addOnsItem.percentage;
		    					self.Form.itemsSummary.addOnsItems.push(obj);
		    				}
	    				}

	    			})

	    			if(self.Form.taxMode!=null){
	    				taxValue += item.taxAmount;
	    				cessValue += item.cessAmount;
						if(item.cessValueOnQuantity && item.productVariants && item.productVariants.length){
							cessValueOnQuantity += (item.cessValueOnQuantity * item.productVariants[0].qty)
						}
	    			}

	    			netAmount += item.netAmount;

	    			item.productVariants.forEach(function (variantItem) {

	    				let qty = variantItem.qty ? variantItem.qty : 0;

	    				console.log(variantItem);

	    				let itemIndex = self.Form.itemsSummary.itemsQuanity.findIndex(vItem=>{
	    					console.log(vItem);
	    					return vItem.unitId == variantItem.unitId && vItem.packQuantity == variantItem.packQuantity;
	    				});

	    				if(itemIndex!=-1){
	    					self.Form.itemsSummary.itemsQuanity[itemIndex].qty += qty;
	    				}
	    				else{
	    					let vObj = {};
		    				vObj.unitId = variantItem.unitId;
		    				vObj.unitName = variantItem.unitName;
		    				vObj.packQuantity = variantItem.packQuantity;
		    				vObj.qty = qty;
		    				self.Form.itemsSummary.itemsQuanity.push(vObj);
	    				}
	    			})

	    		});

	    		this.Form.itemsSummary.grossAmount = !this.Form.items.length ? this.Form.netInvoiceValue : this.roundUpto2Decimals(grossAmount);
				this.Form.itemsSummary.grossAmountAsPerMRP = !this.Form.items.length ? this.Form.netInvoiceValue : this.roundUpto2Decimals(grossAmountAsPerMRP);
				this.Form.itemsSummary.taxValue = this.roundUpto2Decimals(taxValue); 
				this.Form.itemsSummary.cessValue = this.roundUpto2Decimals(cessValue);
				this.Form.itemsSummary.cessValueOnQuantity = this.roundUpto2Decimals(cessValueOnQuantity);

				// if(this.Form.items.length){
				// 	this.Form.transactionData.taxableValue = taxableValue;
				// }
				// else{
				// 	if(this.$root.CurrentBusiness.GSTRegistrationStatus==1){
				// 		this.Form.transactionData.taxableValue = this.Form.netInvoiceValue;
				// 	}
				// 	else{
				// 		this.Form.transactionData.taxableValue = this.roundedAmount;
				// 	}
				// }
				this.Form.transactionData.taxableValue = !this.Form.items.length ? this.Form.netInvoiceValue : taxableValue;

	    		console.log(JSON.stringify(this.Form.itemsSummary));

	    		// this.Form.roundOffValue = null;

	    		// let netAmountAsPerType = null;
	    		// if(this.Form.items.length){
	    		// 	netAmountAsPerType = this.roundUpto2Decimals(netAmount);	
	    		// }
	    		// else{
	    		// 	netAmountAsPerType = this.roundUpto2Decimals(this.Form.netInvoiceValue);
	    		// }

	    		// if(this.Form.isRcmApplicable){
	    		// 	return this.roundUpto2Decimals(netAmountAsPerType - taxValue - cessValue);	
	    		// }
	    		// else{
	    		// 	return netAmountAsPerType;
	    		// }

	    		if(this.Form.items.length){
	    			// putting these hack in case of rcm update just to recompute values
	    			if(this.Form.isRcmApplicable){
	    				return this.roundUpto2Decimals(netAmount);	
	    			}
	    			else{
	    				return this.roundUpto2Decimals(netAmount);	
	    			}
	    		}
	    		else{
	    			return this.roundUpto2Decimals(this.Form.netInvoiceValue);
	    		}
	    	},
	    	totalAmount: function () {
	    		let grossAmount = 0;
	    		let grossAmountAsPerMRP = 0;
	    		let netAmount = this.netAmount;
	    		if(this.Form.items.length){
	    			grossAmount = this.Form.itemsSummary.grossAmount;
	    			grossAmountAsPerMRP = this.Form.itemsSummary.grossAmountAsPerMRP
	    		}
	    		else{
	    			grossAmount = this.Form.netInvoiceValue;
	    			grossAmountAsPerMRP = this.Form.netInvoiceValue;
	    		}
	    		// let grossAmount = !this.Form.items.length ? this.Form.netInvoiceValue : this.Form.itemsSummary.grossAmount;
	    		// let grossAmountAsPerMRP = !this.Form.items.length ? this.Form.netInvoiceValue : this.Form.itemsSummary.grossAmountAsPerMRP;
	    		// let netAmount = this.netAmount;

	    		let totalAmount = 0;

	    		let self = this;

	    		let addOnsTotalValue = 0;

	    		this.Form.transactionAddOns.forEach(function (item) {

					let applicableAmount = 0;
					let addOnsValue = 0;

					//on net value
					if(item.appliedOn == 0){
						applicableAmount = netAmount;
					}//value of goods
					else if(item.appliedOn == 1){
						applicableAmount = grossAmount;
					}//on mrp
					else{
						applicableAmount = grossAmountAsPerMRP;
					}

					//of value or percentage
					if(item.mode){//value
						addOnsValue = item.value;
					}
					else{//percentage
						if(item.percentage!==null && item.percentage!==''){
							addOnsValue = (applicableAmount*item.percentage)/100;
							item.value = self.roundUpto2Decimals(addOnsValue);
						}
						else if(item.value!==null && item.value!==''){
							addOnsValue = item.value;
						}
					}

					addOnsValue = self.roundUpto2Decimals(addOnsValue);

					let isTaxLedger = false;
					if(fixedGstAddOns.CGST.id == item.addOnsId || fixedGstAddOns.SGST.id == item.addOnsId || fixedGstAddOns.UTGST.id == item.addOnsId || fixedGstAddOns.IGST.id == item.addOnsId || fixedCessAddOns.CESS.id == item.addOnsId){
						isTaxLedger = true;
					}

					//Final calculation
					if(item.adjustInTotal){
						if(item.nature==0){
							if(self.Form.isRcmApplicable && isTaxLedger){
								addOnsTotalValue += item.addOnsType != 2 ? addOnsValue : 0;
							}
							else{
								addOnsTotalValue += addOnsValue;
							}
						}
						else{
							addOnsTotalValue -= addOnsValue;
						}
					}
					// if(item.adjustInTotal){
					// 	if(item.nature==0){
					// 		addOnsTotalValue += addOnsValue;
					// 	}
					// 	else{
					// 		addOnsTotalValue -= addOnsValue;
					// 	}
					// }

				});

	    		totalAmount = this.netAmount + addOnsTotalValue - this.Form.tdsDetails.amount;

				return this.roundUpto2Decimals(totalAmount);
	    	},

	    	// roundedAmount: function(){
	    	// 	if(this.Form.isRounded){
	    	// 		return Math.round(this.totalAmount);	
	    	// 	}
	    	// 	else{
	    	// 		return this.totalAmount;
	    	// 	}
	    	// },


	    	// roundOff: function(){
	    	// 	return this.roundUpto2Decimals(this.roundedAmount - this.totalAmount);
	    	// },

	    	roundOff: function(){
	    		let roundAmount = null;
	    		if(this.Form.isRounded){
	    			roundAmount = Math.round(this.totalAmount);
	    		}
	    		else{
	    			this.Form.roundOffValue = null;
	    			roundAmount = this.totalAmount;
	    		}

	    		if(this.Form.roundOffValue){
	    			return this.Form.roundOffValue;
	    		}
	    		else{
	    			// return this.roundUpto2Decimals(this.roundedAmount - this.totalAmount);
	    			return this.roundUpto2Decimals(roundAmount - this.totalAmount);
	    		}
	    	},

	    	roundedAmount: function(){
	    		return this.roundUpto2Decimals(this.totalAmount + this.roundOff);
	    	},

	    	expandCustomFields: function(){
	    		let expantionModel = [];
	    		for(let i in this.Form.customFields){
	    			expantionModel.push(true);
	    		}
	    		return expantionModel;
	    	},
	    	
	    	filteredItems: function () {

	    		let self = this;

	    		let groups = {
					order: [],
					challan: [],
					invoice: [],
					self: [],
				}

	    		let objSelf = {};
	    		objSelf.header = "Items";
	    		// objSelf.baseTransactionNumber = self.Form.transactionData.transactionNumber;
	    		objSelf.baseTransactionNumber = self.Form.transactionData.mergeTransactionNumber;
	    		objSelf.baseTransactionId = null;
	    		objSelf.items = [];

				this.Form.items.forEach(function (itemData) {
					// if(itemData.baseTransactionListId == self.settings.transactionTypeId && itemData.baseTransactionNumber == self.Form.transactionData.transactionNumber){
					// if(itemData.baseTransactionListId == self.settings.transactionTypeId && itemData.baseTransactionNumber == self.Form.transactionData.mergeTransactionNumber){
					if(itemData.baseTransactionListId == self.settings.transactionTypeId){
						itemData.baseTransactionNumber = self.Form.transactionData.mergeTransactionNumber;
						objSelf.items.push(itemData);
					}
				});

				// sorting items as per order number
				objSelf.items.sort(function(a, b){
				  	return a.orderNumber - b.orderNumber;
				});

				groups.self.splice(0, 1, objSelf);

				if(this.Form.transactionData.transactionListId == transactionTypes.purchaseInvoice.id || this.Form.transactionData.transactionListId == transactionTypes.purchaseChallan.id){

					//purchase orders inside purchase invoice and purchase challans
					self.Form.pendingOrders.forEach(function (item) {

						let objOrder = {};
						objOrder.items = [];

						objOrder.header = "Purchase Order";
						objOrder.baseTransactionNumber = item.baseTransactionNumber;
						objOrder.baseTransactionId = item.transactionId;

						objOrder.items = self.Form.items.filter(itemData=>{
							return item.baseTransactionNumber == itemData.baseTransactionNumber && itemData.baseTransactionListId == transactionTypes.purchaseOrder.id;
						});

						// sorting order items as per order number
						objOrder.items.sort(function(a, b){
						  	return a.orderNumber - b.orderNumber;
						});
						
						groups.order.push(objOrder);
					});

					// if(this.Form.pendingOrders.length){
					// 	if(this.loadedFromDraft){
					// 		let transactionIds = [];
					// 		for(let i=0; i<this.Form.pendingOrders.length; i++){
					// 			transactionIds.push(self.Form.pendingOrders[i].transactionId);
					// 		}

					// 		self.fn_checkPendingTransaction(transactionIds, function(response){
					// 			if(!response){
					// 				pushPendingItems(self.Form.pendingOrders, 'Order');
					// 			}
					// 			else{
					// 				// self.fn_removeGroup('order', self.Form.pendingOrders[i].baseTransactionNumber);
					// 				self.Form.isNew ? self.fn_resetForm() : self.fn_get(self.Form.transactionData.transactionId);
					// 				self.fn_showSnackBar("Transaction resets as last tagged item(s) have been used already.", 400);
					// 			}
					// 		})
							
					// 	}
					// 	else{
					// 		pushPendingItems(this.Form.pendingOrders, 'Order');
					// 	}
					// }


					//purchase challans inside purchase invoice
					if(this.Form.transactionData.transactionListId == transactionTypes.purchaseInvoice.id){

						self.Form.pendingChallans.forEach(function (item) {

							let objChallan = {};
							objChallan.items = [];

							objChallan.header = "Purchase Challan";
							objChallan.baseTransactionNumber = item.baseTransactionNumber;
							objChallan.baseTransactionId = item.transactionId;

							objChallan.items = self.Form.items.filter(itemData=>{
								return item.baseTransactionNumber == itemData.baseTransactionNumber && itemData.baseTransactionListId == transactionTypes.purchaseChallan.id;
							});

							// sorting challan items as per order number
							objChallan.items.sort(function(a, b){
							  	return a.orderNumber - b.orderNumber;
							});
							
							groups.challan.push(objChallan);
						});

						// if(this.Form.pendingChallans.length){
						// 	if(this.loadedFromDraft){
						// 		for(let i=0; i<this.Form.pendingChallans.length; i++){
						// 			(function(i){
						// 				self.fn_checkPendingTransaction(self.Form.pendingChallans[i].transactionId, function(response){
						// 					if(!response){
						// 						pushPendingItems(self.Form.pendingChallans, 'Purchase Challan');
						// 					}
						// 					else{
						// 						// self.fn_removeGroup('challan', self.Form.pendingChallans[i].baseTransactionNumber);
						// 						self.Form.isNew ? self.fn_resetForm() : self.fn_get(self.Form.transactionData.transactionId);
						// 						self.snackbar = true;
						// 						self.snackbar_msg = "Transaction resets as last tagged item(s) have been used already.";
						// 					}
						// 				})
						// 			}(i))
						// 		}
								
						// 	}
						// 	else{
						// 		pushPendingItems(this.Form.pendingChallans, 'Purchase Challan');
						// 	}
						// }

					}

				}

				else if(this.Form.transactionData.transactionListId == transactionTypes.purchaseReturn.id){

					//purchase invoice inside purchase return
					self.Form.pendingInvoices.forEach(function (item) {

						let objInvoice = {};
						objInvoice.items = [];

						objInvoice.header = "Purchase Invoice";
						objInvoice.baseTransactionNumber = item.baseTransactionNumber;
						objInvoice.baseTransactionId = item.transactionId;

						objInvoice.items = self.Form.items.filter(itemData=>{
							return item.baseTransactionNumber == itemData.baseTransactionNumber && itemData.baseTransactionListId == transactionTypes.purchaseInvoice.id;
						});

						// sorting invoice items as per order number
						objInvoice.items.sort(function(a, b){
						  	return a.orderNumber - b.orderNumber;
						});
						
						groups.invoice.push(objInvoice);
					});

					// if(this.Form.pendingInvoices.length){
					// 	if(this.loadedFromDraft){
					// 		for(let i=0; i<this.Form.pendingInvoices.length; i++){
					// 			(function(i){
					// 				self.fn_checkPendingTransaction(self.Form.pendingInvoices[i].transactionId, function(response){
					// 					if(!response){
					// 						pushPendingItems(self.Form.pendingInvoices, 'Purchase invoice');
					// 					}
					// 					else{
					// 						// self.fn_removeGroup('invoice', self.Form.pendingInvoices[i].baseTransactionNumber);
					// 						self.Form.isNew ? self.fn_resetForm() : self.fn_get(self.Form.transactionData.transactionId);
					// 						self.snackbar = true;
					// 						self.snackbar_msg = "Transaction resets as last tagged item(s) have been used already.";
					// 					}
					// 				})
					// 			}(i))
					// 		}
							
					// 	}
					// 	else{
					// 		pushPendingItems(this.Form.pendingInvoices, 'Purchase invoice');
					// 	}
					// }

				}

				// function pushPendingItems(pendingItems, header){
					
				// 	pendingItems.forEach(function (item) {

				// 		let itemObj = {};
				// 		itemObj.items = [];

				// 		itemObj.header = header;
				// 		itemObj.baseTransactionNumber = item.baseTransactionNumber;
				// 		itemObj.baseTransactionId = item.transactionId;
				// 		//purchase orders inside purchase invoice and purchase challans
				// 		if(header=='Order'){

				// 			itemObj.items = self.Form.items.filter(itemData=>{
				// 				return item.baseTransactionNumber == itemData.baseTransactionNumber && itemData.baseTransactionListId == transactionTypes.purchaseOrder.id;
				// 			});
							
				// 			groups.order.push(itemObj);

				// 		}
				// 		//purchase challans inside purchase invoice
				// 		else if(header=='Purchase Challan'){

				// 			itemObj.items = self.Form.items.filter(itemData=>{
				// 				return item.baseTransactionNumber == itemData.baseTransactionNumber && itemData.baseTransactionListId == transactionTypes.purchaseChallan.id;
				// 			});
							
				// 			groups.challan.push(itemObj);

				// 		}
				// 		//purchase invoice inside purchase return
				// 		else if(header=='Purchase Invoice'){

				// 			itemObj.items = self.Form.items.filter(itemData=>{
				// 				return item.baseTransactionNumber == itemData.baseTransactionNumber && itemData.baseTransactionListId == transactionTypes.purchaseInvoice.id;
				// 			});
							
				// 			groups.invoice.push(itemObj);

				// 		}
				// 	});

				// }

				for(let key in groups){

					groups[key].sort(function(a, b){
					  	return a.baseTransactionNumber - b.baseTransactionNumber;
					});

				}
				

				console.log(JSON.stringify(groups));

				return groups;

	    	},

	    	// minTransactionDate: function(){
	    	// 	if(!this.Form.isNew){
	    	// 		let defaultMinDate = new Date(this.$root.minDateSelection);
	    	// 		let month = ("0" + (defaultMinDate.getMonth() + 1)).slice(-2);
	    	// 		// let date = defaultMinDate.getDate();
	    	// 		let date = ("0" + defaultMinDate.getDate()).slice(-2);
	    	// 		return this.fn_getFiscalYear(this.Form.transactionData.transactionDate) + "-" + month + "-" + date;
	    	// 	}
	    	// 	else{
	    	// 		return null;
	    	// 	}
	    	// },
	    	// maxTransactionDate: function(){
	    	// 	if(!this.Form.isNew){
	    	// 		return (this.fn_getFiscalYear(this.Form.transactionData.transactionDate)+1) + "-03-31";
	    	// 	}
	    	// 	else{
	    	// 		return null;
	    	// 	}
	    	// },
	    	otherChargeItems: function(){
	    		let items = [];
	    		items = this.Form.transactionAddOns.filter(item=>{
	    			return item.addOnsType == 3;
	    		});
	    		return items;
	    	},
	    	discountItems: function(){
	    		let items = [];
	    		items = this.Form.transactionAddOns.filter(item=>{
	    			return item.addOnsType == 1;
	    		});
	    		return items;
	    	},
	    	taxItems: function(){
	    		let items = [];
	    		items = this.Form.transactionAddOns.filter(item=>{
	    			return item.addOnsType == 2;
	    		});
	    		return items;
	    	},
	    	splitPayentTotal: function(){
	    		let splitPaymentTotal = 0;
	    		if(this.Form.splitPayment){
	    			for(let i=0; i<this.Form.paymentOptions.length; i++){
	    				splitPaymentTotal += this.Form.paymentOptions[i].amount;
	    			}
	    			return this.roundUpto2Decimals(splitPaymentTotal);
	    		}
	    		else{
	    			return this.roundedAmount;
	    		}
	    	},
	    	totalQty: function(){
	    		let totalQty = 0;
	    		if(this.Form.itemsSummary && this.Form.itemsSummary.itemsQuanity && this.Form.itemsSummary.itemsQuanity.length){
	    			for(let i=0; i<this.Form.itemsSummary.itemsQuanity.length; i++){
		    			totalQty += this.Form.itemsSummary.itemsQuanity[i].qty;
		    		}	
	    		}
	    		return totalQty;
	    	}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/purchase/form.vue